const CITYDATA = [
  {
    value: "110000",
    label: "北京市",
    sort: 0,
    children: [
      {
        value: "110000",
        label: "北京市",
        sort: 0,
        children: [
          {
            value: "111000",
            label: "东城区",
            sort: 0,
          },
          {
            value: "111000",
            label: "朝阳区",
            sort: 1,
          },
          {
            value: "111000",
            label: "西城区",
            sort: 2,
          },
          {
            value: "111000",
            label: "石景山区",
            sort: 3,
          },
          {
            value: "111000",
            label: "海淀区",
            sort: 4,
          },
          {
            value: "111000",
            label: "崇文区",
            sort: 5,
          },
          {
            value: "111000",
            label: "宣武区",
            sort: 6,
          },
          {
            value: "111000",
            label: "丰台区",
            sort: 7,
          },
          {
            value: "111000",
            label: "通州区",
            sort: 8,
          },
          {
            value: "111000",
            label: "平谷区",
            sort: 9,
          },
          {
            value: "111000",
            label: "顺义区",
            sort: 10,
          },
          {
            value: "111000",
            label: "怀柔区",
            sort: 11,
          },
          {
            value: "111000",
            label: "密云县",
            sort: 12,
          },
          {
            value: "111000",
            label: "延庆县",
            sort: 13,
          },
          {
            value: "111000",
            label: "昌平区",
            sort: 14,
          },
          {
            value: "111000",
            label: "门头沟区",
            sort: 15,
          },
          {
            value: "111000",
            label: "房山区",
            sort: 16,
          },
          {
            value: "111000",
            label: "大兴区",
            sort: 17,
          },
        ],
      },
    ],
  },
  {
    value: "120000",
    label: "天津市",
    sort: 1,
    children: [
      {
        value: "120000",
        label: "天津市",
        sort: 0,
        children: [
          {
            value: "123000",
            label: "河北区",
            sort: 0,
          },
          {
            value: "123000",
            label: "河东区",
            sort: 1,
          },
          {
            value: "123000",
            label: "南开区",
            sort: 2,
          },
          {
            value: "123000",
            label: "和平区",
            sort: 3,
          },
          {
            value: "123000",
            label: "河西区",
            sort: 4,
          },
          {
            value: "123000",
            label: "红桥区",
            sort: 5,
          },
          {
            value: "123000",
            label: "北辰区",
            sort: 6,
          },
          {
            value: "123000",
            label: "东丽区",
            sort: 7,
          },
          {
            value: "123000",
            label: "大港区",
            sort: 8,
          },
          {
            value: "123000",
            label: "津南区",
            sort: 9,
          },
          {
            value: "123000",
            label: "西青区",
            sort: 10,
          },
          {
            value: "123000",
            label: "塘沽区",
            sort: 11,
          },
          {
            value: "123000",
            label: "汉沽区",
            sort: 12,
          },
          {
            value: "123000",
            label: "宁河县",
            sort: 13,
          },
          {
            value: "123000",
            label: "静海县",
            sort: 14,
          },
          {
            value: "123000",
            label: "武清区",
            sort: 15,
          },
          {
            value: "123000",
            label: "宝坻区",
            sort: 16,
          },
          {
            value: "123000",
            label: "蓟县",
            sort: 17,
          },
        ],
      },
    ],
  },
  {
    value: "130000",
    label: "河北省",
    sort: 2,
    children: [
      {
        value: "130500",
        label: "石家庄市",
        sort: 0,
        children: [
          {
            value: "130500",
            label: "桥西区",
            sort: 0,
          },
          {
            value: "130500",
            label: "新华区",
            sort: 1,
          },
          {
            value: "130500",
            label: "桥东区",
            sort: 2,
          },
          {
            value: "130500",
            label: "长安区",
            sort: 3,
          },
          {
            value: "130500",
            label: "裕华区",
            sort: 4,
          },
          {
            value: "130500",
            label: "鹿泉市",
            sort: 5,
          },
          {
            value: "130500",
            label: "井陉县",
            sort: 6,
          },
          {
            value: "130500",
            label: "平山县",
            sort: 7,
          },
          {
            value: "130500",
            label: "行唐县",
            sort: 8,
          },
          {
            value: "130500",
            label: "新乐市",
            sort: 9,
          },
          {
            value: "130500",
            label: "正定县",
            sort: 10,
          },
        ],
      },
      {
        value: "130530",
        label: "衡水市",
        sort: 1,
        children: [
          {
            value: "130530",
            label: "桃城区",
            sort: 0,
          },
          {
            value: "130530",
            label: "枣强县",
            sort: 1,
          },
          {
            value: "130530",
            label: "冀州市",
            sort: 2,
          },
          {
            value: "130530",
            label: "武强县",
            sort: 3,
          },
          {
            value: "130530",
            label: "武邑县",
            sort: 4,
          },
          {
            value: "130530",
            label: "景县",
            sort: 5,
          },
          {
            value: "130530",
            label: "安平县",
            sort: 6,
          },
          {
            value: "130530",
            label: "阜城县",
            sort: 7,
          },
          {
            value: "130530",
            label: "深州市",
            sort: 8,
          },
          {
            value: "130530",
            label: "饶阳县",
            sort: 9,
          },
        ],
      },
      {
        value: "130540",
        label: "邢台市",
        sort: 2,
        children: [
          {
            value: "130540",
            label: "桥西区",
            sort: 0,
          },
          {
            value: "130540",
            label: "桥东区",
            sort: 1,
          },
          {
            value: "130540",
            label: "邢台县",
            sort: 2,
          },
          {
            value: "130540",
            label: "沙河市",
            sort: 3,
          },
          {
            value: "130540",
            label: "内丘县",
            sort: 4,
          },
          {
            value: "130540",
            label: "临城县",
            sort: 5,
          },
          {
            value: "130540",
            label: "南和县",
            sort: 6,
          },
          {
            value: "130540",
            label: "平乡县",
            sort: 7,
          },
          {
            value: "130540",
            label: "广宗县",
            sort: 8,
          },
          {
            value: "130540",
            label: "威县",
            sort: 9,
          },
          {
            value: "130540",
            label: "清河县",
            sort: 10,
          },
          {
            value: "130540",
            label: "临西县",
            sort: 11,
          },
        ],
      },
      {
        value: "130560",
        label: "邯郸市",
        sort: 3,
        children: [
          {
            value: "130560",
            label: "邯山区",
            sort: 0,
          },
          {
            value: "130560",
            label: "丛台区",
            sort: 1,
          },
          {
            value: "130560",
            label: "复兴区",
            sort: 2,
          },
          {
            value: "130560",
            label: "邯郸县",
            sort: 3,
          },
          {
            value: "130560",
            label: "峰峰矿区",
            sort: 4,
          },
          {
            value: "130560",
            label: "武安市",
            sort: 5,
          },
          {
            value: "130560",
            label: "涉县",
            sort: 6,
          },
          {
            value: "130560",
            label: "磁县",
            sort: 7,
          },
          {
            value: "130560",
            label: "临漳县",
            sort: 8,
          },
          {
            value: "130560",
            label: "成安县",
            sort: 9,
          },
          {
            value: "130560",
            label: "魏县",
            sort: 10,
          },
          {
            value: "130560",
            label: "大名县",
            sort: 11,
          },
        ],
      },
      {
        value: "130610",
        label: "沧州市",
        sort: 4,
        children: [
          {
            value: "130610",
            label: "新华区",
            sort: 0,
          },
          {
            value: "130610",
            label: "运河区",
            sort: 1,
          },
          {
            value: "130610",
            label: "沧县",
            sort: 2,
          },
          {
            value: "130610",
            label: "黄骅市",
            sort: 3,
          },
          {
            value: "130610",
            label: "海兴县",
            sort: 4,
          },
          {
            value: "130610",
            label: "盐山县",
            sort: 5,
          },
          {
            value: "130610",
            label: "孟村回族自治县",
            sort: 6,
          },
          {
            value: "130610",
            label: "南皮县",
            sort: 7,
          },
          {
            value: "130610",
            label: "东光县",
            sort: 8,
          },
          {
            value: "130610",
            label: "吴桥县",
            sort: 9,
          },
        ],
      },
      {
        value: "130630",
        label: "唐山市",
        sort: 5,
        children: [
          {
            value: "130630",
            label: "路南区",
            sort: 0,
          },
          {
            value: "130630",
            label: "路北区",
            sort: 1,
          },
          {
            value: "130630",
            label: "开平区",
            sort: 2,
          },
          {
            value: "130630",
            label: "古冶区",
            sort: 3,
          },
          {
            value: "130630",
            label: "唐海县",
            sort: 4,
          },
          {
            value: "130630",
            label: "丰南区",
            sort: 5,
          },
          {
            value: "130630",
            label: "滦南县",
            sort: 6,
          },
          {
            value: "130630",
            label: "乐亭县",
            sort: 7,
          },
          {
            value: "130630",
            label: "滦县",
            sort: 8,
          },
        ],
      },
      {
        value: "130650",
        label: "廊坊市",
        sort: 6,
        children: [
          {
            value: "130650",
            label: "广阳区",
            sort: 0,
          },
          {
            value: "130650",
            label: "安次区",
            sort: 1,
          },
          {
            value: "130650",
            label: "三河市",
            sort: 2,
          },
          {
            value: "130650",
            label: "大厂回族自治县",
            sort: 3,
          },
          {
            value: "130650",
            label: "香河县",
            sort: 4,
          },
          {
            value: "130650",
            label: "固安县",
            sort: 5,
          },
          {
            value: "130650",
            label: "永清县",
            sort: 6,
          },
          {
            value: "130650",
            label: "霸州市",
            sort: 7,
          },
          {
            value: "130650",
            label: "文安县",
            sort: 8,
          },
          {
            value: "130650",
            label: "大城县",
            sort: 9,
          },
        ],
      },
      {
        value: "130660",
        label: "秦皇岛市",
        sort: 7,
        children: [
          {
            value: "130660",
            label: "海港区",
            sort: 0,
          },
          {
            value: "130660",
            label: "北戴河区",
            sort: 1,
          },
          {
            value: "130660",
            label: "山海关区",
            sort: 2,
          },
          {
            value: "130660",
            label: "抚宁县",
            sort: 3,
          },
          {
            value: "130660",
            label: "卢龙县",
            sort: 4,
          },
          {
            value: "130660",
            label: "青龙满族自治县",
            sort: 5,
          },
          {
            value: "130660",
            label: "昌黎县",
            sort: 6,
          },
        ],
      },
      {
        value: "130670",
        label: "承德市",
        sort: 8,
        children: [
          {
            value: "130670",
            label: "双桥区",
            sort: 0,
          },
          {
            value: "130670",
            label: "双滦区",
            sort: 1,
          },
          {
            value: "130670",
            label: "滦平县",
            sort: 2,
          },
          {
            value: "130670",
            label: "兴隆县",
            sort: 3,
          },
          {
            value: "130670",
            label: "鹰手营子矿区",
            sort: 4,
          },
          {
            value: "130670",
            label: "承德县",
            sort: 5,
          },
          {
            value: "130670",
            label: "平泉县",
            sort: 6,
          },
          {
            value: "130670",
            label: "宽城满族自治县",
            sort: 7,
          },
        ],
      },
      {
        value: "130710",
        label: "保定市",
        sort: 9,
        children: [
          {
            value: "130710",
            label: "南市区",
            sort: 0,
          },
          {
            value: "130710",
            label: "新市区",
            sort: 1,
          },
          {
            value: "130710",
            label: "清苑县",
            sort: 2,
          },
          {
            value: "130710",
            label: "安国市",
            sort: 3,
          },
          {
            value: "130710",
            label: "博野县",
            sort: 4,
          },
          {
            value: "130710",
            label: "蠡县",
            sort: 5,
          },
          {
            value: "130710",
            label: "高阳县",
            sort: 6,
          },
          {
            value: "130710",
            label: "安新县",
            sort: 7,
          },
          {
            value: "130710",
            label: "容城县",
            sort: 8,
          },
          {
            value: "130710",
            label: "雄县",
            sort: 9,
          },
        ],
      },
      {
        value: "130750",
        label: "张家口市",
        sort: 10,
        children: [
          {
            value: "130750",
            label: "桥西区",
            sort: 0,
          },
          {
            value: "130750",
            label: "桥东区",
            sort: 1,
          },
          {
            value: "130750",
            label: "宣化区",
            sort: 2,
          },
          {
            value: "130750",
            label: "宣化县",
            sort: 3,
          },
          {
            value: "130750",
            label: "怀来县",
            sort: 4,
          },
          {
            value: "130750",
            label: "赤城县",
            sort: 5,
          },
          {
            value: "130750",
            label: "涿鹿县",
            sort: 6,
          },
          {
            value: "130750",
            label: "蔚县",
            sort: 7,
          },
          {
            value: "130750",
            label: "阳原县",
            sort: 8,
          },
        ],
      },
    ],
  },
  {
    value: "140000",
    label: "山西省",
    sort: 3,
    children: [
      {
        value: "140300",
        label: "太原市",
        sort: 0,
        children: [
          {
            value: "140300",
            label: "迎泽区",
            sort: 0,
          },
          {
            value: "140300",
            label: "杏花岭区",
            sort: 1,
          },
          {
            value: "140300",
            label: "小店区",
            sort: 2,
          },
          {
            value: "140300",
            label: "尖草坪区",
            sort: 3,
          },
          {
            value: "140300",
            label: "晋源区",
            sort: 4,
          },
          {
            value: "140300",
            label: "万柏林区",
            sort: 5,
          },
          {
            value: "140300",
            label: "阳曲县",
            sort: 6,
          },
          {
            value: "140300",
            label: "古交市",
            sort: 7,
          },
          {
            value: "140300",
            label: "娄烦县",
            sort: 8,
          },
          {
            value: "140300",
            label: "清徐县",
            sort: 9,
          },
          {
            value: "140330",
            label: "交城县",
            sort: 10,
          },
          {
            value: "140306",
            label: "榆次区",
            sort: 11,
          },
          {
            value: "140306",
            label: "太谷县",
            sort: 12,
          },
          {
            value: "140306",
            label: "昔阳县",
            sort: 13,
          },
          {
            value: "140306",
            label: "祁县",
            sort: 14,
          },
        ],
      },
      {
        value: "140306",
        label: "晋中市",
        sort: 1,
        children: [
          {
            value: "140300",
            label: "迎泽区",
            sort: 0,
          },
          {
            value: "140300",
            label: "杏花岭区",
            sort: 1,
          },
          {
            value: "140300",
            label: "小店区",
            sort: 2,
          },
          {
            value: "140300",
            label: "尖草坪区",
            sort: 3,
          },
          {
            value: "140300",
            label: "晋源区",
            sort: 4,
          },
          {
            value: "140300",
            label: "万柏林区",
            sort: 5,
          },
          {
            value: "140300",
            label: "阳曲县",
            sort: 6,
          },
          {
            value: "140300",
            label: "古交市",
            sort: 7,
          },
          {
            value: "140300",
            label: "娄烦县",
            sort: 8,
          },
          {
            value: "140300",
            label: "清徐县",
            sort: 9,
          },
          {
            value: "140330",
            label: "交城县",
            sort: 10,
          },
          {
            value: "140306",
            label: "榆次区",
            sort: 11,
          },
          {
            value: "140306",
            label: "太谷县",
            sort: 12,
          },
          {
            value: "140306",
            label: "昔阳县",
            sort: 13,
          },
          {
            value: "140306",
            label: "祁县",
            sort: 14,
          },
        ],
      },
      {
        value: "140330",
        label: "吕梁市",
        sort: 2,
        children: [
          {
            value: "140330",
            label: "离石区",
            sort: 0,
          },
          {
            value: "140330",
            label: "方山县",
            sort: 1,
          },
          {
            value: "140330",
            label: "临县",
            sort: 2,
          },
          {
            value: "140330",
            label: "柳林县",
            sort: 3,
          },
          {
            value: "140330",
            label: "中阳县",
            sort: 4,
          },
          {
            value: "140330",
            label: "岚县",
            sort: 5,
          },
          {
            value: "140330",
            label: "兴县",
            sort: 6,
          },
        ],
      },
      {
        value: "140340",
        label: "忻州市",
        sort: 3,
        children: [
          {
            value: "140340",
            label: "忻府区",
            sort: 0,
          },
          {
            value: "140340",
            label: "原平市",
            sort: 1,
          },
          {
            value: "140340",
            label: "代县",
            sort: 2,
          },
          {
            value: "140340",
            label: "繁峙县",
            sort: 3,
          },
          {
            value: "140370",
            label: "灵丘县",
            sort: 4,
          },
        ],
      },
      {
        value: "140360",
        label: "朔州市",
        sort: 4,
        children: [
          {
            value: "140360",
            label: "朔城区",
            sort: 0,
          },
          {
            value: "140340",
            label: "神池县",
            sort: 1,
          },
          {
            value: "140340",
            label: "五寨县",
            sort: 2,
          },
          {
            value: "140340",
            label: "岢岚县",
            sort: 3,
          },
          {
            value: "140340",
            label: "偏关县",
            sort: 4,
          },
          {
            value: "140340",
            label: "河曲县",
            sort: 5,
          },
          {
            value: "140340",
            label: "保德县",
            sort: 6,
          },
          {
            value: "140340",
            label: "宁武县",
            sort: 7,
          },
          {
            value: "140360",
            label: "平鲁区",
            sort: 8,
          },
          {
            value: "140360",
            label: "山阴县",
            sort: 9,
          },
        ],
      },
      {
        value: "140370",
        label: "大同市",
        sort: 5,
        children: [
          {
            value: "140370",
            label: "南郊区",
            sort: 0,
          },
          {
            value: "140370",
            label: "新荣区",
            sort: 1,
          },
          {
            value: "140370",
            label: "矿区",
            sort: 2,
          },
          {
            value: "140370",
            label: "城区",
            sort: 3,
          },
          {
            value: "140370",
            label: "左云县",
            sort: 4,
          },
          {
            value: "140360",
            label: "右玉县",
            sort: 5,
          },
          {
            value: "140370",
            label: "大同县",
            sort: 6,
          },
          {
            value: "140370",
            label: "浑源县",
            sort: 7,
          },
          {
            value: "140370",
            label: "广灵县",
            sort: 8,
          },
          {
            value: "140360",
            label: "应县",
            sort: 9,
          },
        ],
      },
      {
        value: "140410",
        label: "临汾市",
        sort: 6,
        children: [
          {
            value: "140410",
            label: "尧都区",
            sort: 0,
          },
          {
            value: "140410",
            label: "蒲县",
            sort: 1,
          },
          {
            value: "140410",
            label: "隰县",
            sort: 2,
          },
          {
            value: "140410",
            label: "永和县",
            sort: 3,
          },
          {
            value: "140410",
            label: "襄汾县",
            sort: 4,
          },
          {
            value: "140410",
            label: "洪洞县",
            sort: 5,
          },
        ],
      },
      {
        value: "140440",
        label: "运城市",
        sort: 7,
        children: [
          {
            value: "140440",
            label: "盐湖区",
            sort: 0,
          },
          {
            value: "140440",
            label: "临猗县",
            sort: 1,
          },
          {
            value: "140440",
            label: "万荣县",
            sort: 2,
          },
          {
            value: "140440",
            label: "平陆县",
            sort: 3,
          },
          {
            value: "140440",
            label: "夏县",
            sort: 4,
          },
          {
            value: "140440",
            label: "永济市",
            sort: 5,
          },
          {
            value: "140440",
            label: "芮城县",
            sort: 6,
          },
        ],
      },
      {
        value: "140450",
        label: "阳泉市",
        sort: 8,
        children: [
          {
            value: "140450",
            label: "城区",
            sort: 0,
          },
          {
            value: "140450",
            label: "郊区",
            sort: 1,
          },
          {
            value: "140450",
            label: "盂县",
            sort: 2,
          },
          {
            value: "140450",
            label: "平定县",
            sort: 3,
          },
          {
            value: "140306",
            label: "寿阳县",
            sort: 4,
          },
        ],
      },
      {
        value: "140460",
        label: "长治市",
        sort: 9,
        children: [
          {
            value: "140460",
            label: "城区",
            sort: 0,
          },
          {
            value: "140460",
            label: "屯留县",
            sort: 1,
          },
          {
            value: "140460",
            label: "襄垣县",
            sort: 2,
          },
          {
            value: "140460",
            label: "武乡县",
            sort: 3,
          },
          {
            value: "140460",
            label: "沁县",
            sort: 4,
          },
          {
            value: "140460",
            label: "沁源县",
            sort: 5,
          },
          {
            value: "140460",
            label: "长子县",
            sort: 6,
          },
        ],
      },
      {
        value: "140480",
        label: "晋城市",
        sort: 10,
        children: [
          {
            value: "140480",
            label: "泽州县",
            sort: 0,
          },
          {
            value: "140480",
            label: "城区",
            sort: 1,
          },
          {
            value: "140480",
            label: "阳城县",
            sort: 2,
          },
          {
            value: "140480",
            label: "沁水县",
            sort: 3,
          },
          {
            value: "140480",
            label: "陵川县",
            sort: 4,
          },
          {
            value: "140480",
            label: "高平市",
            sort: 5,
          },
        ],
      },
    ],
  },
  {
    value: "150000",
    label: "内蒙古自治区",
    sort: 4,
    children: [
      {
        value: "150100",
        label: "呼和浩特市",
        sort: 0,
        children: [
          {
            value: "150100",
            label: "赛罕区",
            sort: 0,
          },
          {
            value: "150100",
            label: "玉泉区",
            sort: 1,
          },
          {
            value: "150100",
            label: "回民区",
            sort: 2,
          },
          {
            value: "150100",
            label: "新城区",
            sort: 3,
          },
          {
            value: "150100",
            label: "土默特左旗",
            sort: 4,
          },
          {
            value: "150100",
            label: "托克托县",
            sort: 5,
          },
          {
            value: "150170",
            label: "准格尔旗",
            sort: 6,
          },
        ],
      },
      {
        value: "150120",
        label: "乌兰察布市",
        sort: 1,
        children: [
          {
            value: "150120",
            label: "集宁区",
            sort: 0,
          },
          {
            value: "150120",
            label: "丰镇市",
            sort: 1,
          },
          {
            value: "150120",
            label: "察哈尔右翼前旗",
            sort: 2,
          },
          {
            value: "150120",
            label: "卓资县",
            sort: 3,
          },
          {
            value: "150120",
            label: "察哈尔右翼后旗",
            sort: 4,
          },
        ],
      },
      {
        value: "150140",
        label: "包头市",
        sort: 2,
        children: [
          {
            value: "150140",
            label: "昆都仑区",
            sort: 0,
          },
          {
            value: "150140",
            label: "青山区",
            sort: 1,
          },
          {
            value: "150140",
            label: "白云矿区",
            sort: 2,
          },
          {
            value: "150140",
            label: "东河区",
            sort: 3,
          },
          {
            value: "150140",
            label: "九原区",
            sort: 4,
          },
          {
            value: "150140",
            label: "石拐区",
            sort: 5,
          },
          {
            value: "150140",
            label: "土默特右旗",
            sort: 6,
          },
          {
            value: "150140",
            label: "固阳县",
            sort: 7,
          },
          {
            value: "150170",
            label: "达拉特旗",
            sort: 8,
          },
          {
            value: "150150",
            label: "乌拉特前旗",
            sort: 9,
          },
          {
            value: "150140",
            label: "达尔罕茂明安联合旗",
            sort: 10,
          },
        ],
      },
      {
        value: "150150",
        label: "巴彦淖尔市",
        sort: 3,
        children: [
          {
            value: "150150",
            label: "临河区",
            sort: 0,
          },
          {
            value: "150150",
            label: "五原县",
            sort: 1,
          },
          {
            value: "150150",
            label: "磴口县",
            sort: 2,
          },
          {
            value: "150150",
            label: "乌拉特中旗",
            sort: 3,
          },
          {
            value: "150150",
            label: "杭锦后旗",
            sort: 4,
          },
          {
            value: "150150",
            label: "乌拉特后旗",
            sort: 5,
          },
        ],
      },
      {
        value: "150160",
        label: "乌海市",
        sort: 4,
        children: [
          {
            value: "150160",
            label: "海勃湾区",
            sort: 0,
          },
          {
            value: "150160",
            label: "海南区",
            sort: 1,
          },
          {
            value: "150160",
            label: "乌达区",
            sort: 2,
          },
          {
            value: "150170",
            label: "鄂托克旗",
            sort: 3,
          },
        ],
      },
      {
        value: "150170",
        label: "鄂尔多斯市",
        sort: 5,
        children: [
          {
            value: "150170",
            label: "东胜区",
            sort: 0,
          },
          {
            value: "150170",
            label: "伊金霍洛旗",
            sort: 1,
          },
          {
            value: "150170",
            label: "乌审旗",
            sort: 2,
          },
          {
            value: "150170",
            label: "杭锦旗",
            sort: 3,
          },
        ],
      },
      {
        value: "150210",
        label: "呼伦贝尔市",
        sort: 6,
        children: [
          {
            value: "150210",
            label: "海拉尔区",
            sort: 0,
          },
          {
            value: "150210",
            label: "新巴尔虎左旗",
            sort: 1,
          },
          {
            value: "150210",
            label: "陈巴尔虎旗",
            sort: 2,
          },
          {
            value: "150210",
            label: "鄂温克族自治旗",
            sort: 3,
          },
          {
            value: "150210",
            label: "新巴尔虎右旗",
            sort: 4,
          },
          {
            value: "150210",
            label: "满洲里市",
            sort: 5,
          },
        ],
      },
      {
        value: "150240",
        label: "赤峰市",
        sort: 7,
        children: [
          {
            value: "150240",
            label: "红山区",
            sort: 0,
          },
          {
            value: "150240",
            label: "松山区",
            sort: 1,
          },
          {
            value: "150240",
            label: "元宝山区",
            sort: 2,
          },
          {
            value: "150240",
            label: "宁城县",
            sort: 3,
          },
          {
            value: "150240",
            label: "敖汉旗",
            sort: 4,
          },
          {
            value: "150240",
            label: "喀喇沁旗",
            sort: 5,
          },
          {
            value: "150240",
            label: "翁牛特旗",
            sort: 6,
          },
        ],
      },
      {
        value: "150260",
        label: "锡林郭勒盟",
        sort: 8,
        children: [
          {
            value: "150260",
            label: "锡林浩特市",
            sort: 0,
          },
          {
            value: "150260",
            label: "西乌珠穆沁旗",
            sort: 1,
          },
          {
            value: "150260",
            label: "东乌珠穆沁旗",
            sort: 2,
          },
        ],
      },
      {
        value: "150280",
        label: "通辽市",
        sort: 9,
        children: [
          {
            value: "150280",
            label: "科尔沁区",
            sort: 0,
          },
          {
            value: "150280",
            label: "库伦旗",
            sort: 1,
          },
          {
            value: "150280",
            label: "奈曼旗",
            sort: 2,
          },
          {
            value: "150280",
            label: "开鲁县",
            sort: 3,
          },
        ],
      },
      {
        value: "151374",
        label: "兴安盟",
        sort: 10,
        children: [
          {
            value: "151374",
            label: "乌兰浩特市",
            sort: 0,
          },
          {
            value: "151374",
            label: "扎赉特旗",
            sort: 1,
          },
          {
            value: "151374",
            label: "科尔沁右翼前旗",
            sort: 2,
          },
          {
            value: "151374",
            label: "阿尔山市",
            sort: 3,
          },
        ],
      },
      {
        value: "157503",
        label: "阿拉善盟",
        sort: 11,
        children: [
          {
            value: "157503",
            label: "阿拉善左旗",
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    value: "210000",
    label: "辽宁省",
    sort: 5,
    children: [
      {
        value: "211100",
        label: "沈阳市",
        sort: 0,
        children: [
          {
            value: "211100",
            label: "和平区",
            sort: 0,
          },
          {
            value: "211100",
            label: "沈河区",
            sort: 1,
          },
          {
            value: "211100",
            label: "东陵区",
            sort: 2,
          },
          {
            value: "211100",
            label: "铁西区",
            sort: 3,
          },
          {
            value: "211100",
            label: "皇姑区",
            sort: 4,
          },
          {
            value: "211100",
            label: "大东区",
            sort: 5,
          },
          {
            value: "211100",
            label: "苏家屯区",
            sort: 6,
          },
          {
            value: "211100",
            label: "新城子区",
            sort: 7,
          },
          {
            value: "211100",
            label: "于洪区",
            sort: 8,
          },
          {
            value: "211100",
            label: "辽中县",
            sort: 9,
          },
          {
            value: "211100",
            label: "新民市",
            sort: 10,
          },
          {
            value: "211100",
            label: "法库县",
            sort: 11,
          },
          {
            value: "211100",
            label: "康平县",
            sort: 12,
          },
        ],
      },
      {
        value: "211110",
        label: "辽阳市",
        sort: 1,
        children: [
          {
            value: "211110",
            label: "文圣区",
            sort: 0,
          },
          {
            value: "211110",
            label: "太子河区",
            sort: 1,
          },
          {
            value: "211110",
            label: "宏伟区",
            sort: 2,
          },
          {
            value: "211110",
            label: "弓长岭区",
            sort: 3,
          },
          {
            value: "211110",
            label: "辽阳县",
            sort: 4,
          },
          {
            value: "211110",
            label: "灯塔市",
            sort: 5,
          },
        ],
      },
      {
        value: "211120",
        label: "铁岭市",
        sort: 2,
        children: [
          {
            value: "211120",
            label: "银州区",
            sort: 0,
          },
          {
            value: "211120",
            label: "清河区",
            sort: 1,
          },
          {
            value: "211120",
            label: "开原市",
            sort: 2,
          },
          {
            value: "211120",
            label: "西丰县",
            sort: 3,
          },
          {
            value: "211120",
            label: "昌图县",
            sort: 4,
          },
          {
            value: "211120",
            label: "铁岭县",
            sort: 5,
          },
          {
            value: "211120",
            label: "调兵山市",
            sort: 6,
          },
        ],
      },
      {
        value: "211130",
        label: "抚顺市",
        sort: 3,
        children: [
          {
            value: "211130",
            label: "望花区",
            sort: 0,
          },
          {
            value: "211130",
            label: "东洲区",
            sort: 1,
          },
          {
            value: "211130",
            label: "新抚区",
            sort: 2,
          },
          {
            value: "211130",
            label: "顺城区",
            sort: 3,
          },
          {
            value: "211130",
            label: "抚顺县",
            sort: 4,
          },
          {
            value: "211130",
            label: "新宾满族自治县",
            sort: 5,
          },
          {
            value: "211130",
            label: "清原满族自治县",
            sort: 6,
          },
        ],
      },
      {
        value: "211140",
        label: "鞍山市",
        sort: 4,
        children: [
          {
            value: "211140",
            label: "铁东区",
            sort: 0,
          },
          {
            value: "211140",
            label: "铁西区",
            sort: 1,
          },
          {
            value: "211140",
            label: "立山区",
            sort: 2,
          },
          {
            value: "211140",
            label: "千山区",
            sort: 3,
          },
          {
            value: "211140",
            label: "台安县",
            sort: 4,
          },
          {
            value: "211140",
            label: "海城市",
            sort: 5,
          },
          {
            value: "211140",
            label: "岫岩满族自治县",
            sort: 6,
          },
        ],
      },
      {
        value: "211150",
        label: "营口市",
        sort: 5,
        children: [
          {
            value: "211150",
            label: "站前区",
            sort: 0,
          },
          {
            value: "211150",
            label: "西市区",
            sort: 1,
          },
          {
            value: "211150",
            label: "老边区",
            sort: 2,
          },
          {
            value: "211150",
            label: "鲅鱼圈区",
            sort: 3,
          },
          {
            value: "211150",
            label: "大石桥市",
            sort: 4,
          },
          {
            value: "211150",
            label: "盖州市",
            sort: 5,
          },
        ],
      },
      {
        value: "211160",
        label: "大连市",
        sort: 6,
        children: [
          {
            value: "211160",
            label: "中山区",
            sort: 0,
          },
          {
            value: "211160",
            label: "西岗区",
            sort: 1,
          },
          {
            value: "211160",
            label: "沙河口区",
            sort: 2,
          },
          {
            value: "211160",
            label: "甘井子区",
            sort: 3,
          },
          {
            value: "211160",
            label: "旅顺口区",
            sort: 4,
          },
          {
            value: "211160",
            label: "金州区",
            sort: 5,
          },
          {
            value: "211160",
            label: "普兰店市",
            sort: 6,
          },
          {
            value: "211160",
            label: "瓦房店市",
            sort: 7,
          },
          {
            value: "211160",
            label: "庄河市",
            sort: 8,
          },
          {
            value: "211160",
            label: "长海县",
            sort: 9,
          },
        ],
      },
      {
        value: "211170",
        label: "本溪市",
        sort: 7,
        children: [
          {
            value: "211170",
            label: "平山区",
            sort: 0,
          },
          {
            value: "211170",
            label: "明山区",
            sort: 1,
          },
          {
            value: "211170",
            label: "溪湖区",
            sort: 2,
          },
          {
            value: "211170",
            label: "南芬区",
            sort: 3,
          },
          {
            value: "211170",
            label: "本溪满族自治县",
            sort: 4,
          },
          {
            value: "211170",
            label: "桓仁满族自治县",
            sort: 5,
          },
        ],
      },
      {
        value: "211180",
        label: "丹东市",
        sort: 8,
        children: [
          {
            value: "211180",
            label: "振兴区",
            sort: 0,
          },
          {
            value: "211180",
            label: "振安区",
            sort: 1,
          },
          {
            value: "211180",
            label: "凤城市",
            sort: 2,
          },
          {
            value: "211180",
            label: "宽甸满族自治县",
            sort: 3,
          },
          {
            value: "211180",
            label: "东港市",
            sort: 4,
          },
        ],
      },
      {
        value: "211210",
        label: "锦州市",
        sort: 9,
        children: [
          {
            value: "211210",
            label: "太和区",
            sort: 0,
          },
          {
            value: "211210",
            label: "凌河区",
            sort: 1,
          },
          {
            value: "211210",
            label: "义县",
            sort: 2,
          },
          {
            value: "211210",
            label: "凌海市",
            sort: 3,
          },
          {
            value: "211210",
            label: "北宁市",
            sort: 4,
          },
          {
            value: "211210",
            label: "黑山县",
            sort: 5,
          },
        ],
      },
      {
        value: "211220",
        label: "朝阳市",
        sort: 10,
        children: [
          {
            value: "211220",
            label: "双塔区",
            sort: 0,
          },
          {
            value: "211220",
            label: "龙城区",
            sort: 1,
          },
          {
            value: "211220",
            label: "北票市",
            sort: 2,
          },
          {
            value: "211220",
            label: "喀喇沁左翼蒙古族自治县",
            sort: 3,
          },
          {
            value: "211220",
            label: "建平县",
            sort: 4,
          },
          {
            value: "211220",
            label: "凌源市",
            sort: 5,
          },
          {
            value: "211220",
            label: "朝阳县",
            sort: 6,
          },
        ],
      },
      {
        value: "211230",
        label: "阜新市",
        sort: 11,
        children: [
          {
            value: "211230",
            label: "海州区",
            sort: 0,
          },
          {
            value: "211230",
            label: "太平区",
            sort: 1,
          },
          {
            value: "211230",
            label: "新邱区",
            sort: 2,
          },
          {
            value: "211230",
            label: "清河门区",
            sort: 3,
          },
          {
            value: "211230",
            label: "阜新蒙古族自治县",
            sort: 4,
          },
          {
            value: "211230",
            label: "彰武县",
            sort: 5,
          },
        ],
      },
      {
        value: "211240",
        label: "盘锦市",
        sort: 12,
        children: [
          {
            value: "211240",
            label: "双台子区",
            sort: 0,
          },
          {
            value: "211240",
            label: "兴隆台区",
            sort: 1,
          },
          {
            value: "211240",
            label: "盘山县",
            sort: 2,
          },
          {
            value: "211240",
            label: "大洼县",
            sort: 3,
          },
        ],
      },
      {
        value: "211250",
        label: "葫芦岛市",
        sort: 13,
        children: [
          {
            value: "211250",
            label: "龙港区",
            sort: 0,
          },
          {
            value: "211250",
            label: "连山区",
            sort: 1,
          },
          {
            value: "211250",
            label: "南票区",
            sort: 2,
          },
          {
            value: "211250",
            label: "兴城市",
            sort: 3,
          },
          {
            value: "211250",
            label: "绥中县",
            sort: 4,
          },
          {
            value: "211250",
            label: "建昌县",
            sort: 5,
          },
        ],
      },
    ],
  },
  {
    value: "220000",
    label: "吉林省",
    sort: 6,
    children: [
      {
        value: "221300",
        label: "长春市",
        sort: 0,
        children: [
          {
            value: "221300",
            label: "绿园区",
            sort: 0,
          },
          {
            value: "221300",
            label: "朝阳区",
            sort: 1,
          },
          {
            value: "221300",
            label: "南关区",
            sort: 2,
          },
          {
            value: "221300",
            label: "二道区",
            sort: 3,
          },
          {
            value: "221300",
            label: "宽城区",
            sort: 4,
          },
          {
            value: "221300",
            label: "农安县",
            sort: 5,
          },
          {
            value: "221300",
            label: "德惠市",
            sort: 6,
          },
          {
            value: "221300",
            label: "榆树市",
            sort: 7,
          },
          {
            value: "221300",
            label: "九台市",
            sort: 8,
          },
          {
            value: "221300",
            label: "双阳区",
            sort: 9,
          },
          {
            value: "221360",
            label: "伊通满族自治县",
            sort: 10,
          },
        ],
      },
      {
        value: "221320",
        label: "吉林市",
        sort: 1,
        children: [
          {
            value: "221320",
            label: "昌邑区",
            sort: 0,
          },
          {
            value: "221320",
            label: "船营区",
            sort: 1,
          },
          {
            value: "221320",
            label: "丰满区",
            sort: 2,
          },
          {
            value: "221320",
            label: "龙潭区",
            sort: 3,
          },
          {
            value: "221320",
            label: "永吉县",
            sort: 4,
          },
          {
            value: "221320",
            label: "磐石市",
            sort: 5,
          },
          {
            value: "221320",
            label: "桦甸市",
            sort: 6,
          },
          {
            value: "221320",
            label: "蛟河市",
            sort: 7,
          },
          {
            value: "221320",
            label: "舒兰市",
            sort: 8,
          },
        ],
      },
      {
        value: "221330",
        label: "延边朝鲜族自治州",
        sort: 2,
        children: [
          {
            value: "221330",
            label: "延吉市",
            sort: 0,
          },
          {
            value: "221330",
            label: "图们市",
            sort: 1,
          },
          {
            value: "221330",
            label: "汪清县",
            sort: 2,
          },
          {
            value: "221330",
            label: "珲春市",
            sort: 3,
          },
          {
            value: "221330",
            label: "龙井市",
            sort: 4,
          },
          {
            value: "221330",
            label: "和龙市",
            sort: 5,
          },
          {
            value: "221330",
            label: "安图县",
            sort: 6,
          },
          {
            value: "221330",
            label: "敦化市",
            sort: 7,
          },
        ],
      },
      {
        value: "221340",
        label: "通化市",
        sort: 3,
        children: [
          {
            value: "221340",
            label: "东昌区",
            sort: 0,
          },
          {
            value: "221340",
            label: "二道江区",
            sort: 1,
          },
          {
            value: "221340",
            label: "通化县",
            sort: 2,
          },
          {
            value: "221340",
            label: "集安市",
            sort: 3,
          },
          {
            value: "221343",
            label: "八道江区",
            sort: 4,
          },
          {
            value: "221343",
            label: "长白朝鲜族自治县",
            sort: 5,
          },
          {
            value: "221343",
            label: "抚松县",
            sort: 6,
          },
          {
            value: "221343",
            label: "临江市",
            sort: 7,
          },
          {
            value: "221343",
            label: "江源县",
            sort: 8,
          },
        ],
      },
      {
        value: "221343",
        label: "白山市",
        sort: 4,
        children: [
          {
            value: "221340",
            label: "东昌区",
            sort: 0,
          },
          {
            value: "221340",
            label: "二道江区",
            sort: 1,
          },
          {
            value: "221340",
            label: "通化县",
            sort: 2,
          },
          {
            value: "221340",
            label: "集安市",
            sort: 3,
          },
          {
            value: "221343",
            label: "八道江区",
            sort: 4,
          },
          {
            value: "221343",
            label: "长白朝鲜族自治县",
            sort: 5,
          },
          {
            value: "221343",
            label: "抚松县",
            sort: 6,
          },
          {
            value: "221343",
            label: "临江市",
            sort: 7,
          },
          {
            value: "221343",
            label: "江源县",
            sort: 8,
          },
        ],
      },
      {
        value: "221360",
        label: "四平市",
        sort: 5,
        children: [
          {
            value: "221360",
            label: "铁西区",
            sort: 0,
          },
          {
            value: "221360",
            label: "铁东区",
            sort: 1,
          },
          {
            value: "221360",
            label: "公主岭市",
            sort: 2,
          },
          {
            value: "221362",
            label: "龙山区",
            sort: 3,
          },
          {
            value: "221362",
            label: "西安区",
            sort: 4,
          },
          {
            value: "221362",
            label: "东丰县",
            sort: 5,
          },
          {
            value: "221360",
            label: "双辽市",
            sort: 6,
          },
          {
            value: "221360",
            label: "梨树县",
            sort: 7,
          },
          {
            value: "221362",
            label: "东辽县",
            sort: 8,
          },
        ],
      },
      {
        value: "221362",
        label: "辽源市",
        sort: 6,
        children: [
          {
            value: "221360",
            label: "铁西区",
            sort: 0,
          },
          {
            value: "221360",
            label: "铁东区",
            sort: 1,
          },
          {
            value: "221360",
            label: "公主岭市",
            sort: 2,
          },
          {
            value: "221362",
            label: "龙山区",
            sort: 3,
          },
          {
            value: "221362",
            label: "西安区",
            sort: 4,
          },
          {
            value: "221362",
            label: "东丰县",
            sort: 5,
          },
          {
            value: "221360",
            label: "双辽市",
            sort: 6,
          },
          {
            value: "221360",
            label: "梨树县",
            sort: 7,
          },
          {
            value: "221362",
            label: "东辽县",
            sort: 8,
          },
        ],
      },
      {
        value: "221370",
        label: "白城市",
        sort: 7,
        children: [
          {
            value: "221370",
            label: "洮北区",
            sort: 0,
          },
          {
            value: "221370",
            label: "洮南市",
            sort: 1,
          },
          {
            value: "221370",
            label: "通榆县",
            sort: 2,
          },
          {
            value: "221370",
            label: "镇赉县",
            sort: 3,
          },
        ],
      },
      {
        value: "221380",
        label: "松原市",
        sort: 8,
        children: [
          {
            value: "221380",
            label: "宁江区",
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    value: "230000",
    label: "黑龙江省",
    sort: 7,
    children: [
      {
        value: "231500",
        label: "哈尔滨市",
        sort: 0,
        children: [
          {
            value: "231500",
            label: "南岗区",
            sort: 0,
          },
          {
            value: "231500",
            label: "道里区",
            sort: 1,
          },
          {
            value: "231500",
            label: "道外区",
            sort: 2,
          },
          {
            value: "231500",
            label: "呼兰区",
            sort: 3,
          },
          {
            value: "231500",
            label: "香坊区",
            sort: 4,
          },
          {
            value: "231500",
            label: "动力区",
            sort: 5,
          },
          {
            value: "231500",
            label: "平房区",
            sort: 6,
          },
          {
            value: "231500",
            label: "双城市",
            sort: 7,
          },
          {
            value: "231500",
            label: "五常市",
            sort: 8,
          },
          {
            value: "231500",
            label: "阿城市",
            sort: 9,
          },
          {
            value: "231500",
            label: "宾县",
            sort: 10,
          },
          {
            value: "231500",
            label: "尚志市",
            sort: 11,
          },
          {
            value: "231500",
            label: "延寿县",
            sort: 12,
          },
          {
            value: "231500",
            label: "方正县",
            sort: 13,
          },
          {
            value: "231500",
            label: "通河县",
            sort: 14,
          },
        ],
      },
      {
        value: "231520",
        label: "绥化市",
        sort: 1,
        children: [
          {
            value: "231520",
            label: "北林区",
            sort: 0,
          },
          {
            value: "231520",
            label: "望奎县",
            sort: 1,
          },
          {
            value: "231520",
            label: "绥棱县",
            sort: 2,
          },
          {
            value: "231520",
            label: "海伦市",
            sort: 3,
          },
          {
            value: "231530",
            label: "铁力市",
            sort: 4,
          },
        ],
      },
      {
        value: "231530",
        label: "伊春市",
        sort: 2,
        children: [
          {
            value: "231530",
            label: "伊春区",
            sort: 0,
          },
          {
            value: "231530",
            label: "乌马河区",
            sort: 1,
          },
          {
            value: "231530",
            label: "翠峦区",
            sort: 2,
          },
          {
            value: "231530",
            label: "美溪区",
            sort: 3,
          },
          {
            value: "231530",
            label: "西林区",
            sort: 4,
          },
          {
            value: "231530",
            label: "金山屯区",
            sort: 5,
          },
          {
            value: "231530",
            label: "友好区",
            sort: 6,
          },
          {
            value: "231530",
            label: "上甘岭区",
            sort: 7,
          },
          {
            value: "231530",
            label: "五营区",
            sort: 8,
          },
          {
            value: "231530",
            label: "红星区",
            sort: 9,
          },
          {
            value: "231530",
            label: "新青区",
            sort: 10,
          },
          {
            value: "231530",
            label: "汤旺河区",
            sort: 11,
          },
          {
            value: "231530",
            label: "乌伊岭区",
            sort: 12,
          },
          {
            value: "231530",
            label: "南岔区",
            sort: 13,
          },
          {
            value: "231530",
            label: "带岭区",
            sort: 14,
          },
          {
            value: "231530",
            label: "嘉荫县",
            sort: 15,
          },
        ],
      },
      {
        value: "231540",
        label: "佳木斯市",
        sort: 3,
        children: [
          {
            value: "231540",
            label: "前进区",
            sort: 0,
          },
          {
            value: "231540",
            label: "向阳区",
            sort: 1,
          },
          {
            value: "231540",
            label: "郊区",
            sort: 2,
          },
          {
            value: "231540",
            label: "东风区",
            sort: 3,
          },
          {
            value: "231541",
            label: "向阳区",
            sort: 4,
          },
          {
            value: "231541",
            label: "工农区",
            sort: 5,
          },
          {
            value: "231541",
            label: "兴安区",
            sort: 6,
          },
          {
            value: "231541",
            label: "南山区",
            sort: 7,
          },
          {
            value: "231541",
            label: "兴山区",
            sort: 8,
          },
          {
            value: "231541",
            label: "东山区",
            sort: 9,
          },
          {
            value: "231541",
            label: "萝北县",
            sort: 10,
          },
          {
            value: "231540",
            label: "桦川县",
            sort: 11,
          },
          {
            value: "231540",
            label: "桦南县",
            sort: 12,
          },
          {
            value: "231546",
            label: "勃利县",
            sort: 13,
          },
          {
            value: "231546",
            label: "桃山区",
            sort: 14,
          },
          {
            value: "231546",
            label: "新兴区",
            sort: 15,
          },
          {
            value: "231546",
            label: "茄子河区",
            sort: 16,
          },
          {
            value: "231540",
            label: "汤原县",
            sort: 17,
          },
          {
            value: "231500",
            label: "依兰县",
            sort: 18,
          },
        ],
      },
      {
        value: "231541",
        label: "鹤岗市",
        sort: 4,
        children: [
          {
            value: "231540",
            label: "前进区",
            sort: 0,
          },
          {
            value: "231540",
            label: "向阳区",
            sort: 1,
          },
          {
            value: "231540",
            label: "郊区",
            sort: 2,
          },
          {
            value: "231540",
            label: "东风区",
            sort: 3,
          },
          {
            value: "231541",
            label: "向阳区",
            sort: 4,
          },
          {
            value: "231541",
            label: "工农区",
            sort: 5,
          },
          {
            value: "231541",
            label: "兴安区",
            sort: 6,
          },
          {
            value: "231541",
            label: "南山区",
            sort: 7,
          },
          {
            value: "231541",
            label: "兴山区",
            sort: 8,
          },
          {
            value: "231541",
            label: "东山区",
            sort: 9,
          },
          {
            value: "231541",
            label: "萝北县",
            sort: 10,
          },
          {
            value: "231540",
            label: "桦川县",
            sort: 11,
          },
          {
            value: "231540",
            label: "桦南县",
            sort: 12,
          },
          {
            value: "231546",
            label: "勃利县",
            sort: 13,
          },
          {
            value: "231546",
            label: "桃山区",
            sort: 14,
          },
          {
            value: "231546",
            label: "新兴区",
            sort: 15,
          },
          {
            value: "231546",
            label: "茄子河区",
            sort: 16,
          },
          {
            value: "231540",
            label: "汤原县",
            sort: 17,
          },
          {
            value: "231500",
            label: "依兰县",
            sort: 18,
          },
        ],
      },
      {
        value: "231546",
        label: "七台河市",
        sort: 5,
        children: [
          {
            value: "231540",
            label: "前进区",
            sort: 0,
          },
          {
            value: "231540",
            label: "向阳区",
            sort: 1,
          },
          {
            value: "231540",
            label: "郊区",
            sort: 2,
          },
          {
            value: "231540",
            label: "东风区",
            sort: 3,
          },
          {
            value: "231541",
            label: "向阳区",
            sort: 4,
          },
          {
            value: "231541",
            label: "工农区",
            sort: 5,
          },
          {
            value: "231541",
            label: "兴安区",
            sort: 6,
          },
          {
            value: "231541",
            label: "南山区",
            sort: 7,
          },
          {
            value: "231541",
            label: "兴山区",
            sort: 8,
          },
          {
            value: "231541",
            label: "东山区",
            sort: 9,
          },
          {
            value: "231541",
            label: "萝北县",
            sort: 10,
          },
          {
            value: "231540",
            label: "桦川县",
            sort: 11,
          },
          {
            value: "231540",
            label: "桦南县",
            sort: 12,
          },
          {
            value: "231546",
            label: "勃利县",
            sort: 13,
          },
          {
            value: "231546",
            label: "桃山区",
            sort: 14,
          },
          {
            value: "231546",
            label: "新兴区",
            sort: 15,
          },
          {
            value: "231546",
            label: "茄子河区",
            sort: 16,
          },
          {
            value: "231540",
            label: "汤原县",
            sort: 17,
          },
          {
            value: "231500",
            label: "依兰县",
            sort: 18,
          },
        ],
      },
      {
        value: "231551",
        label: "双鸭山市",
        sort: 6,
        children: [
          {
            value: "231551",
            label: "尖山区",
            sort: 0,
          },
          {
            value: "231551",
            label: "四方台区",
            sort: 1,
          },
          {
            value: "231551",
            label: "岭东区",
            sort: 2,
          },
          {
            value: "231551",
            label: "宝山区",
            sort: 3,
          },
          {
            value: "231551",
            label: "宝清县",
            sort: 4,
          },
          {
            value: "231551",
            label: "饶河县",
            sort: 5,
          },
          {
            value: "231551",
            label: "友谊县",
            sort: 6,
          },
          {
            value: "231551",
            label: "集贤县",
            sort: 7,
          },
        ],
      },
      {
        value: "231570",
        label: "牡丹江市",
        sort: 7,
        children: [
          {
            value: "231570",
            label: "西安区",
            sort: 0,
          },
          {
            value: "231570",
            label: "阳明区",
            sort: 1,
          },
          {
            value: "231570",
            label: "爱民区",
            sort: 2,
          },
          {
            value: "231570",
            label: "东安区",
            sort: 3,
          },
          {
            value: "231570",
            label: "海林市",
            sort: 4,
          },
          {
            value: "231570",
            label: "东宁县",
            sort: 5,
          },
          {
            value: "231570",
            label: "绥芬河市",
            sort: 6,
          },
          {
            value: "231570",
            label: "宁安市",
            sort: 7,
          },
          {
            value: "231570",
            label: "穆棱市",
            sort: 8,
          },
          {
            value: "231570",
            label: "林口县",
            sort: 9,
          },
        ],
      },
      {
        value: "231581",
        label: "鸡西市",
        sort: 8,
        children: [
          {
            value: "231581",
            label: "鸡冠区",
            sort: 0,
          },
          {
            value: "231581",
            label: "恒山区",
            sort: 1,
          },
          {
            value: "231581",
            label: "滴道区",
            sort: 2,
          },
          {
            value: "231581",
            label: "梨树区",
            sort: 3,
          },
          {
            value: "231581",
            label: "城子河区",
            sort: 4,
          },
          {
            value: "231581",
            label: "麻山区",
            sort: 5,
          },
          {
            value: "231581",
            label: "鸡东县",
            sort: 6,
          },
          {
            value: "231581",
            label: "密山市",
            sort: 7,
          },
          {
            value: "231581",
            label: "虎林市",
            sort: 8,
          },
        ],
      },
      {
        value: "231610",
        label: "齐齐哈尔市",
        sort: 9,
        children: [
          {
            value: "231610",
            label: "铁锋区",
            sort: 0,
          },
          {
            value: "231610",
            label: "龙沙区",
            sort: 1,
          },
          {
            value: "231610",
            label: "建华区",
            sort: 2,
          },
          {
            value: "231610",
            label: "梅里斯达斡尔族区",
            sort: 3,
          },
          {
            value: "231610",
            label: "昂昂溪区",
            sort: 4,
          },
          {
            value: "231610",
            label: "富拉尔基区",
            sort: 5,
          },
          {
            value: "231610",
            label: "碾子山区",
            sort: 6,
          },
          {
            value: "231610",
            label: "龙江县",
            sort: 7,
          },
          {
            value: "231610",
            label: "富裕县",
            sort: 8,
          },
          {
            value: "231610",
            label: "讷河市",
            sort: 9,
          },
          {
            value: "231643",
            label: "嫩江县",
            sort: 10,
          },
          {
            value: "231610",
            label: "依安县",
            sort: 11,
          },
          {
            value: "231610",
            label: "克山县",
            sort: 12,
          },
        ],
      },
      {
        value: "231630",
        label: "大庆市",
        sort: 10,
        children: [
          {
            value: "231630",
            label: "萨尔图区",
            sort: 0,
          },
          {
            value: "231630",
            label: "让胡路区",
            sort: 1,
          },
          {
            value: "231630",
            label: "龙凤区",
            sort: 2,
          },
          {
            value: "231630",
            label: "红岗区",
            sort: 3,
          },
          {
            value: "231630",
            label: "大同区",
            sort: 4,
          },
        ],
      },
      {
        value: "231643",
        label: "黑河市",
        sort: 11,
        children: [
          {
            value: "231643",
            label: "北安市",
            sort: 0,
          },
          {
            value: "231643",
            label: "五大连池市",
            sort: 1,
          },
          {
            value: "231643",
            label: "孙吴县",
            sort: 2,
          },
          {
            value: "231643",
            label: "爱辉区",
            sort: 3,
          },
          {
            value: "231643",
            label: "逊克县",
            sort: 4,
          },
          {
            value: "231610",
            label: "拜泉县",
            sort: 5,
          },
          {
            value: "231610",
            label: "克东县",
            sort: 6,
          },
        ],
      },
      {
        value: "231650",
        label: "大兴安岭地区",
        sort: 12,
        children: [
          {
            value: "231650",
            label: "呼玛县",
            sort: 0,
          },
          {
            value: "231650",
            label: "塔河县",
            sort: 1,
          },
          {
            value: "231650",
            label: "漠河县",
            sort: 2,
          },
        ],
      },
    ],
  },
  {
    value: "310000",
    label: "上海市",
    sort: 8,
    children: [
      {
        value: "310000",
        label: "上海市",
        sort: 0,
        children: [
          {
            value: "312000",
            label: "黄浦区",
            sort: 0,
          },
          {
            value: "312000",
            label: "卢湾区",
            sort: 1,
          },
          {
            value: "312000",
            label: "徐汇区",
            sort: 2,
          },
          {
            value: "312000",
            label: "静安区",
            sort: 3,
          },
          {
            value: "312000",
            label: "长宁区",
            sort: 4,
          },
          {
            value: "312000",
            label: "普陀区",
            sort: 5,
          },
          {
            value: "312000",
            label: "闸北区",
            sort: 6,
          },
          {
            value: "312000",
            label: "虹口区",
            sort: 7,
          },
          {
            value: "312000",
            label: "杨浦区",
            sort: 8,
          },
          {
            value: "312000",
            label: "浦东新区",
            sort: 9,
          },
          {
            value: "312000",
            label: "闵行区",
            sort: 10,
          },
          {
            value: "312000",
            label: "宝山区",
            sort: 11,
          },
          {
            value: "312000",
            label: "金山区",
            sort: 12,
          },
          {
            value: "312000",
            label: "南汇区",
            sort: 13,
          },
          {
            value: "312000",
            label: "奉贤区",
            sort: 14,
          },
          {
            value: "312000",
            label: "松江区",
            sort: 15,
          },
          {
            value: "312000",
            label: "青浦区",
            sort: 16,
          },
          {
            value: "312000",
            label: "嘉定区",
            sort: 17,
          },
          {
            value: "312000",
            label: "崇明县",
            sort: 18,
          },
        ],
      },
    ],
  },
  {
    value: "330000",
    label: "浙江省",
    sort: 9,
    children: [
      {
        value: "333100",
        label: "杭州市",
        sort: 0,
        children: [
          {
            value: "333100",
            label: "上城区",
            sort: 0,
          },
          {
            value: "333100",
            label: "下城区",
            sort: 1,
          },
          {
            value: "333100",
            label: "拱墅区",
            sort: 2,
          },
          {
            value: "333100",
            label: "西湖区",
            sort: 3,
          },
          {
            value: "333100",
            label: "江干区",
            sort: 4,
          },
          {
            value: "333100",
            label: "滨江区",
            sort: 5,
          },
        ],
      },
      {
        value: "333120",
        label: "绍兴市",
        sort: 1,
        children: [
          {
            value: "333120",
            label: "越城区",
            sort: 0,
          },
          {
            value: "333120",
            label: "绍兴县",
            sort: 1,
          },
          {
            value: "333120",
            label: "上虞市",
            sort: 2,
          },
          {
            value: "333120",
            label: "嵊州市",
            sort: 3,
          },
        ],
      },
      {
        value: "333130",
        label: "湖州市",
        sort: 2,
        children: [
          {
            value: "333130",
            label: "吴兴区",
            sort: 0,
          },
          {
            value: "333130",
            label: "南浔区",
            sort: 1,
          },
          {
            value: "333130",
            label: "长兴县",
            sort: 2,
          },
          {
            value: "333130",
            label: "德清县",
            sort: 3,
          },
          {
            value: "333130",
            label: "安吉县",
            sort: 4,
          },
        ],
      },
      {
        value: "333140",
        label: "嘉兴市",
        sort: 3,
        children: [
          {
            value: "333140",
            label: "秀城区",
            sort: 0,
          },
          {
            value: "333140",
            label: "秀洲区",
            sort: 1,
          },
          {
            value: "333140",
            label: "嘉善县",
            sort: 2,
          },
          {
            value: "333140",
            label: "平湖市",
            sort: 3,
          },
          {
            value: "333140",
            label: "海盐县",
            sort: 4,
          },
          {
            value: "333140",
            label: "海宁市",
            sort: 5,
          },
          {
            value: "333140",
            label: "桐乡市",
            sort: 6,
          },
        ],
      },
      {
        value: "333150",
        label: "宁波市",
        sort: 4,
        children: [
          {
            value: "333150",
            label: "海曙区",
            sort: 0,
          },
          {
            value: "333150",
            label: "江北区",
            sort: 1,
          },
          {
            value: "333150",
            label: "江东区",
            sort: 2,
          },
          {
            value: "333150",
            label: "鄞州区",
            sort: 3,
          },
          {
            value: "333150",
            label: "镇海区",
            sort: 4,
          },
          {
            value: "333150",
            label: "慈溪市",
            sort: 5,
          },
          {
            value: "333150",
            label: "余姚市",
            sort: 6,
          },
          {
            value: "333150",
            label: "奉化市",
            sort: 7,
          },
          {
            value: "333150",
            label: "宁海县",
            sort: 8,
          },
          {
            value: "333150",
            label: "象山县",
            sort: 9,
          },
          {
            value: "333150",
            label: "北仑区",
            sort: 10,
          },
        ],
      },
      {
        value: "333160",
        label: "舟山市",
        sort: 5,
        children: [
          {
            value: "333160",
            label: "定海区",
            sort: 0,
          },
          {
            value: "333160",
            label: "普陀区",
            sort: 1,
          },
          {
            value: "333160",
            label: "岱山县",
            sort: 2,
          },
        ],
      },
      {
        value: "333180",
        label: "台州市",
        sort: 6,
        children: [
          {
            value: "333180",
            label: "椒江区",
            sort: 0,
          },
          {
            value: "333180",
            label: "黄岩区",
            sort: 1,
          },
          {
            value: "333180",
            label: "路桥区",
            sort: 2,
          },
        ],
      },
      {
        value: "333210",
        label: "金华市",
        sort: 7,
        children: [
          {
            value: "333210",
            label: "婺城区",
            sort: 0,
          },
          {
            value: "333210",
            label: "金东区",
            sort: 1,
          },
          {
            value: "333210",
            label: "兰溪市",
            sort: 2,
          },
          {
            value: "333210",
            label: "武义县",
            sort: 3,
          },
          {
            value: "333210",
            label: "永康市",
            sort: 4,
          },
          {
            value: "333230",
            label: "缙云县",
            sort: 5,
          },
        ],
      },
      {
        value: "333230",
        label: "丽水市",
        sort: 8,
        children: [
          {
            value: "333230",
            label: "莲都区",
            sort: 0,
          },
          {
            value: "333230",
            label: "遂昌县",
            sort: 1,
          },
          {
            value: "333230",
            label: "松阳县",
            sort: 2,
          },
          {
            value: "333230",
            label: "景宁畲族自治县",
            sort: 3,
          },
          {
            value: "333230",
            label: "云和县",
            sort: 4,
          },
          {
            value: "333230",
            label: "龙泉市",
            sort: 5,
          },
          {
            value: "333230",
            label: "庆元县",
            sort: 6,
          },
          {
            value: "333230",
            label: "青田县",
            sort: 7,
          },
        ],
      },
      {
        value: "333240",
        label: "衢州市",
        sort: 9,
        children: [
          {
            value: "333240",
            label: "柯城区",
            sort: 0,
          },
          {
            value: "333240",
            label: "衢江区",
            sort: 1,
          },
          {
            value: "333240",
            label: "江山市",
            sort: 2,
          },
          {
            value: "333240",
            label: "常山县",
            sort: 3,
          },
          {
            value: "333240",
            label: "开化县",
            sort: 4,
          },
          {
            value: "333240",
            label: "龙游县",
            sort: 5,
          },
        ],
      },
      {
        value: "333250",
        label: "温州市",
        sort: 10,
        children: [
          {
            value: "333250",
            label: "鹿城区",
            sort: 0,
          },
          {
            value: "333250",
            label: "瓯海区",
            sort: 1,
          },
          {
            value: "333250",
            label: "龙湾区",
            sort: 2,
          },
          {
            value: "333250",
            label: "永嘉县",
            sort: 3,
          },
          {
            value: "333250",
            label: "瑞安市",
            sort: 4,
          },
          {
            value: "333250",
            label: "文成县",
            sort: 5,
          },
          {
            value: "333250",
            label: "平阳县",
            sort: 6,
          },
          {
            value: "333250",
            label: "泰顺县",
            sort: 7,
          },
          {
            value: "333250",
            label: "乐清市",
            sort: 8,
          },
          {
            value: "333250",
            label: "洞头县",
            sort: 9,
          },
          {
            value: "333250",
            label: "苍南县",
            sort: 10,
          },
        ],
      },
    ],
  },
  {
    value: "340000",
    label: "安徽省",
    sort: 10,
    children: [
      {
        value: "342300",
        label: "合肥市",
        sort: 0,
        children: [
          {
            value: "342300",
            label: "庐阳区",
            sort: 0,
          },
          {
            value: "342300",
            label: "包河区",
            sort: 1,
          },
          {
            value: "342300",
            label: "蜀山区",
            sort: 2,
          },
          {
            value: "342300",
            label: "肥西县",
            sort: 3,
          },
        ],
      },
      {
        value: "342320",
        label: "淮南市",
        sort: 1,
        children: [
          {
            value: "342320",
            label: "田家庵区",
            sort: 0,
          },
          {
            value: "342320",
            label: "大通区",
            sort: 1,
          },
          {
            value: "342320",
            label: "谢家集区",
            sort: 2,
          },
          {
            value: "342320",
            label: "八公山区",
            sort: 3,
          },
          {
            value: "342320",
            label: "潘集区",
            sort: 4,
          },
          {
            value: "342320",
            label: "凤台县",
            sort: 5,
          },
          {
            value: "342370",
            label: "寿县",
            sort: 6,
          },
        ],
      },
      {
        value: "342330",
        label: "蚌埠市",
        sort: 2,
        children: [
          {
            value: "342330",
            label: "龙子湖区",
            sort: 0,
          },
          {
            value: "342330",
            label: "禹会区",
            sort: 1,
          },
          {
            value: "342330",
            label: "淮上区",
            sort: 2,
          },
          {
            value: "342330",
            label: "蚌山区",
            sort: 3,
          },
          {
            value: "342390",
            label: "凤阳县",
            sort: 4,
          },
          {
            value: "342390",
            label: "定远县",
            sort: 5,
          },
          {
            value: "342330",
            label: "五河县",
            sort: 6,
          },
          {
            value: "342330",
            label: "怀远县",
            sort: 7,
          },
          {
            value: "342368",
            label: "蒙城县",
            sort: 8,
          },
          {
            value: "342368",
            label: "涡阳县",
            sort: 9,
          },
          {
            value: "342330",
            label: "固镇县",
            sort: 10,
          },
        ],
      },
      {
        value: "342340",
        label: "宿州市",
        sort: 3,
        children: [
          {
            value: "342340",
            label: "埇桥区",
            sort: 0,
          },
          {
            value: "342340",
            label: "灵璧县",
            sort: 1,
          },
          {
            value: "342340",
            label: "泗县",
            sort: 2,
          },
        ],
      },
      {
        value: "342350",
        label: "淮北市",
        sort: 4,
        children: [
          {
            value: "342350",
            label: "相山区",
            sort: 0,
          },
          {
            value: "342350",
            label: "烈山区",
            sort: 1,
          },
          {
            value: "342350",
            label: "杜集区",
            sort: 2,
          },
          {
            value: "342350",
            label: "濉溪县",
            sort: 3,
          },
          {
            value: "342340",
            label: "萧县",
            sort: 4,
          },
          {
            value: "342340",
            label: "砀山县",
            sort: 5,
          },
        ],
      },
      {
        value: "342360",
        label: "阜阳市",
        sort: 5,
        children: [
          {
            value: "342360",
            label: "颍泉区",
            sort: 0,
          },
          {
            value: "342360",
            label: "颍州区",
            sort: 1,
          },
          {
            value: "342360",
            label: "颍东区",
            sort: 2,
          },
          {
            value: "342360",
            label: "颍上县",
            sort: 3,
          },
          {
            value: "342360",
            label: "阜南县",
            sort: 4,
          },
          {
            value: "342360",
            label: "临泉县",
            sort: 5,
          },
          {
            value: "342360",
            label: "界首市",
            sort: 6,
          },
          {
            value: "342360",
            label: "太和县",
            sort: 7,
          },
          {
            value: "342368",
            label: "利辛县",
            sort: 8,
          },
          {
            value: "342368",
            label: "谯城区",
            sort: 9,
          },
        ],
      },
      {
        value: "342368",
        label: "亳州市",
        sort: 6,
        children: [
          {
            value: "342360",
            label: "颍泉区",
            sort: 0,
          },
          {
            value: "342360",
            label: "颍州区",
            sort: 1,
          },
          {
            value: "342360",
            label: "颍东区",
            sort: 2,
          },
          {
            value: "342360",
            label: "颍上县",
            sort: 3,
          },
          {
            value: "342360",
            label: "阜南县",
            sort: 4,
          },
          {
            value: "342360",
            label: "临泉县",
            sort: 5,
          },
          {
            value: "342360",
            label: "界首市",
            sort: 6,
          },
          {
            value: "342360",
            label: "太和县",
            sort: 7,
          },
          {
            value: "342368",
            label: "利辛县",
            sort: 8,
          },
          {
            value: "342368",
            label: "谯城区",
            sort: 9,
          },
        ],
      },
      {
        value: "342370",
        label: "六安市",
        sort: 7,
        children: [
          {
            value: "342370",
            label: "裕安区",
            sort: 0,
          },
          {
            value: "342370",
            label: "金安区",
            sort: 1,
          },
          {
            value: "342370",
            label: "霍山县",
            sort: 2,
          },
          {
            value: "342370",
            label: "金寨县",
            sort: 3,
          },
          {
            value: "342370",
            label: "霍邱县",
            sort: 4,
          },
        ],
      },
      {
        value: "342380",
        label: "巢湖市",
        sort: 8,
        children: [
          {
            value: "342380",
            label: "居巢区",
            sort: 0,
          },
          {
            value: "342380",
            label: "含山县",
            sort: 1,
          },
          {
            value: "342380",
            label: "和县",
            sort: 2,
          },
          {
            value: "342380",
            label: "无为县",
            sort: 3,
          },
        ],
      },
      {
        value: "342390",
        label: "滁州市",
        sort: 9,
        children: [
          {
            value: "342390",
            label: "琅琊区",
            sort: 0,
          },
          {
            value: "342390",
            label: "南谯区",
            sort: 1,
          },
          {
            value: "342390",
            label: "来安县",
            sort: 2,
          },
          {
            value: "342390",
            label: "天长市",
            sort: 3,
          },
          {
            value: "342390",
            label: "明光市",
            sort: 4,
          },
          {
            value: "342390",
            label: "全椒县",
            sort: 5,
          },
        ],
      },
      {
        value: "342410",
        label: "芜湖市",
        sort: 10,
        children: [
          {
            value: "342410",
            label: "镜湖区",
            sort: 0,
          },
          {
            value: "342410",
            label: "弋江区",
            sort: 1,
          },
          {
            value: "342410",
            label: "鸠江区",
            sort: 2,
          },
          {
            value: "342410",
            label: "三山区",
            sort: 3,
          },
          {
            value: "342410",
            label: "芜湖县",
            sort: 4,
          },
          {
            value: "342410",
            label: "繁昌县",
            sort: 5,
          },
          {
            value: "342410",
            label: "南陵县",
            sort: 6,
          },
        ],
      },
      {
        value: "342420",
        label: "宣城市",
        sort: 11,
        children: [
          {
            value: "342420",
            label: "宣州区",
            sort: 0,
          },
          {
            value: "342420",
            label: "郎溪县",
            sort: 1,
          },
          {
            value: "342420",
            label: "广德县",
            sort: 2,
          },
          {
            value: "342420",
            label: "宁国市",
            sort: 3,
          },
          {
            value: "342420",
            label: "泾县",
            sort: 4,
          },
          {
            value: "342420",
            label: "旌德县",
            sort: 5,
          },
          {
            value: "342471",
            label: "青阳县",
            sort: 6,
          },
        ],
      },
      {
        value: "342430",
        label: "马鞍山市",
        sort: 12,
        children: [
          {
            value: "342430",
            label: "雨山区",
            sort: 0,
          },
          {
            value: "342430",
            label: "花山区",
            sort: 1,
          },
          {
            value: "342430",
            label: "金家庄区",
            sort: 2,
          },
          {
            value: "342430",
            label: "当涂县",
            sort: 3,
          },
        ],
      },
      {
        value: "342440",
        label: "铜陵市",
        sort: 13,
        children: [
          {
            value: "342440",
            label: "铜官山区",
            sort: 0,
          },
          {
            value: "342440",
            label: "郊区",
            sort: 1,
          },
          {
            value: "342440",
            label: "狮子山区",
            sort: 2,
          },
          {
            value: "342440",
            label: "铜陵县",
            sort: 3,
          },
        ],
      },
      {
        value: "342450",
        label: "黄山市",
        sort: 14,
        children: [
          {
            value: "342450",
            label: "屯溪区",
            sort: 0,
          },
          {
            value: "342471",
            label: "石台县",
            sort: 1,
          },
          {
            value: "342450",
            label: "歙县",
            sort: 2,
          },
          {
            value: "342420",
            label: "绩溪县",
            sort: 3,
          },
          {
            value: "342450",
            label: "休宁县",
            sort: 4,
          },
          {
            value: "342450",
            label: "黟县",
            sort: 5,
          },
          {
            value: "342450",
            label: "祁门县",
            sort: 6,
          },
          {
            value: "342450",
            label: "黄山区",
            sort: 7,
          },
          {
            value: "342450",
            label: "徽州区",
            sort: 8,
          },
        ],
      },
      {
        value: "342460",
        label: "安庆市",
        sort: 15,
        children: [
          {
            value: "342460",
            label: "大观区",
            sort: 0,
          },
          {
            value: "342460",
            label: "迎江区",
            sort: 1,
          },
          {
            value: "342460",
            label: "怀宁县",
            sort: 2,
          },
          {
            value: "342460",
            label: "望江县",
            sort: 3,
          },
          {
            value: "342460",
            label: "潜山县",
            sort: 4,
          },
          {
            value: "342460",
            label: "太湖县",
            sort: 5,
          },
          {
            value: "342460",
            label: "宿松县",
            sort: 6,
          },
          {
            value: "342460",
            label: "岳西县",
            sort: 7,
          },
          {
            value: "342460",
            label: "枞阳县",
            sort: 8,
          },
        ],
      },
      {
        value: "342471",
        label: "池州市",
        sort: 16,
        children: [
          {
            value: "342471",
            label: "贵池区",
            sort: 0,
          },
          {
            value: "342471",
            label: "东至县",
            sort: 1,
          },
        ],
      },
    ],
  },
  {
    value: "350000",
    label: "福建省",
    sort: 11,
    children: [
      {
        value: "353500",
        label: "福州市",
        sort: 0,
        children: [
          {
            value: "353500",
            label: "鼓楼区",
            sort: 0,
          },
          {
            value: "353500",
            label: "台江区",
            sort: 1,
          },
          {
            value: "353500",
            label: "仓山区",
            sort: 2,
          },
          {
            value: "353500",
            label: "晋安区",
            sort: 3,
          },
          {
            value: "353500",
            label: "马尾区",
            sort: 4,
          },
          {
            value: "353500",
            label: "闽侯县",
            sort: 5,
          },
          {
            value: "353500",
            label: "长乐市",
            sort: 6,
          },
          {
            value: "353500",
            label: "福清市",
            sort: 7,
          },
          {
            value: "353500",
            label: "平潭县",
            sort: 8,
          },
          {
            value: "353500",
            label: "连江县",
            sort: 9,
          },
          {
            value: "353500",
            label: "罗源县",
            sort: 10,
          },
          {
            value: "353500",
            label: "永泰县",
            sort: 11,
          },
          {
            value: "353500",
            label: "闽清县",
            sort: 12,
          },
        ],
      },
      {
        value: "353511",
        label: "莆田市",
        sort: 1,
        children: [
          {
            value: "353511",
            label: "城厢区",
            sort: 0,
          },
          {
            value: "353511",
            label: "涵江区",
            sort: 1,
          },
          {
            value: "353511",
            label: "荔城区",
            sort: 2,
          },
          {
            value: "353511",
            label: "秀屿区",
            sort: 3,
          },
          {
            value: "353511",
            label: "仙游县",
            sort: 4,
          },
        ],
      },
      {
        value: "353520",
        label: "宁德市",
        sort: 2,
        children: [
          {
            value: "353520",
            label: "蕉城区",
            sort: 0,
          },
          {
            value: "353520",
            label: "古田县",
            sort: 1,
          },
          {
            value: "353520",
            label: "屏南县",
            sort: 2,
          },
        ],
      },
      {
        value: "353530",
        label: "南平市",
        sort: 3,
        children: [
          {
            value: "353530",
            label: "延平区",
            sort: 0,
          },
          {
            value: "353530",
            label: "建瓯市",
            sort: 1,
          },
          {
            value: "353530",
            label: "顺昌县",
            sort: 2,
          },
          {
            value: "353650",
            label: "将乐县",
            sort: 3,
          },
          {
            value: "353530",
            label: "浦城县",
            sort: 4,
          },
          {
            value: "353530",
            label: "松溪县",
            sort: 5,
          },
          {
            value: "353530",
            label: "政和县",
            sort: 6,
          },
        ],
      },
      {
        value: "353610",
        label: "厦门市",
        sort: 4,
        children: [
          {
            value: "353610",
            label: "思明区",
            sort: 0,
          },
          {
            value: "353610",
            label: "湖里区",
            sort: 1,
          },
          {
            value: "353610",
            label: "集美区",
            sort: 2,
          },
          {
            value: "353610",
            label: "海沧区",
            sort: 3,
          },
          {
            value: "353610",
            label: "同安区",
            sort: 4,
          },
          {
            value: "353610",
            label: "翔安区",
            sort: 5,
          },
        ],
      },
      {
        value: "353620",
        label: "泉州市",
        sort: 5,
        children: [
          {
            value: "353620",
            label: "鲤城区",
            sort: 0,
          },
          {
            value: "353620",
            label: "丰泽区",
            sort: 1,
          },
          {
            value: "353620",
            label: "洛江区",
            sort: 2,
          },
          {
            value: "353620",
            label: "惠安县",
            sort: 3,
          },
          {
            value: "353620",
            label: "晋江市",
            sort: 4,
          },
          {
            value: "353620",
            label: "南安市",
            sort: 5,
          },
          {
            value: "353640",
            label: "上杭县",
            sort: 6,
          },
          {
            value: "353620",
            label: "安溪县",
            sort: 7,
          },
          {
            value: "353620",
            label: "德化县",
            sort: 8,
          },
          {
            value: "353620",
            label: "永春县",
            sort: 9,
          },
          {
            value: "353620",
            label: "石狮市",
            sort: 10,
          },
          {
            value: "353620",
            label: "泉港区",
            sort: 11,
          },
        ],
      },
      {
        value: "353630",
        label: "漳州市",
        sort: 6,
        children: [
          {
            value: "353630",
            label: "芗城区",
            sort: 0,
          },
          {
            value: "353630",
            label: "龙文区",
            sort: 1,
          },
          {
            value: "353630",
            label: "龙海市",
            sort: 2,
          },
          {
            value: "353630",
            label: "漳浦县",
            sort: 3,
          },
          {
            value: "353630",
            label: "云霄县",
            sort: 4,
          },
          {
            value: "353630",
            label: "东山县",
            sort: 5,
          },
          {
            value: "353630",
            label: "诏安县",
            sort: 6,
          },
          {
            value: "353630",
            label: "南靖县",
            sort: 7,
          },
          {
            value: "353630",
            label: "平和县",
            sort: 8,
          },
          {
            value: "353630",
            label: "华安县",
            sort: 9,
          },
          {
            value: "353630",
            label: "长泰县",
            sort: 10,
          },
        ],
      },
      {
        value: "353640",
        label: "龙岩市",
        sort: 7,
        children: [
          {
            value: "353640",
            label: "新罗区",
            sort: 0,
          },
          {
            value: "353640",
            label: "永定县",
            sort: 1,
          },
          {
            value: "353640",
            label: "武平县",
            sort: 2,
          },
          {
            value: "353640",
            label: "漳平市",
            sort: 3,
          },
        ],
      },
      {
        value: "353650",
        label: "三明市",
        sort: 8,
        children: [
          {
            value: "353650",
            label: "梅列区",
            sort: 0,
          },
          {
            value: "353650",
            label: "三元区",
            sort: 1,
          },
          {
            value: "353650",
            label: "尤溪县",
            sort: 2,
          },
          {
            value: "353650",
            label: "明溪县",
            sort: 3,
          },
          {
            value: "353650",
            label: "清流县",
            sort: 4,
          },
          {
            value: "353650",
            label: "宁化县",
            sort: 5,
          },
          {
            value: "353650",
            label: "沙县",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "360000",
    label: "江西省",
    sort: 12,
    children: [
      {
        value: "363300",
        label: "南昌市",
        sort: 0,
        children: [
          {
            value: "363300",
            label: "青云谱区",
            sort: 0,
          },
          {
            value: "363300",
            label: "西湖区",
            sort: 1,
          },
          {
            value: "363300",
            label: "湾里区",
            sort: 2,
          },
          {
            value: "363300",
            label: "东湖区",
            sort: 3,
          },
          {
            value: "363300",
            label: "青山湖区",
            sort: 4,
          },
          {
            value: "363300",
            label: "南昌县",
            sort: 5,
          },
          {
            value: "363300",
            label: "新建县",
            sort: 6,
          },
          {
            value: "363320",
            label: "永修县",
            sort: 7,
          },
          {
            value: "363320",
            label: "德安县",
            sort: 8,
          },
          {
            value: "363300",
            label: "安义县",
            sort: 9,
          },
          {
            value: "363360",
            label: "靖安县",
            sort: 10,
          },
          {
            value: "363360",
            label: "奉新县",
            sort: 11,
          },
          {
            value: "363360",
            label: "高安市",
            sort: 12,
          },
        ],
      },
      {
        value: "363320",
        label: "九江市",
        sort: 1,
        children: [
          {
            value: "363320",
            label: "浔阳区",
            sort: 0,
          },
          {
            value: "363320",
            label: "庐山区",
            sort: 1,
          },
          {
            value: "363320",
            label: "九江县",
            sort: 2,
          },
          {
            value: "363320",
            label: "瑞昌市",
            sort: 3,
          },
          {
            value: "363320",
            label: "武宁县",
            sort: 4,
          },
          {
            value: "363320",
            label: "修水县",
            sort: 5,
          },
          {
            value: "363320",
            label: "湖口县",
            sort: 6,
          },
          {
            value: "363320",
            label: "都昌县",
            sort: 7,
          },
          {
            value: "363320",
            label: "彭泽县",
            sort: 8,
          },
          {
            value: "363320",
            label: "星子县",
            sort: 9,
          },
        ],
      },
      {
        value: "363330",
        label: "景德镇市",
        sort: 2,
        children: [
          {
            value: "363330",
            label: "昌江区",
            sort: 0,
          },
          {
            value: "363330",
            label: "珠山区",
            sort: 1,
          },
          {
            value: "363330",
            label: "浮梁县",
            sort: 2,
          },
          {
            value: "363340",
            label: "鄱阳县",
            sort: 3,
          },
          {
            value: "363340",
            label: "婺源县",
            sort: 4,
          },
          {
            value: "363330",
            label: "乐平市",
            sort: 5,
          },
        ],
      },
      {
        value: "363340",
        label: "上饶市",
        sort: 3,
        children: [
          {
            value: "363340",
            label: "信州区",
            sort: 0,
          },
          {
            value: "363340",
            label: "上饶县",
            sort: 1,
          },
          {
            value: "363340",
            label: "德兴市",
            sort: 2,
          },
          {
            value: "363340",
            label: "横峰县",
            sort: 3,
          },
          {
            value: "363340",
            label: "弋阳县",
            sort: 4,
          },
          {
            value: "363340",
            label: "铅山县",
            sort: 5,
          },
          {
            value: "363340",
            label: "广丰县",
            sort: 6,
          },
          {
            value: "363340",
            label: "玉山县",
            sort: 7,
          },
        ],
      },
      {
        value: "363350",
        label: "鹰潭市",
        sort: 4,
        children: [
          {
            value: "363350",
            label: "月湖区",
            sort: 0,
          },
          {
            value: "363340",
            label: "余干县",
            sort: 1,
          },
          {
            value: "363350",
            label: "余江县",
            sort: 2,
          },
          {
            value: "363440",
            label: "资溪县",
            sort: 3,
          },
          {
            value: "363350",
            label: "贵溪市",
            sort: 4,
          },
          {
            value: "363340",
            label: "万年县",
            sort: 5,
          },
        ],
      },
      {
        value: "363360",
        label: "宜春市",
        sort: 5,
        children: [
          {
            value: "363360",
            label: "袁州区",
            sort: 0,
          },
          {
            value: "363360",
            label: "万载县",
            sort: 1,
          },
          {
            value: "363360",
            label: "铜鼓县",
            sort: 2,
          },
          {
            value: "363360",
            label: "宜丰县",
            sort: 3,
          },
          {
            value: "363360",
            label: "上高县",
            sort: 4,
          },
          {
            value: "363380",
            label: "分宜县",
            sort: 5,
          },
        ],
      },
      {
        value: "363370",
        label: "萍乡市",
        sort: 6,
        children: [
          {
            value: "363370",
            label: "安源区",
            sort: 0,
          },
          {
            value: "363370",
            label: "上栗县",
            sort: 1,
          },
          {
            value: "363370",
            label: "湘东区",
            sort: 2,
          },
          {
            value: "363370",
            label: "莲花县",
            sort: 3,
          },
          {
            value: "363370",
            label: "芦溪县",
            sort: 4,
          },
        ],
      },
      {
        value: "363380",
        label: "新余市",
        sort: 7,
        children: [
          {
            value: "363380",
            label: "渝水区",
            sort: 0,
          },
        ],
      },
      {
        value: "363410",
        label: "赣州市",
        sort: 8,
        children: [
          {
            value: "363410",
            label: "章贡区",
            sort: 0,
          },
          {
            value: "363410",
            label: "赣县",
            sort: 1,
          },
          {
            value: "363410",
            label: "上犹县",
            sort: 2,
          },
          {
            value: "363410",
            label: "崇义县",
            sort: 3,
          },
          {
            value: "363410",
            label: "南康市",
            sort: 4,
          },
          {
            value: "363410",
            label: "大余县",
            sort: 5,
          },
          {
            value: "363410",
            label: "信丰县",
            sort: 6,
          },
          {
            value: "363410",
            label: "龙南县",
            sort: 7,
          },
          {
            value: "363410",
            label: "全南县",
            sort: 8,
          },
          {
            value: "363410",
            label: "定南县",
            sort: 9,
          },
        ],
      },
      {
        value: "363430",
        label: "吉安市",
        sort: 9,
        children: [
          {
            value: "363430",
            label: "吉州区",
            sort: 0,
          },
          {
            value: "363430",
            label: "青原区",
            sort: 1,
          },
          {
            value: "363430",
            label: "吉安县",
            sort: 2,
          },
          {
            value: "363430",
            label: "安福县",
            sort: 3,
          },
          {
            value: "363430",
            label: "永新县",
            sort: 4,
          },
          {
            value: "363430",
            label: "井冈山市",
            sort: 5,
          },
          {
            value: "363430",
            label: "泰和县",
            sort: 6,
          },
          {
            value: "363430",
            label: "万安县",
            sort: 7,
          },
          {
            value: "363430",
            label: "遂川县",
            sort: 8,
          },
        ],
      },
      {
        value: "363440",
        label: "抚州市",
        sort: 10,
        children: [
          {
            value: "363440",
            label: "临川区",
            sort: 0,
          },
          {
            value: "363440",
            label: "崇仁县",
            sort: 1,
          },
          {
            value: "363440",
            label: "乐安县",
            sort: 2,
          },
          {
            value: "363440",
            label: "宜黄县",
            sort: 3,
          },
          {
            value: "363440",
            label: "南丰县",
            sort: 4,
          },
          {
            value: "363440",
            label: "黎川县",
            sort: 5,
          },
          {
            value: "363440",
            label: "南城县",
            sort: 6,
          },
          {
            value: "363440",
            label: "金溪县",
            sort: 7,
          },
          {
            value: "363440",
            label: "广昌县",
            sort: 8,
          },
        ],
      },
    ],
  },
  {
    value: "370000",
    label: "山东省",
    sort: 13,
    children: [
      {
        value: "372500",
        label: "济南市",
        sort: 0,
        children: [
          {
            value: "372500",
            label: "市中区",
            sort: 0,
          },
          {
            value: "372500",
            label: "历下区",
            sort: 1,
          },
          {
            value: "372500",
            label: "历城区",
            sort: 2,
          },
          {
            value: "372500",
            label: "槐荫区",
            sort: 3,
          },
          {
            value: "372500",
            label: "天桥区",
            sort: 4,
          },
          {
            value: "372500",
            label: "章丘市",
            sort: 5,
          },
          {
            value: "372500",
            label: "长清区",
            sort: 6,
          },
          {
            value: "372500",
            label: "平阴县",
            sort: 7,
          },
        ],
      },
      {
        value: "372520",
        label: "聊城市",
        sort: 1,
        children: [
          {
            value: "372520",
            label: "东昌府区",
            sort: 0,
          },
          {
            value: "372520",
            label: "茌平县",
            sort: 1,
          },
          {
            value: "372520",
            label: "东阿县",
            sort: 2,
          },
          {
            value: "372520",
            label: "阳谷县",
            sort: 3,
          },
          {
            value: "372520",
            label: "莘县",
            sort: 4,
          },
          {
            value: "372520",
            label: "冠县",
            sort: 5,
          },
          {
            value: "372520",
            label: "临清市",
            sort: 6,
          },
          {
            value: "372520",
            label: "高唐县",
            sort: 7,
          },
        ],
      },
      {
        value: "372530",
        label: "德州市",
        sort: 2,
        children: [
          {
            value: "372530",
            label: "德城区",
            sort: 0,
          },
          {
            value: "372530",
            label: "平原县",
            sort: 1,
          },
          {
            value: "372530",
            label: "夏津县",
            sort: 2,
          },
          {
            value: "372530",
            label: "武城县",
            sort: 3,
          },
          {
            value: "372530",
            label: "宁津县",
            sort: 4,
          },
          {
            value: "372530",
            label: "陵县",
            sort: 5,
          },
          {
            value: "372530",
            label: "乐陵市",
            sort: 6,
          },
          {
            value: "372530",
            label: "庆云县",
            sort: 7,
          },
        ],
      },
      {
        value: "372550",
        label: "淄博市",
        sort: 3,
        children: [
          {
            value: "372550",
            label: "张店区",
            sort: 0,
          },
          {
            value: "372550",
            label: "淄川区",
            sort: 1,
          },
          {
            value: "372550",
            label: "博山区",
            sort: 2,
          },
          {
            value: "372550",
            label: "周村区",
            sort: 3,
          },
          {
            value: "372550",
            label: "临淄区",
            sort: 4,
          },
        ],
      },
      {
        value: "372566",
        label: "滨州市",
        sort: 4,
        children: [
          {
            value: "372550",
            label: "沂源县",
            sort: 0,
          },
          {
            value: "372566",
            label: "邹平县",
            sort: 1,
          },
          {
            value: "372550",
            label: "高青县",
            sort: 2,
          },
          {
            value: "372550",
            label: "桓台县",
            sort: 3,
          },
          {
            value: "372566",
            label: "博兴县",
            sort: 4,
          },
          {
            value: "372566",
            label: "滨城区",
            sort: 5,
          },
          {
            value: "372566",
            label: "沾化县",
            sort: 6,
          },
        ],
      },
      {
        value: "372570",
        label: "东营市",
        sort: 5,
        children: [
          {
            value: "372570",
            label: "东营区",
            sort: 0,
          },
          {
            value: "372570",
            label: "垦利县",
            sort: 1,
          },
          {
            value: "372570",
            label: "河口区",
            sort: 2,
          },
          {
            value: "372570",
            label: "广饶县",
            sort: 3,
          },
          {
            value: "372570",
            label: "利津县",
            sort: 4,
          },
        ],
      },
      {
        value: "372610",
        label: "潍坊市",
        sort: 6,
        children: [
          {
            value: "372610",
            label: "潍城区",
            sort: 0,
          },
          {
            value: "372610",
            label: "奎文区",
            sort: 1,
          },
          {
            value: "372610",
            label: "寒亭区",
            sort: 2,
          },
          {
            value: "372610",
            label: "坊子区",
            sort: 3,
          },
          {
            value: "372610",
            label: "昌邑市",
            sort: 4,
          },
          {
            value: "372640",
            label: "莱州市",
            sort: 5,
          },
          {
            value: "372610",
            label: "高密市",
            sort: 6,
          },
        ],
      },
      {
        value: "372640",
        label: "烟台市",
        sort: 7,
        children: [
          {
            value: "372640",
            label: "芝罘区",
            sort: 0,
          },
          {
            value: "372640",
            label: "莱山区",
            sort: 1,
          },
          {
            value: "372640",
            label: "龙口市",
            sort: 2,
          },
          {
            value: "372640",
            label: "牟平区",
            sort: 3,
          },
          {
            value: "372642",
            label: "环翠区",
            sort: 4,
          },
          {
            value: "372642",
            label: "荣成市",
            sort: 5,
          },
          {
            value: "372642",
            label: "文登市",
            sort: 6,
          },
          {
            value: "372642",
            label: "乳山市",
            sort: 7,
          },
        ],
      },
      {
        value: "372642",
        label: "威海市",
        sort: 8,
        children: [
          {
            value: "372640",
            label: "芝罘区",
            sort: 0,
          },
          {
            value: "372640",
            label: "莱山区",
            sort: 1,
          },
          {
            value: "372640",
            label: "龙口市",
            sort: 2,
          },
          {
            value: "372640",
            label: "牟平区",
            sort: 3,
          },
          {
            value: "372642",
            label: "环翠区",
            sort: 4,
          },
          {
            value: "372642",
            label: "荣成市",
            sort: 5,
          },
          {
            value: "372642",
            label: "文登市",
            sort: 6,
          },
          {
            value: "372642",
            label: "乳山市",
            sort: 7,
          },
        ],
      },
      {
        value: "372660",
        label: "青岛市",
        sort: 9,
        children: [
          {
            value: "372660",
            label: "市南区",
            sort: 0,
          },
          {
            value: "372660",
            label: "市北区",
            sort: 1,
          },
          {
            value: "372660",
            label: "四方区",
            sort: 2,
          },
          {
            value: "372660",
            label: "李沧区",
            sort: 3,
          },
          {
            value: "372660",
            label: "崂山区",
            sort: 4,
          },
          {
            value: "372660",
            label: "城阳区",
            sort: 5,
          },
          {
            value: "372660",
            label: "即墨市",
            sort: 6,
          },
          {
            value: "372660",
            label: "胶州市",
            sort: 7,
          },
          {
            value: "372660",
            label: "黄岛区",
            sort: 8,
          },
          {
            value: "372660",
            label: "莱西市",
            sort: 9,
          },
          {
            value: "372660",
            label: "平度市",
            sort: 10,
          },
        ],
      },
      {
        value: "372710",
        label: "泰安市",
        sort: 10,
        children: [
          {
            value: "372710",
            label: "泰山区",
            sort: 0,
          },
          {
            value: "372710",
            label: "岱岳区",
            sort: 1,
          },
          {
            value: "372711",
            label: "钢城区",
            sort: 2,
          },
          {
            value: "372710",
            label: "新泰市",
            sort: 3,
          },
          {
            value: "372710",
            label: "宁阳县",
            sort: 4,
          },
          {
            value: "372710",
            label: "东平县",
            sort: 5,
          },
          {
            value: "372710",
            label: "肥城市",
            sort: 6,
          },
        ],
      },
      {
        value: "372711",
        label: "莱芜市",
        sort: 11,
        children: [
          {
            value: "372710",
            label: "泰山区",
            sort: 0,
          },
          {
            value: "372710",
            label: "岱岳区",
            sort: 1,
          },
          {
            value: "372711",
            label: "钢城区",
            sort: 2,
          },
          {
            value: "372710",
            label: "新泰市",
            sort: 3,
          },
          {
            value: "372710",
            label: "宁阳县",
            sort: 4,
          },
          {
            value: "372710",
            label: "东平县",
            sort: 5,
          },
          {
            value: "372710",
            label: "肥城市",
            sort: 6,
          },
        ],
      },
      {
        value: "372720",
        label: "济宁市",
        sort: 12,
        children: [
          {
            value: "372720",
            label: "市中区",
            sort: 0,
          },
          {
            value: "372720",
            label: "任城区",
            sort: 1,
          },
          {
            value: "372720",
            label: "兖州市",
            sort: 2,
          },
          {
            value: "372720",
            label: "微山县",
            sort: 3,
          },
          {
            value: "372720",
            label: "金乡县",
            sort: 4,
          },
          {
            value: "372720",
            label: "鱼台县",
            sort: 5,
          },
          {
            value: "372720",
            label: "嘉祥县",
            sort: 6,
          },
          {
            value: "372720",
            label: "汶上县",
            sort: 7,
          },
          {
            value: "372720",
            label: "梁山县",
            sort: 8,
          },
        ],
      },
      {
        value: "372740",
        label: "菏泽市",
        sort: 13,
        children: [
          {
            value: "372740",
            label: "牡丹区",
            sort: 0,
          },
          {
            value: "372740",
            label: "定陶县",
            sort: 1,
          },
          {
            value: "372740",
            label: "成武县",
            sort: 2,
          },
          {
            value: "372740",
            label: "单县",
            sort: 3,
          },
          {
            value: "372740",
            label: "曹县",
            sort: 4,
          },
          {
            value: "372740",
            label: "东明县",
            sort: 5,
          },
          {
            value: "372740",
            label: "鄄城县",
            sort: 6,
          },
          {
            value: "372740",
            label: "郓城县",
            sort: 7,
          },
          {
            value: "372740",
            label: "巨野县",
            sort: 8,
          },
        ],
      },
      {
        value: "372760",
        label: "临沂市",
        sort: 14,
        children: [
          {
            value: "372760",
            label: "兰山区",
            sort: 0,
          },
          {
            value: "372760",
            label: "罗庄区",
            sort: 1,
          },
          {
            value: "372760",
            label: "河东区",
            sort: 2,
          },
          {
            value: "372760",
            label: "郯城县",
            sort: 3,
          },
          {
            value: "372760",
            label: "蒙阴县",
            sort: 4,
          },
          {
            value: "372760",
            label: "沂南县",
            sort: 5,
          },
          {
            value: "372760",
            label: "沂水县",
            sort: 6,
          },
          {
            value: "372768",
            label: "莒县",
            sort: 7,
          },
          {
            value: "372760",
            label: "莒南县",
            sort: 8,
          },
          {
            value: "372760",
            label: "临沭县",
            sort: 9,
          },
          {
            value: "372768",
            label: "东港区",
            sort: 10,
          },
          {
            value: "372768",
            label: "岚山区",
            sort: 11,
          },
        ],
      },
      {
        value: "372768",
        label: "日照市",
        sort: 15,
        children: [
          {
            value: "372760",
            label: "兰山区",
            sort: 0,
          },
          {
            value: "372760",
            label: "罗庄区",
            sort: 1,
          },
          {
            value: "372760",
            label: "河东区",
            sort: 2,
          },
          {
            value: "372760",
            label: "郯城县",
            sort: 3,
          },
          {
            value: "372760",
            label: "蒙阴县",
            sort: 4,
          },
          {
            value: "372760",
            label: "沂南县",
            sort: 5,
          },
          {
            value: "372760",
            label: "沂水县",
            sort: 6,
          },
          {
            value: "372768",
            label: "莒县",
            sort: 7,
          },
          {
            value: "372760",
            label: "莒南县",
            sort: 8,
          },
          {
            value: "372760",
            label: "临沭县",
            sort: 9,
          },
          {
            value: "372768",
            label: "东港区",
            sort: 10,
          },
          {
            value: "372768",
            label: "岚山区",
            sort: 11,
          },
        ],
      },
      {
        value: "372770",
        label: "枣庄市",
        sort: 16,
        children: [
          {
            value: "372770",
            label: "薛城区",
            sort: 0,
          },
          {
            value: "372770",
            label: "市中区",
            sort: 1,
          },
          {
            value: "372770",
            label: "山亭区",
            sort: 2,
          },
          {
            value: "372770",
            label: "峄城区",
            sort: 3,
          },
          {
            value: "372770",
            label: "台儿庄区",
            sort: 4,
          },
          {
            value: "372770",
            label: "滕州市",
            sort: 5,
          },
          {
            value: "372760",
            label: "苍山县",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "410000",
    label: "河南省",
    sort: 14,
    children: [
      {
        value: "414500",
        label: "郑州市",
        sort: 0,
        children: [
          {
            value: "414500",
            label: "二七区",
            sort: 0,
          },
          {
            value: "414500",
            label: "中原区",
            sort: 1,
          },
          {
            value: "414500",
            label: "金水区",
            sort: 2,
          },
          {
            value: "414500",
            label: "管城回族区",
            sort: 3,
          },
          {
            value: "414500",
            label: "上街区",
            sort: 4,
          },
          {
            value: "414500",
            label: "惠济区",
            sort: 5,
          },
          {
            value: "414500",
            label: "荥阳市",
            sort: 6,
          },
        ],
      },
      {
        value: "414530",
        label: "新乡市",
        sort: 1,
        children: [
          {
            value: "414530",
            label: "卫滨区",
            sort: 0,
          },
          {
            value: "414530",
            label: "牧野区",
            sort: 1,
          },
          {
            value: "414530",
            label: "凤泉区",
            sort: 2,
          },
          {
            value: "414530",
            label: "卫辉市",
            sort: 3,
          },
          {
            value: "414530",
            label: "延津县",
            sort: 4,
          },
          {
            value: "414530",
            label: "封丘县",
            sort: 5,
          },
          {
            value: "414530",
            label: "长垣县",
            sort: 6,
          },
          {
            value: "414530",
            label: "原阳县",
            sort: 7,
          },
          {
            value: "414530",
            label: "辉县市",
            sort: 8,
          },
          {
            value: "414530",
            label: "新乡县",
            sort: 9,
          },
          {
            value: "414530",
            label: "获嘉县",
            sort: 10,
          },
        ],
      },
      {
        value: "414541",
        label: "焦作市",
        sort: 2,
        children: [
          {
            value: "414541",
            label: "解放区",
            sort: 0,
          },
          {
            value: "414541",
            label: "山阳区",
            sort: 1,
          },
          {
            value: "414541",
            label: "马村区",
            sort: 2,
          },
          {
            value: "414541",
            label: "中站区",
            sort: 3,
          },
          {
            value: "414541",
            label: "修武县",
            sort: 4,
          },
          {
            value: "414541",
            label: "博爱县",
            sort: 5,
          },
          {
            value: "414730",
            label: "西峡县",
            sort: 6,
          },
          {
            value: "414541",
            label: "沁阳市",
            sort: 7,
          },
          {
            value: "414541",
            label: "济源市",
            sort: 8,
          },
          {
            value: "414541",
            label: "孟州市",
            sort: 9,
          },
          {
            value: "414541",
            label: "温县",
            sort: 10,
          },
          {
            value: "414541",
            label: "武陟县",
            sort: 11,
          },
        ],
      },
      {
        value: "414546",
        label: "济源市",
        sort: 3,
        children: [
          {
            value: "414541",
            label: "解放区",
            sort: 0,
          },
          {
            value: "414541",
            label: "山阳区",
            sort: 1,
          },
          {
            value: "414541",
            label: "马村区",
            sort: 2,
          },
          {
            value: "414541",
            label: "中站区",
            sort: 3,
          },
          {
            value: "414541",
            label: "修武县",
            sort: 4,
          },
          {
            value: "414541",
            label: "博爱县",
            sort: 5,
          },
          {
            value: "414730",
            label: "西峡县",
            sort: 6,
          },
          {
            value: "414541",
            label: "沁阳市",
            sort: 7,
          },
          {
            value: "414541",
            label: "济源市",
            sort: 8,
          },
          {
            value: "414541",
            label: "孟州市",
            sort: 9,
          },
          {
            value: "414541",
            label: "温县",
            sort: 10,
          },
          {
            value: "414541",
            label: "武陟县",
            sort: 11,
          },
        ],
      },
      {
        value: "414550",
        label: "安阳市",
        sort: 4,
        children: [
          {
            value: "414550",
            label: "文峰区",
            sort: 0,
          },
          {
            value: "414550",
            label: "北关区",
            sort: 1,
          },
          {
            value: "414550",
            label: "龙安区",
            sort: 2,
          },
          {
            value: "414550",
            label: "殷都区",
            sort: 3,
          },
          {
            value: "414550",
            label: "安阳县",
            sort: 4,
          },
        ],
      },
      {
        value: "414570",
        label: "濮阳市",
        sort: 5,
        children: [
          {
            value: "414570",
            label: "华龙区",
            sort: 0,
          },
          {
            value: "414570",
            label: "濮阳县",
            sort: 1,
          },
          {
            value: "414570",
            label: "清丰县",
            sort: 2,
          },
          {
            value: "414570",
            label: "南乐县",
            sort: 3,
          },
          {
            value: "414570",
            label: "范县",
            sort: 4,
          },
          {
            value: "414570",
            label: "台前县",
            sort: 5,
          },
        ],
      },
      {
        value: "414580",
        label: "鹤壁市",
        sort: 6,
        children: [
          {
            value: "414580",
            label: "山城区",
            sort: 0,
          },
          {
            value: "414580",
            label: "淇滨区",
            sort: 1,
          },
          {
            value: "414580",
            label: "鹤山区",
            sort: 2,
          },
        ],
      },
      {
        value: "414610",
        label: "许昌市",
        sort: 7,
        children: [
          {
            value: "414610",
            label: "魏都区",
            sort: 0,
          },
          {
            value: "414610",
            label: "许昌县",
            sort: 1,
          },
          {
            value: "414610",
            label: "鄢陵县",
            sort: 2,
          },
          {
            value: "414660",
            label: "太康县",
            sort: 3,
          },
          {
            value: "414610",
            label: "长葛市",
            sort: 4,
          },
          {
            value: "414610",
            label: "禹州市",
            sort: 5,
          },
          {
            value: "414610",
            label: "襄城县",
            sort: 6,
          },
        ],
      },
      {
        value: "414620",
        label: "漯河市",
        sort: 8,
        children: [
          {
            value: "414620",
            label: "源汇区",
            sort: 0,
          },
          {
            value: "414620",
            label: "郾城区",
            sort: 1,
          },
          {
            value: "414620",
            label: "舞阳县",
            sort: 2,
          },
          {
            value: "414670",
            label: "舞钢市",
            sort: 3,
          },
          {
            value: "414620",
            label: "临颍县",
            sort: 4,
          },
        ],
      },
      {
        value: "414640",
        label: "信阳市",
        sort: 9,
        children: [
          {
            value: "414640",
            label: "浉河区",
            sort: 0,
          },
          {
            value: "414640",
            label: "平桥区",
            sort: 1,
          },
          {
            value: "414640",
            label: "罗山县",
            sort: 2,
          },
          {
            value: "414640",
            label: "息县",
            sort: 3,
          },
          {
            value: "414640",
            label: "淮滨县",
            sort: 4,
          },
        ],
      },
      {
        value: "414660",
        label: "周口市",
        sort: 10,
        children: [
          {
            value: "414660",
            label: "淮阳县",
            sort: 0,
          },
        ],
      },
      {
        value: "414670",
        label: "平顶山市",
        sort: 11,
        children: [
          {
            value: "414670",
            label: "卫东区",
            sort: 0,
          },
          {
            value: "414670",
            label: "湛河区",
            sort: 1,
          },
          {
            value: "414670",
            label: "新华区",
            sort: 2,
          },
          {
            value: "414670",
            label: "石龙区",
            sort: 3,
          },
          {
            value: "414670",
            label: "郏县",
            sort: 4,
          },
          {
            value: "414670",
            label: "叶县",
            sort: 5,
          },
          {
            value: "414670",
            label: "鲁山县",
            sort: 6,
          },
          {
            value: "414670",
            label: "宝丰县",
            sort: 7,
          },
          {
            value: "414670",
            label: "汝州市",
            sort: 8,
          },
        ],
      },
      {
        value: "414710",
        label: "洛阳市",
        sort: 12,
        children: [
          {
            value: "414710",
            label: "西工区",
            sort: 0,
          },
          {
            value: "414710",
            label: "老城区",
            sort: 1,
          },
          {
            value: "414710",
            label: "涧西区",
            sort: 2,
          },
          {
            value: "414710",
            label: "洛龙区",
            sort: 3,
          },
          {
            value: "414710",
            label: "吉利区",
            sort: 4,
          },
          {
            value: "414710",
            label: "孟津县",
            sort: 5,
          },
          {
            value: "414710",
            label: "汝阳县",
            sort: 6,
          },
          {
            value: "414710",
            label: "伊川县",
            sort: 7,
          },
          {
            value: "414710",
            label: "嵩县",
            sort: 8,
          },
          {
            value: "414710",
            label: "栾川县",
            sort: 9,
          },
          {
            value: "414710",
            label: "宜阳县",
            sort: 10,
          },
          {
            value: "414710",
            label: "洛宁县",
            sort: 11,
          },
          {
            value: "414710",
            label: "新安县",
            sort: 12,
          },
          {
            value: "414710",
            label: "偃师市",
            sort: 13,
          },
        ],
      },
      {
        value: "414720",
        label: "三门峡市",
        sort: 13,
        children: [
          {
            value: "414720",
            label: "湖滨区",
            sort: 0,
          },
          {
            value: "414720",
            label: "陕县",
            sort: 1,
          },
          {
            value: "414720",
            label: "卢氏县",
            sort: 2,
          },
          {
            value: "414720",
            label: "义马市",
            sort: 3,
          },
          {
            value: "414720",
            label: "渑池县",
            sort: 4,
          },
          {
            value: "414720",
            label: "灵宝市",
            sort: 5,
          },
        ],
      },
      {
        value: "414730",
        label: "南阳市",
        sort: 14,
        children: [
          {
            value: "414730",
            label: "卧龙区",
            sort: 0,
          },
          {
            value: "414730",
            label: "宛城区",
            sort: 1,
          },
          {
            value: "414730",
            label: "方城县",
            sort: 2,
          },
          {
            value: "414730",
            label: "社旗县",
            sort: 3,
          },
          {
            value: "414730",
            label: "唐河县",
            sort: 4,
          },
          {
            value: "414730",
            label: "新野县",
            sort: 5,
          },
        ],
      },
      {
        value: "414750",
        label: "开封市",
        sort: 15,
        children: [
          {
            value: "414750",
            label: "鼓楼区",
            sort: 0,
          },
          {
            value: "414750",
            label: "顺河回族区",
            sort: 1,
          },
          {
            value: "414750",
            label: "禹王台区",
            sort: 2,
          },
          {
            value: "414750",
            label: "金明区",
            sort: 3,
          },
          {
            value: "414750",
            label: "龙亭区",
            sort: 4,
          },
          {
            value: "414750",
            label: "开封县",
            sort: 5,
          },
          {
            value: "414750",
            label: "杞县",
            sort: 6,
          },
          {
            value: "414750",
            label: "兰考县",
            sort: 7,
          },
          {
            value: "414750",
            label: "通许县",
            sort: 8,
          },
          {
            value: "414750",
            label: "尉氏县",
            sort: 9,
          },
        ],
      },
      {
        value: "414760",
        label: "商丘市",
        sort: 16,
        children: [
          {
            value: "414760",
            label: "梁园区",
            sort: 0,
          },
          {
            value: "414760",
            label: "睢阳区",
            sort: 1,
          },
          {
            value: "414760",
            label: "柘城县",
            sort: 2,
          },
          {
            value: "414760",
            label: "虞城县",
            sort: 3,
          },
          {
            value: "414760",
            label: "夏邑县",
            sort: 4,
          },
          {
            value: "414760",
            label: "永城市",
            sort: 5,
          },
          {
            value: "414760",
            label: "宁陵县",
            sort: 6,
          },
          {
            value: "414760",
            label: "民权县",
            sort: 7,
          },
          {
            value: "414760",
            label: "睢县",
            sort: 8,
          },
        ],
      },
    ],
  },
  {
    value: "420000",
    label: "湖北省",
    sort: 15,
    children: [
      {
        value: "424300",
        label: "武汉市",
        sort: 0,
        children: [
          {
            value: "424300",
            label: "江岸区",
            sort: 0,
          },
          {
            value: "424300",
            label: "江汉区",
            sort: 1,
          },
          {
            value: "424300",
            label: "硚口区",
            sort: 2,
          },
          {
            value: "424300",
            label: "东西湖区",
            sort: 3,
          },
          {
            value: "424300",
            label: "汉阳区",
            sort: 4,
          },
          {
            value: "424300",
            label: "武昌区",
            sort: 5,
          },
          {
            value: "424300",
            label: "洪山区",
            sort: 6,
          },
          {
            value: "424300",
            label: "青山区",
            sort: 7,
          },
          {
            value: "424300",
            label: "汉南区",
            sort: 8,
          },
          {
            value: "424300",
            label: "蔡甸区",
            sort: 9,
          },
          {
            value: "424300",
            label: "江夏区",
            sort: 10,
          },
          {
            value: "424300",
            label: "黄陂区",
            sort: 11,
          },
          {
            value: "424300",
            label: "新洲区",
            sort: 12,
          },
        ],
      },
      {
        value: "424317",
        label: "天门市",
        sort: 1,
        children: [
          {
            value: "424320",
            label: "汉川市",
            sort: 0,
          },
          {
            value: "424317",
            label: "天门市",
            sort: 1,
          },
          {
            value: "424480",
            label: "京山县",
            sort: 2,
          },
          {
            value: "424480",
            label: "沙洋县",
            sort: 3,
          },
          {
            value: "424480",
            label: "钟祥市",
            sort: 4,
          },
        ],
      },
      {
        value: "424320",
        label: "孝感市",
        sort: 2,
        children: [
          {
            value: "424320",
            label: "云梦县",
            sort: 0,
          },
          {
            value: "424320",
            label: "孝南区",
            sort: 1,
          },
          {
            value: "424320",
            label: "应城市",
            sort: 2,
          },
          {
            value: "424320",
            label: "安陆市",
            sort: 3,
          },
          {
            value: "424413",
            label: "广水市",
            sort: 4,
          },
          {
            value: "424320",
            label: "大悟县",
            sort: 5,
          },
          {
            value: "424320",
            label: "孝昌县",
            sort: 6,
          },
        ],
      },
      {
        value: "424330",
        label: "仙桃市",
        sort: 3,
        children: [
          {
            value: "424330",
            label: "仙桃市",
            sort: 0,
          },
          {
            value: "424331",
            label: "潜江市",
            sort: 1,
          },
          {
            value: "424340",
            label: "洪湖市",
            sort: 2,
          },
          {
            value: "424340",
            label: "监利县",
            sort: 3,
          },
        ],
      },
      {
        value: "424331",
        label: "潜江市",
        sort: 4,
        children: [
          {
            value: "424330",
            label: "仙桃市",
            sort: 0,
          },
          {
            value: "424331",
            label: "潜江市",
            sort: 1,
          },
          {
            value: "424340",
            label: "洪湖市",
            sort: 2,
          },
          {
            value: "424340",
            label: "监利县",
            sort: 3,
          },
        ],
      },
      {
        value: "424340",
        label: "荆州市",
        sort: 5,
        children: [
          {
            value: "424340",
            label: "沙市区",
            sort: 0,
          },
          {
            value: "424340",
            label: "荆州区",
            sort: 1,
          },
          {
            value: "424340",
            label: "江陵县",
            sort: 2,
          },
          {
            value: "424340",
            label: "松滋市",
            sort: 3,
          },
          {
            value: "424340",
            label: "公安县",
            sort: 4,
          },
          {
            value: "424340",
            label: "石首市",
            sort: 5,
          },
        ],
      },
      {
        value: "424350",
        label: "黄石市",
        sort: 6,
        children: [
          {
            value: "424350",
            label: "阳新县",
            sort: 0,
          },
          {
            value: "424350",
            label: "西塞山区",
            sort: 1,
          },
          {
            value: "424350",
            label: "黄石港区",
            sort: 2,
          },
          {
            value: "424350",
            label: "下陆区",
            sort: 3,
          },
          {
            value: "424350",
            label: "铁山区",
            sort: 4,
          },
          {
            value: "424350",
            label: "大冶市",
            sort: 5,
          },
          {
            value: "424380",
            label: "蕲春县",
            sort: 6,
          },
          {
            value: "424380",
            label: "武穴市",
            sort: 7,
          },
          {
            value: "424380",
            label: "黄梅县",
            sort: 8,
          },
        ],
      },
      {
        value: "424360",
        label: "鄂州市",
        sort: 7,
        children: [
          {
            value: "424360",
            label: "鄂城区",
            sort: 0,
          },
          {
            value: "424360",
            label: "华容区",
            sort: 1,
          },
          {
            value: "424360",
            label: "梁子湖区",
            sort: 2,
          },
        ],
      },
      {
        value: "424370",
        label: "咸宁市",
        sort: 8,
        children: [
          {
            value: "424370",
            label: "咸安区",
            sort: 0,
          },
          {
            value: "424370",
            label: "嘉鱼县",
            sort: 1,
          },
          {
            value: "424370",
            label: "赤壁市",
            sort: 2,
          },
          {
            value: "424370",
            label: "通城县",
            sort: 3,
          },
          {
            value: "424370",
            label: "崇阳县",
            sort: 4,
          },
          {
            value: "424370",
            label: "通山县",
            sort: 5,
          },
        ],
      },
      {
        value: "424380",
        label: "黄冈市",
        sort: 9,
        children: [
          {
            value: "424380",
            label: "黄州区",
            sort: 0,
          },
          {
            value: "424380",
            label: "浠水县",
            sort: 1,
          },
          {
            value: "424380",
            label: "麻城市",
            sort: 2,
          },
          {
            value: "424380",
            label: "红安县",
            sort: 3,
          },
          {
            value: "424380",
            label: "罗田县",
            sort: 4,
          },
          {
            value: "424380",
            label: "英山县",
            sort: 5,
          },
          {
            value: "424380",
            label: "团风县",
            sort: 6,
          },
        ],
      },
      {
        value: "424410",
        label: "襄樊市",
        sort: 10,
        children: [
          {
            value: "424410",
            label: "樊城区",
            sort: 0,
          },
          {
            value: "424410",
            label: "襄城区",
            sort: 1,
          },
          {
            value: "424410",
            label: "襄阳区",
            sort: 2,
          },
          {
            value: "424410",
            label: "枣阳市",
            sort: 3,
          },
          {
            value: "424413",
            label: "曾都区",
            sort: 4,
          },
          {
            value: "424410",
            label: "宜城市",
            sort: 5,
          },
          {
            value: "424410",
            label: "南漳县",
            sort: 6,
          },
          {
            value: "424410",
            label: "保康县",
            sort: 7,
          },
          {
            value: "424410",
            label: "谷城县",
            sort: 8,
          },
          {
            value: "424410",
            label: "老河口市",
            sort: 9,
          },
        ],
      },
      {
        value: "424413",
        label: "随州市",
        sort: 11,
        children: [
          {
            value: "424410",
            label: "樊城区",
            sort: 0,
          },
          {
            value: "424410",
            label: "襄城区",
            sort: 1,
          },
          {
            value: "424410",
            label: "襄阳区",
            sort: 2,
          },
          {
            value: "424410",
            label: "枣阳市",
            sort: 3,
          },
          {
            value: "424413",
            label: "曾都区",
            sort: 4,
          },
          {
            value: "424410",
            label: "宜城市",
            sort: 5,
          },
          {
            value: "424410",
            label: "南漳县",
            sort: 6,
          },
          {
            value: "424410",
            label: "保康县",
            sort: 7,
          },
          {
            value: "424410",
            label: "谷城县",
            sort: 8,
          },
          {
            value: "424410",
            label: "老河口市",
            sort: 9,
          },
        ],
      },
      {
        value: "424420",
        label: "十堰市",
        sort: 12,
        children: [
          {
            value: "424420",
            label: "茅箭区",
            sort: 0,
          },
          {
            value: "424420",
            label: "张湾区",
            sort: 1,
          },
          {
            value: "424420",
            label: "房县",
            sort: 2,
          },
          {
            value: "424420",
            label: "竹山县",
            sort: 3,
          },
          {
            value: "424420",
            label: "竹溪县",
            sort: 4,
          },
          {
            value: "424330",
            label: "神农架林区",
            sort: 5,
          },
          {
            value: "424420",
            label: "郧县",
            sort: 6,
          },
          {
            value: "424420",
            label: "郧西县",
            sort: 7,
          },
          {
            value: "424420",
            label: "丹江口市",
            sort: 8,
          },
        ],
      },
      {
        value: "424424",
        label: "神农架林区",
        sort: 13,
        children: [
          {
            value: "424420",
            label: "茅箭区",
            sort: 0,
          },
          {
            value: "424420",
            label: "张湾区",
            sort: 1,
          },
          {
            value: "424420",
            label: "房县",
            sort: 2,
          },
          {
            value: "424420",
            label: "竹山县",
            sort: 3,
          },
          {
            value: "424420",
            label: "竹溪县",
            sort: 4,
          },
          {
            value: "424330",
            label: "神农架林区",
            sort: 5,
          },
          {
            value: "424420",
            label: "郧县",
            sort: 6,
          },
          {
            value: "424420",
            label: "郧西县",
            sort: 7,
          },
          {
            value: "424420",
            label: "丹江口市",
            sort: 8,
          },
        ],
      },
      {
        value: "424430",
        label: "宜昌市",
        sort: 14,
        children: [
          {
            value: "424430",
            label: "西陵区",
            sort: 0,
          },
          {
            value: "424430",
            label: "伍家岗区",
            sort: 1,
          },
          {
            value: "424430",
            label: "点军区",
            sort: 2,
          },
          {
            value: "424430",
            label: "猇亭区",
            sort: 3,
          },
          {
            value: "424430",
            label: "夷陵区",
            sort: 4,
          },
          {
            value: "424430",
            label: "枝江市",
            sort: 5,
          },
          {
            value: "424430",
            label: "宜都市",
            sort: 6,
          },
          {
            value: "424430",
            label: "五峰土家族自治县",
            sort: 7,
          },
          {
            value: "424430",
            label: "长阳土家族自治县",
            sort: 8,
          },
          {
            value: "424430",
            label: "秭归县",
            sort: 9,
          },
          {
            value: "424430",
            label: "兴山县",
            sort: 10,
          },
        ],
      },
      {
        value: "424450",
        label: "恩施土家族苗族自治州",
        sort: 15,
        children: [
          {
            value: "424450",
            label: "恩施市",
            sort: 0,
          },
          {
            value: "424450",
            label: "建始县",
            sort: 1,
          },
          {
            value: "424450",
            label: "利川市",
            sort: 2,
          },
          {
            value: "424450",
            label: "宣恩县",
            sort: 3,
          },
          {
            value: "424450",
            label: "咸丰县",
            sort: 4,
          },
          {
            value: "424450",
            label: "来凤县",
            sort: 5,
          },
          {
            value: "424450",
            label: "鹤峰县",
            sort: 6,
          },
        ],
      },
      {
        value: "424480",
        label: "荆门市",
        sort: 16,
        children: [
          {
            value: "424480",
            label: "东宝区",
            sort: 0,
          },
          {
            value: "424480",
            label: "掇刀区",
            sort: 1,
          },
        ],
      },
    ],
  },
  {
    value: "430000",
    label: "湖南省",
    sort: 16,
    children: [
      {
        value: "434100",
        label: "长沙市",
        sort: 0,
        children: [
          {
            value: "434100",
            label: "芙蓉区",
            sort: 0,
          },
          {
            value: "434100",
            label: "天心区",
            sort: 1,
          },
          {
            value: "434100",
            label: "开福区",
            sort: 2,
          },
          {
            value: "434100",
            label: "雨花区",
            sort: 3,
          },
          {
            value: "434100",
            label: "岳麓区",
            sort: 4,
          },
          {
            value: "434100",
            label: "长沙县",
            sort: 5,
          },
          {
            value: "434100",
            label: "望城县",
            sort: 6,
          },
          {
            value: "434100",
            label: "浏阳市",
            sort: 7,
          },
          {
            value: "434100",
            label: "宁乡县",
            sort: 8,
          },
        ],
      },
      {
        value: "434111",
        label: "湘潭市",
        sort: 1,
        children: [
          {
            value: "434111",
            label: "雨湖区",
            sort: 0,
          },
          {
            value: "434111",
            label: "岳塘区",
            sort: 1,
          },
          {
            value: "434111",
            label: "湘潭县",
            sort: 2,
          },
          {
            value: "434111",
            label: "韶山市",
            sort: 3,
          },
          {
            value: "434111",
            label: "湘乡市",
            sort: 4,
          },
        ],
      },
      {
        value: "434120",
        label: "株洲市",
        sort: 2,
        children: [
          {
            value: "434120",
            label: "石峰区",
            sort: 0,
          },
          {
            value: "434120",
            label: "芦淞区",
            sort: 1,
          },
          {
            value: "434120",
            label: "荷塘区",
            sort: 2,
          },
          {
            value: "434120",
            label: "天元区",
            sort: 3,
          },
          {
            value: "434120",
            label: "株洲县",
            sort: 4,
          },
          {
            value: "434120",
            label: "醴陵市",
            sort: 5,
          },
          {
            value: "434120",
            label: "攸县",
            sort: 6,
          },
          {
            value: "434120",
            label: "茶陵县",
            sort: 7,
          },
          {
            value: "434120",
            label: "炎陵县",
            sort: 8,
          },
        ],
      },
      {
        value: "434130",
        label: "益阳市",
        sort: 3,
        children: [
          {
            value: "434130",
            label: "赫山区",
            sort: 0,
          },
          {
            value: "434130",
            label: "南县",
            sort: 1,
          },
          {
            value: "434130",
            label: "资阳区",
            sort: 2,
          },
          {
            value: "434130",
            label: "沅江市",
            sort: 3,
          },
          {
            value: "434130",
            label: "桃江县",
            sort: 4,
          },
          {
            value: "434130",
            label: "安化县",
            sort: 5,
          },
        ],
      },
      {
        value: "434140",
        label: "岳阳市",
        sort: 4,
        children: [
          {
            value: "434140",
            label: "岳阳楼区",
            sort: 0,
          },
          {
            value: "434140",
            label: "君山区",
            sort: 1,
          },
          {
            value: "434140",
            label: "云溪区",
            sort: 2,
          },
          {
            value: "434140",
            label: "岳阳县",
            sort: 3,
          },
          {
            value: "434140",
            label: "华容县",
            sort: 4,
          },
          {
            value: "434140",
            label: "临湘市",
            sort: 5,
          },
          {
            value: "434140",
            label: "汨罗市",
            sort: 6,
          },
          {
            value: "434140",
            label: "平江县",
            sort: 7,
          },
          {
            value: "434140",
            label: "湘阴县",
            sort: 8,
          },
        ],
      },
      {
        value: "434150",
        label: "常德市",
        sort: 5,
        children: [
          {
            value: "434150",
            label: "武陵区",
            sort: 0,
          },
          {
            value: "434150",
            label: "鼎城区",
            sort: 1,
          },
          {
            value: "434150",
            label: "临澧县",
            sort: 2,
          },
          {
            value: "434150",
            label: "石门县",
            sort: 3,
          },
          {
            value: "434150",
            label: "津市市",
            sort: 4,
          },
          {
            value: "434150",
            label: "澧县",
            sort: 5,
          },
          {
            value: "434150",
            label: "安乡县",
            sort: 6,
          },
          {
            value: "434150",
            label: "桃源县",
            sort: 7,
          },
          {
            value: "434150",
            label: "汉寿县",
            sort: 8,
          },
        ],
      },
      {
        value: "434160",
        label: "湘西土家族苗族自治州",
        sort: 6,
        children: [
          {
            value: "434160",
            label: "吉首市",
            sort: 0,
          },
          {
            value: "434160",
            label: "泸溪县",
            sort: 1,
          },
          {
            value: "434160",
            label: "凤凰县",
            sort: 2,
          },
          {
            value: "434160",
            label: "古丈县",
            sort: 3,
          },
          {
            value: "434160",
            label: "花垣县",
            sort: 4,
          },
          {
            value: "434160",
            label: "保靖县",
            sort: 5,
          },
          {
            value: "434160",
            label: "永顺县",
            sort: 6,
          },
          {
            value: "434160",
            label: "龙山县",
            sort: 7,
          },
        ],
      },
      {
        value: "434170",
        label: "娄底市",
        sort: 7,
        children: [
          {
            value: "434170",
            label: "娄星区",
            sort: 0,
          },
          {
            value: "434170",
            label: "涟源市",
            sort: 1,
          },
          {
            value: "434170",
            label: "冷水江市",
            sort: 2,
          },
          {
            value: "434170",
            label: "新化县",
            sort: 3,
          },
          {
            value: "434170",
            label: "双峰县",
            sort: 4,
          },
        ],
      },
      {
        value: "434180",
        label: "怀化市",
        sort: 8,
        children: [
          {
            value: "434180",
            label: "鹤城区",
            sort: 0,
          },
          {
            value: "434180",
            label: "中方县",
            sort: 1,
          },
          {
            value: "434180",
            label: "洪江市",
            sort: 2,
          },
          {
            value: "434180",
            label: "会同县",
            sort: 3,
          },
          {
            value: "434180",
            label: "靖州苗族侗族自治县",
            sort: 4,
          },
          {
            value: "434180",
            label: "通道侗族自治县",
            sort: 5,
          },
        ],
      },
      {
        value: "434210",
        label: "衡阳市",
        sort: 9,
        children: [
          {
            value: "434210",
            label: "蒸湘区",
            sort: 0,
          },
          {
            value: "434210",
            label: "珠晖区",
            sort: 1,
          },
          {
            value: "434210",
            label: "雁峰区",
            sort: 2,
          },
          {
            value: "434210",
            label: "石鼓区",
            sort: 3,
          },
          {
            value: "434210",
            label: "衡南县",
            sort: 4,
          },
          {
            value: "434210",
            label: "衡阳县",
            sort: 5,
          },
          {
            value: "434210",
            label: "衡山县",
            sort: 6,
          },
          {
            value: "434210",
            label: "衡东县",
            sort: 7,
          },
          {
            value: "434210",
            label: "常宁市",
            sort: 8,
          },
          {
            value: "434210",
            label: "祁东县",
            sort: 9,
          },
          {
            value: "434210",
            label: "耒阳市",
            sort: 10,
          },
          {
            value: "434210",
            label: "南岳区",
            sort: 11,
          },
        ],
      },
      {
        value: "434220",
        label: "邵阳市",
        sort: 10,
        children: [
          {
            value: "434220",
            label: "大祥区",
            sort: 0,
          },
          {
            value: "434220",
            label: "双清区",
            sort: 1,
          },
          {
            value: "434220",
            label: "北塔区",
            sort: 2,
          },
          {
            value: "434220",
            label: "邵阳县",
            sort: 3,
          },
          {
            value: "434220",
            label: "隆回县",
            sort: 4,
          },
          {
            value: "434220",
            label: "洞口县",
            sort: 5,
          },
          {
            value: "434220",
            label: "武冈市",
            sort: 6,
          },
          {
            value: "434220",
            label: "城步苗族自治县",
            sort: 7,
          },
          {
            value: "434220",
            label: "绥宁县",
            sort: 8,
          },
          {
            value: "434220",
            label: "新宁县",
            sort: 9,
          },
          {
            value: "434220",
            label: "邵东县",
            sort: 10,
          },
          {
            value: "434220",
            label: "新邵县",
            sort: 11,
          },
        ],
      },
      {
        value: "434230",
        label: "郴州市",
        sort: 11,
        children: [
          {
            value: "434230",
            label: "北湖区",
            sort: 0,
          },
          {
            value: "434230",
            label: "苏仙区",
            sort: 1,
          },
          {
            value: "434230",
            label: "永兴县",
            sort: 2,
          },
          {
            value: "434230",
            label: "资兴市",
            sort: 3,
          },
          {
            value: "434230",
            label: "桂东县",
            sort: 4,
          },
          {
            value: "434230",
            label: "安仁县",
            sort: 5,
          },
        ],
      },
      {
        value: "434250",
        label: "永州市",
        sort: 12,
        children: [
          {
            value: "434250",
            label: "冷水滩区",
            sort: 0,
          },
          {
            value: "434250",
            label: "零陵区",
            sort: 1,
          },
          {
            value: "434250",
            label: "双牌县",
            sort: 2,
          },
          {
            value: "434250",
            label: "道县",
            sort: 3,
          },
          {
            value: "434250",
            label: "江永县",
            sort: 4,
          },
          {
            value: "434250",
            label: "江华瑶族自治县",
            sort: 5,
          },
          {
            value: "434250",
            label: "宁远县",
            sort: 6,
          },
          {
            value: "434250",
            label: "新田县",
            sort: 7,
          },
          {
            value: "434250",
            label: "蓝山县",
            sort: 8,
          },
          {
            value: "434250",
            label: "东安县",
            sort: 9,
          },
        ],
      },
      {
        value: "434270",
        label: "张家界市",
        sort: 13,
        children: [
          {
            value: "434270",
            label: "永定区",
            sort: 0,
          },
          {
            value: "434270",
            label: "桑植县",
            sort: 1,
          },
          {
            value: "434270",
            label: "慈利县",
            sort: 2,
          },
          {
            value: "434270",
            label: "武陵源区",
            sort: 3,
          },
        ],
      },
    ],
  },
  {
    value: "440000",
    label: "广东省",
    sort: 17,
    children: [
      {
        value: "445100",
        label: "广州市",
        sort: 0,
        children: [
          {
            value: "445100",
            label: "越秀区",
            sort: 0,
          },
          {
            value: "445100",
            label: "天河区",
            sort: 1,
          },
          {
            value: "445100",
            label: "荔湾区",
            sort: 2,
          },
          {
            value: "445100",
            label: "白云区",
            sort: 3,
          },
          {
            value: "445100",
            label: "海珠区",
            sort: 4,
          },
          {
            value: "445100",
            label: "黄埔区",
            sort: 5,
          },
          {
            value: "445100",
            label: "萝岗区",
            sort: 6,
          },
          {
            value: "445100",
            label: "花都区",
            sort: 7,
          },
          {
            value: "445100",
            label: "从化市",
            sort: 8,
          },
        ],
      },
      {
        value: "445115",
        label: "清远市",
        sort: 1,
        children: [
          {
            value: "445100",
            label: "增城市",
            sort: 0,
          },
          {
            value: "445120",
            label: "新丰县",
            sort: 1,
          },
          {
            value: "445100",
            label: "番禺区",
            sort: 2,
          },
          {
            value: "445100",
            label: "南沙区",
            sort: 3,
          },
          {
            value: "445115",
            label: "清城区",
            sort: 4,
          },
          {
            value: "445115",
            label: "佛冈县",
            sort: 5,
          },
          {
            value: "445115",
            label: "清新县",
            sort: 6,
          },
        ],
      },
      {
        value: "445120",
        label: "韶关市",
        sort: 2,
        children: [
          {
            value: "445120",
            label: "浈江区",
            sort: 0,
          },
          {
            value: "445120",
            label: "武江区",
            sort: 1,
          },
          {
            value: "445120",
            label: "曲江区",
            sort: 2,
          },
          {
            value: "445120",
            label: "乐昌市",
            sort: 3,
          },
          {
            value: "445120",
            label: "仁化县",
            sort: 4,
          },
          {
            value: "445120",
            label: "南雄市",
            sort: 5,
          },
          {
            value: "445120",
            label: "始兴县",
            sort: 6,
          },
          {
            value: "445120",
            label: "翁源县",
            sort: 7,
          },
          {
            value: "445120",
            label: "乳源瑶族自治县",
            sort: 8,
          },
        ],
      },
      {
        value: "445140",
        label: "梅州市",
        sort: 3,
        children: [
          {
            value: "445140",
            label: "梅江区",
            sort: 0,
          },
          {
            value: "445140",
            label: "蕉岭县",
            sort: 1,
          },
          {
            value: "445140",
            label: "大埔县",
            sort: 2,
          },
          {
            value: "445140",
            label: "丰顺县",
            sort: 3,
          },
          {
            value: "445140",
            label: "五华县",
            sort: 4,
          },
          {
            value: "445140",
            label: "兴宁市",
            sort: 5,
          },
          {
            value: "445140",
            label: "平远县",
            sort: 6,
          },
          {
            value: "445140",
            label: "梅县",
            sort: 7,
          },
        ],
      },
      {
        value: "445150",
        label: "汕头市",
        sort: 4,
        children: [
          {
            value: "445150",
            label: "金平区",
            sort: 0,
          },
          {
            value: "445150",
            label: "龙湖区",
            sort: 1,
          },
          {
            value: "445150",
            label: "濠江区",
            sort: 2,
          },
          {
            value: "445150",
            label: "潮阳区",
            sort: 3,
          },
          {
            value: "445150",
            label: "潮南区",
            sort: 4,
          },
          {
            value: "445150",
            label: "澄海区",
            sort: 5,
          },
          {
            value: "445150",
            label: "南澳县",
            sort: 6,
          },
        ],
      },
      {
        value: "445160",
        label: "惠州市",
        sort: 5,
        children: [
          {
            value: "445160",
            label: "惠城区",
            sort: 0,
          },
          {
            value: "445160",
            label: "博罗县",
            sort: 1,
          },
          {
            value: "445160",
            label: "惠阳区",
            sort: 2,
          },
          {
            value: "445160",
            label: "惠东县",
            sort: 3,
          },
          {
            value: "445166",
            label: "海丰县",
            sort: 4,
          },
          {
            value: "445166",
            label: "陆丰市",
            sort: 5,
          },
          {
            value: "445166",
            label: "城区",
            sort: 6,
          },
          {
            value: "445166",
            label: "陆河县",
            sort: 7,
          },
          {
            value: "445160",
            label: "龙门县",
            sort: 8,
          },
        ],
      },
      {
        value: "445166",
        label: "汕尾市",
        sort: 6,
        children: [
          {
            value: "445160",
            label: "惠城区",
            sort: 0,
          },
          {
            value: "445160",
            label: "博罗县",
            sort: 1,
          },
          {
            value: "445160",
            label: "惠阳区",
            sort: 2,
          },
          {
            value: "445160",
            label: "惠东县",
            sort: 3,
          },
          {
            value: "445166",
            label: "海丰县",
            sort: 4,
          },
          {
            value: "445166",
            label: "陆丰市",
            sort: 5,
          },
          {
            value: "445166",
            label: "城区",
            sort: 6,
          },
          {
            value: "445166",
            label: "陆河县",
            sort: 7,
          },
          {
            value: "445160",
            label: "龙门县",
            sort: 8,
          },
        ],
      },
      {
        value: "445170",
        label: "河源市",
        sort: 7,
        children: [
          {
            value: "445170",
            label: "源城区",
            sort: 0,
          },
          {
            value: "445170",
            label: "连平县",
            sort: 1,
          },
          {
            value: "445170",
            label: "和平县",
            sort: 2,
          },
          {
            value: "445170",
            label: "龙川县",
            sort: 3,
          },
          {
            value: "445170",
            label: "紫金县",
            sort: 4,
          },
          {
            value: "445170",
            label: "东源县",
            sort: 5,
          },
        ],
      },
      {
        value: "445180",
        label: "深圳市",
        sort: 8,
        children: [
          {
            value: "445180",
            label: "南山区",
            sort: 0,
          },
          {
            value: "445180",
            label: "罗湖区",
            sort: 1,
          },
          {
            value: "445180",
            label: "福田区",
            sort: 2,
          },
          {
            value: "445180",
            label: "盐田区",
            sort: 3,
          },
          {
            value: "445180",
            label: "宝安区",
            sort: 4,
          },
          {
            value: "445180",
            label: "龙岗区",
            sort: 5,
          },
        ],
      },
      {
        value: "445190",
        label: "珠海市",
        sort: 9,
        children: [
          {
            value: "445190",
            label: "香洲区",
            sort: 0,
          },
          {
            value: "445190",
            label: "金湾区",
            sort: 1,
          },
          {
            value: "445190",
            label: "斗门区",
            sort: 2,
          },
        ],
      },
      {
        value: "445230",
        label: "东莞市",
        sort: 10,
        children: [
          {
            value: "445230",
            label: "东莞市",
            sort: 0,
          },
        ],
      },
      {
        value: "445240",
        label: "湛江市",
        sort: 11,
        children: [
          {
            value: "445240",
            label: "霞山区",
            sort: 0,
          },
          {
            value: "445240",
            label: "赤坎区",
            sort: 1,
          },
          {
            value: "445240",
            label: "坡头区",
            sort: 2,
          },
          {
            value: "445240",
            label: "麻章区",
            sort: 3,
          },
          {
            value: "445240",
            label: "徐闻县",
            sort: 4,
          },
          {
            value: "445240",
            label: "雷州市",
            sort: 5,
          },
          {
            value: "445250",
            label: "高州市",
            sort: 6,
          },
          {
            value: "445240",
            label: "遂溪县",
            sort: 7,
          },
          {
            value: "445240",
            label: "廉江市",
            sort: 8,
          },
          {
            value: "445240",
            label: "吴川市",
            sort: 9,
          },
        ],
      },
      {
        value: "445250",
        label: "茂名市",
        sort: 12,
        children: [
          {
            value: "445250",
            label: "茂南区",
            sort: 0,
          },
          {
            value: "445250",
            label: "茂港区",
            sort: 1,
          },
          {
            value: "445250",
            label: "化州市",
            sort: 2,
          },
          {
            value: "445250",
            label: "信宜市",
            sort: 3,
          },
          {
            value: "445250",
            label: "电白县",
            sort: 4,
          },
        ],
      },
      {
        value: "445260",
        label: "肇庆市",
        sort: 13,
        children: [
          {
            value: "445260",
            label: "端州区",
            sort: 0,
          },
          {
            value: "445260",
            label: "鼎湖区",
            sort: 1,
          },
          {
            value: "445260",
            label: "高要市",
            sort: 2,
          },
          {
            value: "445260",
            label: "四会市",
            sort: 3,
          },
          {
            value: "445260",
            label: "广宁县",
            sort: 4,
          },
          {
            value: "445260",
            label: "怀集县",
            sort: 5,
          },
          {
            value: "445260",
            label: "封开县",
            sort: 6,
          },
          {
            value: "445260",
            label: "德庆县",
            sort: 7,
          },
        ],
      },
      {
        value: "445280",
        label: "佛山市",
        sort: 14,
        children: [
          {
            value: "445280",
            label: "禅城区",
            sort: 0,
          },
          {
            value: "445280",
            label: "三水区",
            sort: 1,
          },
          {
            value: "445280",
            label: "南海区",
            sort: 2,
          },
          {
            value: "445280",
            label: "顺德区",
            sort: 3,
          },
          {
            value: "445284",
            label: "中山市",
            sort: 4,
          },
          {
            value: "445280",
            label: "高明区",
            sort: 5,
          },
        ],
      },
      {
        value: "445284",
        label: "中山市",
        sort: 15,
        children: [
          {
            value: "445280",
            label: "禅城区",
            sort: 0,
          },
          {
            value: "445280",
            label: "三水区",
            sort: 1,
          },
          {
            value: "445280",
            label: "南海区",
            sort: 2,
          },
          {
            value: "445280",
            label: "顺德区",
            sort: 3,
          },
          {
            value: "445284",
            label: "中山市",
            sort: 4,
          },
          {
            value: "445280",
            label: "高明区",
            sort: 5,
          },
        ],
      },
      {
        value: "445290",
        label: "江门市",
        sort: 16,
        children: [
          {
            value: "445290",
            label: "蓬江区",
            sort: 0,
          },
          {
            value: "445290",
            label: "江海区",
            sort: 1,
          },
          {
            value: "445290",
            label: "新会区",
            sort: 2,
          },
          {
            value: "445290",
            label: "台山市",
            sort: 3,
          },
          {
            value: "445290",
            label: "开平市",
            sort: 4,
          },
          {
            value: "445290",
            label: "恩平市",
            sort: 5,
          },
          {
            value: "445295",
            label: "江城区",
            sort: 6,
          },
          {
            value: "445295",
            label: "阳春市",
            sort: 7,
          },
          {
            value: "445290",
            label: "鹤山市",
            sort: 8,
          },
          {
            value: "445295",
            label: "阳西县",
            sort: 9,
          },
          {
            value: "445295",
            label: "阳东县",
            sort: 10,
          },
        ],
      },
      {
        value: "445295",
        label: "阳江市",
        sort: 17,
        children: [
          {
            value: "445290",
            label: "蓬江区",
            sort: 0,
          },
          {
            value: "445290",
            label: "江海区",
            sort: 1,
          },
          {
            value: "445290",
            label: "新会区",
            sort: 2,
          },
          {
            value: "445290",
            label: "台山市",
            sort: 3,
          },
          {
            value: "445290",
            label: "开平市",
            sort: 4,
          },
          {
            value: "445290",
            label: "恩平市",
            sort: 5,
          },
          {
            value: "445295",
            label: "江城区",
            sort: 6,
          },
          {
            value: "445295",
            label: "阳春市",
            sort: 7,
          },
          {
            value: "445290",
            label: "鹤山市",
            sort: 8,
          },
          {
            value: "445295",
            label: "阳西县",
            sort: 9,
          },
          {
            value: "445295",
            label: "阳东县",
            sort: 10,
          },
        ],
      },
    ],
  },
  {
    value: "450000",
    label: "广西壮族自治区",
    sort: 18,
    children: [
      {
        value: "455300",
        label: "南宁市",
        sort: 0,
        children: [
          {
            value: "455300",
            label: "西乡塘区",
            sort: 0,
          },
          {
            value: "455300",
            label: "兴宁区",
            sort: 1,
          },
          {
            value: "455300",
            label: "青秀区",
            sort: 2,
          },
          {
            value: "455300",
            label: "江南区",
            sort: 3,
          },
          {
            value: "455300",
            label: "武鸣县",
            sort: 4,
          },
          {
            value: "455300",
            label: "邕宁区",
            sort: 5,
          },
          {
            value: "455300",
            label: "良庆区",
            sort: 6,
          },
          {
            value: "455300",
            label: "横县",
            sort: 7,
          },
          {
            value: "455300",
            label: "宾阳县",
            sort: 8,
          },
          {
            value: "455300",
            label: "上林县",
            sort: 9,
          },
          {
            value: "455300",
            label: "马山县",
            sort: 10,
          },
          {
            value: "455470",
            label: "大化瑶族自治县",
            sort: 11,
          },
        ],
      },
      {
        value: "455322",
        label: "崇左市",
        sort: 1,
        children: [
          {
            value: "455322",
            label: "扶绥县",
            sort: 0,
          },
          {
            value: "455322",
            label: "江洲区",
            sort: 1,
          },
          {
            value: "455322",
            label: "大新县",
            sort: 2,
          },
          {
            value: "455322",
            label: "龙州县",
            sort: 3,
          },
          {
            value: "455322",
            label: "宁明县",
            sort: 4,
          },
          {
            value: "455322",
            label: "凭祥市",
            sort: 5,
          },
          {
            value: "455300",
            label: "隆安县",
            sort: 6,
          },
          {
            value: "455322",
            label: "天等县",
            sort: 7,
          },
        ],
      },
      {
        value: "455330",
        label: "百色市",
        sort: 2,
        children: [
          {
            value: "455330",
            label: "右江区",
            sort: 0,
          },
          {
            value: "455330",
            label: "凌云县",
            sort: 1,
          },
          {
            value: "455330",
            label: "乐业县",
            sort: 2,
          },
          {
            value: "455330",
            label: "田林县",
            sort: 3,
          },
          {
            value: "455330",
            label: "隆林各族自治县",
            sort: 4,
          },
          {
            value: "455330",
            label: "西林县",
            sort: 5,
          },
          {
            value: "455330",
            label: "田阳县",
            sort: 6,
          },
          {
            value: "455330",
            label: "德保县",
            sort: 7,
          },
          {
            value: "455330",
            label: "靖西县",
            sort: 8,
          },
          {
            value: "455330",
            label: "那坡县",
            sort: 9,
          },
        ],
      },
      {
        value: "455350",
        label: "钦州市",
        sort: 3,
        children: [
          {
            value: "455350",
            label: "钦南区",
            sort: 0,
          },
          {
            value: "455350",
            label: "钦北区",
            sort: 1,
          },
          {
            value: "455350",
            label: "浦北县",
            sort: 2,
          },
          {
            value: "455350",
            label: "灵山县",
            sort: 3,
          },
          {
            value: "455380",
            label: "防城区",
            sort: 4,
          },
          {
            value: "455380",
            label: "上思县",
            sort: 5,
          },
        ],
      },
      {
        value: "455360",
        label: "北海市",
        sort: 4,
        children: [
          {
            value: "455360",
            label: "海城区",
            sort: 0,
          },
          {
            value: "455360",
            label: "银海区",
            sort: 1,
          },
          {
            value: "455360",
            label: "铁山港区",
            sort: 2,
          },
          {
            value: "455360",
            label: "合浦县",
            sort: 3,
          },
        ],
      },
      {
        value: "455370",
        label: "玉林市",
        sort: 5,
        children: [
          {
            value: "455370",
            label: "玉州区",
            sort: 0,
          },
          {
            value: "455370",
            label: "兴业县",
            sort: 1,
          },
          {
            value: "455371",
            label: "港北区",
            sort: 2,
          },
          {
            value: "455371",
            label: "港南区",
            sort: 3,
          },
          {
            value: "455371",
            label: "覃塘区",
            sort: 4,
          },
          {
            value: "455371",
            label: "桂平市",
            sort: 5,
          },
          {
            value: "455371",
            label: "平南县",
            sort: 6,
          },
          {
            value: "455370",
            label: "北流市",
            sort: 7,
          },
          {
            value: "455370",
            label: "容县",
            sort: 8,
          },
          {
            value: "455370",
            label: "博白县",
            sort: 9,
          },
          {
            value: "455370",
            label: "陆川县",
            sort: 10,
          },
        ],
      },
      {
        value: "455371",
        label: "贵港市",
        sort: 6,
        children: [
          {
            value: "455370",
            label: "玉州区",
            sort: 0,
          },
          {
            value: "455370",
            label: "兴业县",
            sort: 1,
          },
          {
            value: "455371",
            label: "港北区",
            sort: 2,
          },
          {
            value: "455371",
            label: "港南区",
            sort: 3,
          },
          {
            value: "455371",
            label: "覃塘区",
            sort: 4,
          },
          {
            value: "455371",
            label: "桂平市",
            sort: 5,
          },
          {
            value: "455371",
            label: "平南县",
            sort: 6,
          },
          {
            value: "455370",
            label: "北流市",
            sort: 7,
          },
          {
            value: "455370",
            label: "容县",
            sort: 8,
          },
          {
            value: "455370",
            label: "博白县",
            sort: 9,
          },
          {
            value: "455370",
            label: "陆川县",
            sort: 10,
          },
        ],
      },
      {
        value: "455380",
        label: "防城港市",
        sort: 7,
        children: [
          {
            value: "455380",
            label: "港口区",
            sort: 0,
          },
          {
            value: "455380",
            label: "东兴市",
            sort: 1,
          },
        ],
      },
      {
        value: "455410",
        label: "桂林市",
        sort: 8,
        children: [
          {
            value: "455410",
            label: "秀峰区",
            sort: 0,
          },
          {
            value: "455410",
            label: "象山区",
            sort: 1,
          },
          {
            value: "455410",
            label: "七星区",
            sort: 2,
          },
          {
            value: "455410",
            label: "雁山区",
            sort: 3,
          },
          {
            value: "455410",
            label: "临桂县",
            sort: 4,
          },
          {
            value: "455410",
            label: "灵川县",
            sort: 5,
          },
          {
            value: "455410",
            label: "兴安县",
            sort: 6,
          },
          {
            value: "455410",
            label: "资源县",
            sort: 7,
          },
          {
            value: "455410",
            label: "全州县",
            sort: 8,
          },
          {
            value: "455410",
            label: "灌阳县",
            sort: 9,
          },
          {
            value: "455410",
            label: "龙胜各族自治县",
            sort: 10,
          },
          {
            value: "455410",
            label: "永福县",
            sort: 11,
          },
        ],
      },
      {
        value: "455428",
        label: "贺州市",
        sort: 9,
        children: [
          {
            value: "455410",
            label: "平乐县",
            sort: 0,
          },
          {
            value: "455410",
            label: "恭城瑶族自治县",
            sort: 1,
          },
          {
            value: "455428",
            label: "钟山县",
            sort: 2,
          },
          {
            value: "455428",
            label: "富川瑶族自治县",
            sort: 3,
          },
          {
            value: "455428",
            label: "八步区",
            sort: 4,
          },
        ],
      },
      {
        value: "455430",
        label: "梧州市",
        sort: 10,
        children: [
          {
            value: "455430",
            label: "万秀区",
            sort: 0,
          },
          {
            value: "455430",
            label: "蝶山区",
            sort: 1,
          },
          {
            value: "455430",
            label: "长洲区",
            sort: 2,
          },
          {
            value: "455430",
            label: "苍梧县",
            sort: 3,
          },
          {
            value: "455430",
            label: "岑溪市",
            sort: 4,
          },
          {
            value: "455430",
            label: "藤县",
            sort: 5,
          },
        ],
      },
      {
        value: "455450",
        label: "柳州市",
        sort: 11,
        children: [
          {
            value: "455450",
            label: "城中区",
            sort: 0,
          },
          {
            value: "455450",
            label: "柳北区",
            sort: 1,
          },
          {
            value: "455450",
            label: "鱼峰区",
            sort: 2,
          },
          {
            value: "455450",
            label: "柳南区",
            sort: 3,
          },
          {
            value: "455450",
            label: "柳江县",
            sort: 4,
          },
          {
            value: "455450",
            label: "柳城县",
            sort: 5,
          },
          {
            value: "455450",
            label: "融水苗族自治县",
            sort: 6,
          },
          {
            value: "455450",
            label: "融安县",
            sort: 7,
          },
          {
            value: "455450",
            label: "三江侗族自治县",
            sort: 8,
          },
          {
            value: "455450",
            label: "鹿寨县",
            sort: 9,
          },
          {
            value: "455461",
            label: "金秀瑶族自治县",
            sort: 10,
          },
          {
            value: "455461",
            label: "象州县",
            sort: 11,
          },
          {
            value: "455461",
            label: "武宣县",
            sort: 12,
          },
        ],
      },
      {
        value: "455461",
        label: "来宾市",
        sort: 12,
        children: [
          {
            value: "455461",
            label: "兴宾区",
            sort: 0,
          },
          {
            value: "455461",
            label: "忻城县",
            sort: 1,
          },
          {
            value: "455470",
            label: "宜州市",
            sort: 2,
          },
          {
            value: "455470",
            label: "罗城仫佬族自治县",
            sort: 3,
          },
          {
            value: "455461",
            label: "合山市",
            sort: 4,
          },
          {
            value: "455410",
            label: "荔蒲县",
            sort: 5,
          },
          {
            value: "455430",
            label: "蒙山县",
            sort: 6,
          },
          {
            value: "455428",
            label: "昭平县",
            sort: 7,
          },
        ],
      },
      {
        value: "455470",
        label: "河池市",
        sort: 13,
        children: [
          {
            value: "455470",
            label: "金城江区",
            sort: 0,
          },
          {
            value: "455470",
            label: "环江毛南族自治县",
            sort: 1,
          },
          {
            value: "455470",
            label: "南丹县",
            sort: 2,
          },
          {
            value: "455470",
            label: "天峨县",
            sort: 3,
          },
          {
            value: "455470",
            label: "东兰县",
            sort: 4,
          },
          {
            value: "455470",
            label: "巴马瑶族自治县",
            sort: 5,
          },
          {
            value: "455470",
            label: "凤山县",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "460000",
    label: "海南省",
    sort: 19,
    children: [
      {
        value: "465701",
        label: "海口市",
        sort: 0,
        children: [
          {
            value: "465701",
            label: "秀英区",
            sort: 0,
          },
          {
            value: "465701",
            label: "龙华区",
            sort: 1,
          },
          {
            value: "465701",
            label: "美兰区",
            sort: 2,
          },
        ],
      },
      {
        value: "465720",
        label: "三亚市",
        sort: 1,
        children: [
          {
            value: "465720",
            label: "三亚市",
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    value: "500000",
    label: "重庆市",
    sort: 20,
    children: [
      {
        value: "500000",
        label: "重庆市",
        sort: 0,
        children: [
          {
            value: "504000",
            label: "渝中区",
            sort: 0,
          },
          {
            value: "504000",
            label: "江北区",
            sort: 1,
          },
          {
            value: "504000",
            label: "沙坪坝区",
            sort: 2,
          },
          {
            value: "504000",
            label: "九龙坡区",
            sort: 3,
          },
          {
            value: "504000",
            label: "巴南区",
            sort: 4,
          },
          {
            value: "504000",
            label: "南岸区",
            sort: 5,
          },
          {
            value: "504000",
            label: "大渡口区",
            sort: 6,
          },
          {
            value: "504000",
            label: "北碚区",
            sort: 7,
          },
          {
            value: "504000",
            label: "万盛区",
            sort: 8,
          },
          {
            value: "504000",
            label: "双桥区",
            sort: 9,
          },
          {
            value: "504000",
            label: "渝北区",
            sort: 10,
          },
          {
            value: "504000",
            label: "长寿区",
            sort: 11,
          },
          {
            value: "504000",
            label: "綦江县",
            sort: 12,
          },
          {
            value: "504000",
            label: "合川市",
            sort: 13,
          },
          {
            value: "504000",
            label: "永川市",
            sort: 14,
          },
          {
            value: "504000",
            label: "江津市",
            sort: 15,
          },
          {
            value: "504000",
            label: "大足县",
            sort: 16,
          },
          {
            value: "504000",
            label: "荣昌县",
            sort: 17,
          },
          {
            value: "504000",
            label: "铜梁县",
            sort: 18,
          },
          {
            value: "504000",
            label: "潼南县",
            sort: 19,
          },
          {
            value: "504000",
            label: "璧山县",
            sort: 20,
          },
          {
            value: "504000",
            label: "万州区",
            sort: 21,
          },
          {
            value: "504000",
            label: "忠县",
            sort: 22,
          },
          {
            value: "504000",
            label: "云阳县",
            sort: 23,
          },
          {
            value: "504000",
            label: "奉节县",
            sort: 24,
          },
          {
            value: "504000",
            label: "巫山县",
            sort: 25,
          },
          {
            value: "504000",
            label: "梁平县",
            sort: 26,
          },
          {
            value: "504000",
            label: "开县",
            sort: 27,
          },
          {
            value: "504000",
            label: "巫溪县",
            sort: 28,
          },
          {
            value: "504000",
            label: "城口县",
            sort: 29,
          },
          {
            value: "504000",
            label: "涪陵区",
            sort: 30,
          },
          {
            value: "504000",
            label: "丰都县",
            sort: 31,
          },
          {
            value: "504000",
            label: "垫江县",
            sort: 32,
          },
          {
            value: "504000",
            label: "南川市",
            sort: 33,
          },
          {
            value: "504000",
            label: "武隆县",
            sort: 34,
          },
          {
            value: "504000",
            label: "黔江区",
            sort: 35,
          },
          {
            value: "504000",
            label: "石柱土家族自治县",
            sort: 36,
          },
          {
            value: "504000",
            label: "彭水苗族土家族自治县",
            sort: 37,
          },
          {
            value: "504000",
            label: "酉阳土家族苗族自治县",
            sort: 38,
          },
          {
            value: "504000",
            label: "秀山土家族苗族自治县",
            sort: 39,
          },
        ],
      },
    ],
  },
  {
    value: "510000",
    label: "四川省",
    sort: 21,
    children: [
      {
        value: "516100",
        label: "成都市",
        sort: 0,
        children: [
          {
            value: "516100",
            label: "青羊区",
            sort: 0,
          },
          {
            value: "516100",
            label: "锦江区",
            sort: 1,
          },
          {
            value: "516100",
            label: "成华区",
            sort: 2,
          },
          {
            value: "516100",
            label: "武侯区",
            sort: 3,
          },
          {
            value: "516100",
            label: "金牛区",
            sort: 4,
          },
          {
            value: "516100",
            label: "郫县",
            sort: 5,
          },
          {
            value: "516100",
            label: "龙泉驿区",
            sort: 6,
          },
          {
            value: "516100",
            label: "双流县",
            sort: 7,
          },
          {
            value: "516100",
            label: "青白江区",
            sort: 8,
          },
          {
            value: "516100",
            label: "金堂县",
            sort: 9,
          },
          {
            value: "516100",
            label: "新都区",
            sort: 10,
          },
        ],
      },
      {
        value: "516140",
        label: "乐山市",
        sort: 1,
        children: [
          {
            value: "516140",
            label: "市中区",
            sort: 0,
          },
          {
            value: "516140",
            label: "夹江县",
            sort: 1,
          },
          {
            value: "516140",
            label: "峨眉山市",
            sort: 2,
          },
          {
            value: "516140",
            label: "峨边彝族自治县",
            sort: 3,
          },
          {
            value: "516140",
            label: "犍为县",
            sort: 4,
          },
          {
            value: "516140",
            label: "沐川县",
            sort: 5,
          },
          {
            value: "516140",
            label: "马边彝族自治县",
            sort: 6,
          },
          {
            value: "516140",
            label: "金口河区",
            sort: 7,
          },
          {
            value: "516140",
            label: "五通桥区",
            sort: 8,
          },
          {
            value: "516140",
            label: "沙湾区",
            sort: 9,
          },
        ],
      },
      {
        value: "516150",
        label: "凉山彝族自治州",
        sort: 2,
        children: [
          {
            value: "516150",
            label: "西昌市",
            sort: 0,
          },
          {
            value: "516150",
            label: "会理县",
            sort: 1,
          },
          {
            value: "516150",
            label: "会东县",
            sort: 2,
          },
          {
            value: "516150",
            label: "普格县",
            sort: 3,
          },
          {
            value: "516150",
            label: "宁南县",
            sort: 4,
          },
          {
            value: "516150",
            label: "德昌县",
            sort: 5,
          },
          {
            value: "516150",
            label: "冕宁县",
            sort: 6,
          },
          {
            value: "516150",
            label: "盐源县",
            sort: 7,
          },
          {
            value: "516150",
            label: "木里藏族自治县",
            sort: 8,
          },
        ],
      },
      {
        value: "516170",
        label: "攀枝花市",
        sort: 3,
        children: [
          {
            value: "516170",
            label: "东区",
            sort: 0,
          },
          {
            value: "516170",
            label: "仁和区",
            sort: 1,
          },
          {
            value: "516170",
            label: "西区",
            sort: 2,
          },
          {
            value: "516170",
            label: "盐边县",
            sort: 3,
          },
          {
            value: "516170",
            label: "米易县",
            sort: 4,
          },
        ],
      },
      {
        value: "516180",
        label: "德阳市",
        sort: 4,
        children: [
          {
            value: "516180",
            label: "旌阳区",
            sort: 0,
          },
          {
            value: "516180",
            label: "中江县",
            sort: 1,
          },
          {
            value: "516180",
            label: "绵竹市",
            sort: 2,
          },
          {
            value: "516180",
            label: "广汉市",
            sort: 3,
          },
          {
            value: "516180",
            label: "什邡市",
            sort: 4,
          },
          {
            value: "516180",
            label: "罗江县",
            sort: 5,
          },
        ],
      },
      {
        value: "516200",
        label: "眉山市",
        sort: 5,
        children: [
          {
            value: "516200",
            label: "东坡区",
            sort: 0,
          },
          {
            value: "516200",
            label: "丹棱县",
            sort: 1,
          },
          {
            value: "516200",
            label: "洪雅县",
            sort: 2,
          },
          {
            value: "516200",
            label: "青神县",
            sort: 3,
          },
          {
            value: "516200",
            label: "仁寿县",
            sort: 4,
          },
          {
            value: "516200",
            label: "彭山县",
            sort: 5,
          },
        ],
      },
      {
        value: "516210",
        label: "绵阳市",
        sort: 6,
        children: [
          {
            value: "516210",
            label: "安县",
            sort: 0,
          },
          {
            value: "516210",
            label: "游仙区",
            sort: 1,
          },
          {
            value: "516210",
            label: "平武县",
            sort: 2,
          },
          {
            value: "516210",
            label: "梓潼县",
            sort: 3,
          },
          {
            value: "516210",
            label: "盐亭县",
            sort: 4,
          },
          {
            value: "516210",
            label: "涪城区",
            sort: 5,
          },
          {
            value: "516210",
            label: "三台县",
            sort: 6,
          },
          {
            value: "516210",
            label: "北川羌族自治县",
            sort: 7,
          },
        ],
      },
      {
        value: "516240",
        label: "阿坝藏族羌族自治州",
        sort: 7,
        children: [
          {
            value: "516240",
            label: "马尔康县",
            sort: 0,
          },
          {
            value: "516240",
            label: "金川县",
            sort: 1,
          },
          {
            value: "516240",
            label: "小金县",
            sort: 2,
          },
          {
            value: "516240",
            label: "红原县",
            sort: 3,
          },
          {
            value: "516240",
            label: "若尔盖县",
            sort: 4,
          },
          {
            value: "516240",
            label: "阿坝县",
            sort: 5,
          },
        ],
      },
      {
        value: "516250",
        label: "雅安市",
        sort: 8,
        children: [
          {
            value: "516250",
            label: "雨城区",
            sort: 0,
          },
          {
            value: "516250",
            label: "名山县",
            sort: 1,
          },
          {
            value: "516250",
            label: "荥经县",
            sort: 2,
          },
          {
            value: "516250",
            label: "汉源县",
            sort: 3,
          },
          {
            value: "516250",
            label: "石棉县",
            sort: 4,
          },
          {
            value: "516250",
            label: "天全县",
            sort: 5,
          },
          {
            value: "516250",
            label: "芦山县",
            sort: 6,
          },
          {
            value: "516250",
            label: "宝兴县",
            sort: 7,
          },
        ],
      },
      {
        value: "516260",
        label: "甘孜藏族自治州",
        sort: 9,
        children: [
          {
            value: "516260",
            label: "康定县",
            sort: 0,
          },
          {
            value: "516260",
            label: "泸定县",
            sort: 1,
          },
          {
            value: "516260",
            label: "九龙县",
            sort: 2,
          },
          {
            value: "516260",
            label: "丹巴县",
            sort: 3,
          },
          {
            value: "516260",
            label: "道孚县",
            sort: 4,
          },
          {
            value: "516260",
            label: "炉霍县",
            sort: 5,
          },
          {
            value: "516260",
            label: "色达县",
            sort: 6,
          },
          {
            value: "516260",
            label: "甘孜县",
            sort: 7,
          },
          {
            value: "516260",
            label: "新龙县",
            sort: 8,
          },
        ],
      },
      {
        value: "516280",
        label: "广元市",
        sort: 10,
        children: [
          {
            value: "516280",
            label: "市中区",
            sort: 0,
          },
          {
            value: "516280",
            label: "元坝区",
            sort: 1,
          },
          {
            value: "516280",
            label: "朝天区",
            sort: 2,
          },
          {
            value: "516280",
            label: "青川县",
            sort: 3,
          },
          {
            value: "516280",
            label: "旺苍县",
            sort: 4,
          },
          {
            value: "516280",
            label: "剑阁县",
            sort: 5,
          },
          {
            value: "516280",
            label: "苍溪县",
            sort: 6,
          },
        ],
      },
      {
        value: "516290",
        label: "遂宁市",
        sort: 11,
        children: [
          {
            value: "516290",
            label: "船山区",
            sort: 0,
          },
          {
            value: "516290",
            label: "安居区",
            sort: 1,
          },
          {
            value: "516290",
            label: "蓬溪县",
            sort: 2,
          },
          {
            value: "516290",
            label: "射洪县",
            sort: 3,
          },
          {
            value: "516290",
            label: "大英县",
            sort: 4,
          },
        ],
      },
      {
        value: "516350",
        label: "达州市",
        sort: 12,
        children: [
          {
            value: "516350",
            label: "通川区",
            sort: 0,
          },
          {
            value: "516350",
            label: "达县",
            sort: 1,
          },
          {
            value: "516350",
            label: "大竹县",
            sort: 2,
          },
          {
            value: "516350",
            label: "渠县",
            sort: 3,
          },
          {
            value: "516350",
            label: "开江县",
            sort: 4,
          },
        ],
      },
      {
        value: "516366",
        label: "巴中市",
        sort: 13,
        children: [
          {
            value: "516366",
            label: "巴州区",
            sort: 0,
          },
          {
            value: "516350",
            label: "宣汉县",
            sort: 1,
          },
          {
            value: "516350",
            label: "万源市",
            sort: 2,
          },
          {
            value: "516366",
            label: "平昌县",
            sort: 3,
          },
          {
            value: "516366",
            label: "南江县",
            sort: 4,
          },
          {
            value: "516366",
            label: "通江县",
            sort: 5,
          },
        ],
      },
      {
        value: "516370",
        label: "南充市",
        sort: 14,
        children: [
          {
            value: "516370",
            label: "顺庆区",
            sort: 0,
          },
          {
            value: "516370",
            label: "高坪区",
            sort: 1,
          },
          {
            value: "516370",
            label: "西充县",
            sort: 2,
          },
          {
            value: "516370",
            label: "南部县",
            sort: 3,
          },
          {
            value: "516370",
            label: "阆中市",
            sort: 4,
          },
          {
            value: "516370",
            label: "仪陇县",
            sort: 5,
          },
          {
            value: "516370",
            label: "营山县",
            sort: 6,
          },
          {
            value: "516370",
            label: "蓬安县",
            sort: 7,
          },
          {
            value: "516370",
            label: "嘉陵区",
            sort: 8,
          },
        ],
      },
      {
        value: "516385",
        label: "广安市",
        sort: 15,
        children: [
          {
            value: "516385",
            label: "广安区",
            sort: 0,
          },
          {
            value: "516385",
            label: "岳池县",
            sort: 1,
          },
          {
            value: "516385",
            label: "武胜县",
            sort: 2,
          },
          {
            value: "516385",
            label: "邻水县",
            sort: 3,
          },
          {
            value: "516385",
            label: "华蓥市",
            sort: 4,
          },
        ],
      },
      {
        value: "516410",
        label: "内江市",
        sort: 16,
        children: [
          {
            value: "516410",
            label: "市中区",
            sort: 0,
          },
          {
            value: "516410",
            label: "东兴区",
            sort: 1,
          },
          {
            value: "516410",
            label: "资中县",
            sort: 2,
          },
          {
            value: "516413",
            label: "雁江区",
            sort: 3,
          },
          {
            value: "516413",
            label: "简阳市",
            sort: 4,
          },
          {
            value: "516413",
            label: "乐至县",
            sort: 5,
          },
        ],
      },
      {
        value: "516413",
        label: "资阳市",
        sort: 17,
        children: [
          {
            value: "516410",
            label: "市中区",
            sort: 0,
          },
          {
            value: "516410",
            label: "东兴区",
            sort: 1,
          },
          {
            value: "516410",
            label: "资中县",
            sort: 2,
          },
          {
            value: "516413",
            label: "雁江区",
            sort: 3,
          },
          {
            value: "516413",
            label: "简阳市",
            sort: 4,
          },
          {
            value: "516413",
            label: "乐至县",
            sort: 5,
          },
        ],
      },
      {
        value: "516430",
        label: "自贡市",
        sort: 18,
        children: [
          {
            value: "516430",
            label: "大安区",
            sort: 0,
          },
          {
            value: "516430",
            label: "自流井区",
            sort: 1,
          },
          {
            value: "516430",
            label: "贡井区",
            sort: 2,
          },
          {
            value: "516430",
            label: "沿滩区",
            sort: 3,
          },
          {
            value: "516430",
            label: "荣县",
            sort: 4,
          },
          {
            value: "516430",
            label: "富顺县",
            sort: 5,
          },
        ],
      },
      {
        value: "516440",
        label: "宜宾市",
        sort: 19,
        children: [
          {
            value: "516440",
            label: "翠屏区",
            sort: 0,
          },
          {
            value: "516440",
            label: "南溪县",
            sort: 1,
          },
          {
            value: "516440",
            label: "江安县",
            sort: 2,
          },
          {
            value: "516440",
            label: "长宁县",
            sort: 3,
          },
          {
            value: "516440",
            label: "兴文县",
            sort: 4,
          },
          {
            value: "516440",
            label: "珙县",
            sort: 5,
          },
          {
            value: "516440",
            label: "宜宾县",
            sort: 6,
          },
        ],
      },
      {
        value: "516460",
        label: "泸州市",
        sort: 20,
        children: [
          {
            value: "516460",
            label: "江阳区",
            sort: 0,
          },
          {
            value: "516460",
            label: "泸县",
            sort: 1,
          },
          {
            value: "516460",
            label: "合江县",
            sort: 2,
          },
          {
            value: "516460",
            label: "纳溪区",
            sort: 3,
          },
          {
            value: "516460",
            label: "叙永县",
            sort: 4,
          },
          {
            value: "516460",
            label: "古蔺县",
            sort: 5,
          },
          {
            value: "516460",
            label: "龙马潭区",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "520000",
    label: "贵州省",
    sort: 22,
    children: [
      {
        value: "525500",
        label: "贵阳市",
        sort: 0,
        children: [
          {
            value: "525500",
            label: "云岩区",
            sort: 0,
          },
          {
            value: "525500",
            label: "南明区",
            sort: 1,
          },
          {
            value: "525500",
            label: "小河区",
            sort: 2,
          },
          {
            value: "525500",
            label: "白云区",
            sort: 3,
          },
          {
            value: "525500",
            label: "乌当区",
            sort: 4,
          },
          {
            value: "525500",
            label: "花溪区",
            sort: 5,
          },
          {
            value: "525580",
            label: "罗甸县",
            sort: 6,
          },
          {
            value: "525500",
            label: "修文县",
            sort: 7,
          },
          {
            value: "525500",
            label: "开阳县",
            sort: 8,
          },
          {
            value: "525580",
            label: "瓮安县",
            sort: 9,
          },
          {
            value: "525580",
            label: "福泉市",
            sort: 10,
          },
          {
            value: "525580",
            label: "惠水县",
            sort: 11,
          },
          {
            value: "525580",
            label: "长顺县",
            sort: 12,
          },
          {
            value: "525610",
            label: "紫云苗族布依族自治县",
            sort: 13,
          },
        ],
      },
      {
        value: "525517",
        label: "毕节地区",
        sort: 1,
        children: [
          {
            value: "525500",
            label: "息烽县",
            sort: 0,
          },
          {
            value: "525580",
            label: "龙里县",
            sort: 1,
          },
          {
            value: "525580",
            label: "贵定县",
            sort: 2,
          },
          {
            value: "525500",
            label: "清镇市",
            sort: 3,
          },
          {
            value: "525517",
            label: "黔西县",
            sort: 4,
          },
          {
            value: "525517",
            label: "大方县",
            sort: 5,
          },
          {
            value: "525517",
            label: "毕节市",
            sort: 6,
          },
          {
            value: "525517",
            label: "金沙县",
            sort: 7,
          },
        ],
      },
      {
        value: "525530",
        label: "六盘水市",
        sort: 2,
        children: [
          {
            value: "525530",
            label: "钟山区",
            sort: 0,
          },
          {
            value: "525530",
            label: "水城县",
            sort: 1,
          },
          {
            value: "525517",
            label: "威宁彝族回族苗族自治县",
            sort: 2,
          },
          {
            value: "525517",
            label: "赫章县",
            sort: 3,
          },
          {
            value: "525517",
            label: "纳雍县",
            sort: 4,
          },
          {
            value: "525530",
            label: "六枝特区",
            sort: 5,
          },
          {
            value: "525530",
            label: "盘县",
            sort: 6,
          },
        ],
      },
      {
        value: "525543",
        label: "铜仁地区",
        sort: 3,
        children: [
          {
            value: "525543",
            label: "玉屏侗族自治县",
            sort: 0,
          },
          {
            value: "525543",
            label: "松桃苗族自治县",
            sort: 1,
          },
          {
            value: "525543",
            label: "万山特区",
            sort: 2,
          },
          {
            value: "525543",
            label: "铜仁市",
            sort: 3,
          },
          {
            value: "525543",
            label: "江口县",
            sort: 4,
          },
        ],
      },
      {
        value: "525560",
        label: "黔东南苗族侗族自治州",
        sort: 4,
        children: [
          {
            value: "525560",
            label: "凯里市",
            sort: 0,
          },
          {
            value: "525560",
            label: "黄平县",
            sort: 1,
          },
          {
            value: "525560",
            label: "施秉县",
            sort: 2,
          },
          {
            value: "525560",
            label: "台江县",
            sort: 3,
          },
          {
            value: "525560",
            label: "剑河县",
            sort: 4,
          },
          {
            value: "525560",
            label: "三穗县",
            sort: 5,
          },
          {
            value: "525560",
            label: "天柱县",
            sort: 6,
          },
          {
            value: "525560",
            label: "锦屏县",
            sort: 7,
          },
        ],
      },
      {
        value: "525580",
        label: "黔南布依族苗族自治州",
        sort: 5,
        children: [
          {
            value: "525580",
            label: "都匀市",
            sort: 0,
          },
          {
            value: "525580",
            label: "三都水族自治县",
            sort: 1,
          },
          {
            value: "525580",
            label: "独山县",
            sort: 2,
          },
          {
            value: "525580",
            label: "平塘县",
            sort: 3,
          },
          {
            value: "525580",
            label: "荔波县",
            sort: 4,
          },
        ],
      },
      {
        value: "525610",
        label: "安顺市",
        sort: 6,
        children: [
          {
            value: "525610",
            label: "西秀区",
            sort: 0,
          },
          {
            value: "525610",
            label: "平坝县",
            sort: 1,
          },
          {
            value: "525610",
            label: "镇宁布依族苗族自治县",
            sort: 2,
          },
          {
            value: "525610",
            label: "关岭布依族苗族自治县",
            sort: 3,
          },
          {
            value: "525624",
            label: "晴隆县",
            sort: 4,
          },
          {
            value: "525624",
            label: "普安县",
            sort: 5,
          },
        ],
      },
      {
        value: "525624",
        label: "黔西南布依族苗族自治州",
        sort: 7,
        children: [
          {
            value: "525610",
            label: "普定县",
            sort: 0,
          },
          {
            value: "525624",
            label: "贞丰县",
            sort: 1,
          },
          {
            value: "525624",
            label: "兴仁县",
            sort: 2,
          },
          {
            value: "525624",
            label: "兴义市",
            sort: 3,
          },
        ],
      },
      {
        value: "525630",
        label: "遵义市",
        sort: 8,
        children: [
          {
            value: "525630",
            label: "红花岗区",
            sort: 0,
          },
          {
            value: "525630",
            label: "汇川区",
            sort: 1,
          },
          {
            value: "525630",
            label: "桐梓县",
            sort: 2,
          },
          {
            value: "525630",
            label: "绥阳县",
            sort: 3,
          },
          {
            value: "525630",
            label: "正安县",
            sort: 4,
          },
          {
            value: "525630",
            label: "道真仡佬族苗族自治县",
            sort: 5,
          },
        ],
      },
    ],
  },
  {
    value: "530000",
    label: "云南省",
    sort: 23,
    children: [
      {
        value: "536500",
        label: "昆明市",
        sort: 0,
        children: [
          {
            value: "536500",
            label: "官渡区",
            sort: 0,
          },
          {
            value: "536500",
            label: "五华区",
            sort: 1,
          },
          {
            value: "536500",
            label: "西山区",
            sort: 2,
          },
          {
            value: "536500",
            label: "盘龙区",
            sort: 3,
          },
          {
            value: "536500",
            label: "富民县",
            sort: 4,
          },
          {
            value: "536500",
            label: "呈贡县",
            sort: 5,
          },
          {
            value: "536500",
            label: "晋宁县",
            sort: 6,
          },
        ],
      },
      {
        value: "536531",
        label: "玉溪市",
        sort: 1,
        children: [
          {
            value: "536531",
            label: "红塔区",
            sort: 0,
          },
          {
            value: "536531",
            label: "峨山彝族自治县",
            sort: 1,
          },
          {
            value: "536531",
            label: "元江哈尼族彝族傣族自治县",
            sort: 2,
          },
          {
            value: "536531",
            label: "新平彝族傣族自治县",
            sort: 3,
          },
        ],
      },
      {
        value: "536550",
        label: "曲靖市",
        sort: 2,
        children: [
          {
            value: "536550",
            label: "麒麟区",
            sort: 0,
          },
          {
            value: "536550",
            label: "沾益县",
            sort: 1,
          },
          {
            value: "536550",
            label: "富源县",
            sort: 2,
          },
          {
            value: "536550",
            label: "陆良县",
            sort: 3,
          },
          {
            value: "536550",
            label: "师宗县",
            sort: 4,
          },
        ],
      },
      {
        value: "536570",
        label: "昭通市",
        sort: 3,
        children: [
          {
            value: "536570",
            label: "昭阳区",
            sort: 0,
          },
          {
            value: "536570",
            label: "鲁甸县",
            sort: 1,
          },
          {
            value: "536570",
            label: "镇雄县",
            sort: 2,
          },
          {
            value: "536570",
            label: "永善县",
            sort: 3,
          },
          {
            value: "536570",
            label: "大关县",
            sort: 4,
          },
          {
            value: "536570",
            label: "盐津县",
            sort: 5,
          },
          {
            value: "536570",
            label: "彝良县",
            sort: 6,
          },
          {
            value: "536570",
            label: "绥江县",
            sort: 7,
          },
          {
            value: "536570",
            label: "水富县",
            sort: 8,
          },
          {
            value: "536570",
            label: "威信县",
            sort: 9,
          },
        ],
      },
      {
        value: "536614",
        label: "红河哈尼族彝族自治州",
        sort: 4,
        children: [
          {
            value: "536614",
            label: "个旧市",
            sort: 0,
          },
          {
            value: "536614",
            label: "蒙自县",
            sort: 1,
          },
          {
            value: "536614",
            label: "屏边苗族自治县",
            sort: 2,
          },
          {
            value: "536614",
            label: "河口瑶族自治县",
            sort: 3,
          },
          {
            value: "536614",
            label: "开远市",
            sort: 4,
          },
        ],
      },
      {
        value: "536630",
        label: "文山壮族苗族自治州",
        sort: 5,
        children: [
          {
            value: "536630",
            label: "文山县",
            sort: 0,
          },
          {
            value: "536630",
            label: "砚山县",
            sort: 1,
          },
          {
            value: "536630",
            label: "丘北县",
            sort: 2,
          },
          {
            value: "536630",
            label: "广南县",
            sort: 3,
          },
          {
            value: "536630",
            label: "富宁县",
            sort: 4,
          },
          {
            value: "536630",
            label: "西畴县",
            sort: 5,
          },
          {
            value: "536630",
            label: "麻栗坡县",
            sort: 6,
          },
          {
            value: "536630",
            label: "马关县",
            sort: 7,
          },
        ],
      },
      {
        value: "536650",
        label: "普洱市",
        sort: 6,
        children: [
          {
            value: "536650",
            label: "翠云区",
            sort: 0,
          },
          {
            value: "536650",
            label: "普洱哈尼族彝族自治县",
            sort: 1,
          },
        ],
      },
      {
        value: "536661",
        label: "西双版纳傣族自治州",
        sort: 7,
        children: [
          {
            value: "536661",
            label: "景洪市",
            sort: 0,
          },
          {
            value: "536661",
            label: "勐海县",
            sort: 1,
          },
          {
            value: "536661",
            label: "勐腊县",
            sort: 2,
          },
          {
            value: "536650",
            label: "景谷傣族彝族自治县",
            sort: 3,
          },
          {
            value: "536650",
            label: "镇沅彝族哈尼族拉祜族自治县",
            sort: 4,
          },
        ],
      },
      {
        value: "536710",
        label: "大理白族自治州",
        sort: 8,
        children: [
          {
            value: "536710",
            label: "大理市",
            sort: 0,
          },
          {
            value: "536731",
            label: "兰坪白族普米族自治县",
            sort: 1,
          },
        ],
      },
      {
        value: "536731",
        label: "怒江傈僳族自治州",
        sort: 9,
        children: [
          {
            value: "536731",
            label: "福贡县",
            sort: 0,
          },
          {
            value: "536731",
            label: "贡山独龙族怒族自治县",
            sort: 1,
          },
        ],
      },
      {
        value: "536741",
        label: "丽江市",
        sort: 10,
        children: [
          {
            value: "536741",
            label: "玉龙纳西族自治县",
            sort: 0,
          },
          {
            value: "536741",
            label: "永胜县",
            sort: 1,
          },
          {
            value: "536741",
            label: "宁蒗彝族自治县",
            sort: 2,
          },
          {
            value: "536744",
            label: "香格里拉县",
            sort: 3,
          },
          {
            value: "536744",
            label: "德钦县",
            sort: 4,
          },
          {
            value: "536744",
            label: "维西傈僳族自治县",
            sort: 5,
          },
          {
            value: "536741",
            label: "华坪县",
            sort: 6,
          },
        ],
      },
      {
        value: "536744",
        label: "迪庆藏族自治州",
        sort: 11,
        children: [
          {
            value: "536741",
            label: "玉龙纳西族自治县",
            sort: 0,
          },
          {
            value: "536741",
            label: "永胜县",
            sort: 1,
          },
          {
            value: "536741",
            label: "宁蒗彝族自治县",
            sort: 2,
          },
          {
            value: "536744",
            label: "香格里拉县",
            sort: 3,
          },
          {
            value: "536744",
            label: "德钦县",
            sort: 4,
          },
          {
            value: "536744",
            label: "维西傈僳族自治县",
            sort: 5,
          },
          {
            value: "536741",
            label: "华坪县",
            sort: 6,
          },
        ],
      },
      {
        value: "536750",
        label: "楚雄彝族自治州",
        sort: 12,
        children: [
          {
            value: "536750",
            label: "楚雄市",
            sort: 0,
          },
          {
            value: "536770",
            label: "云县",
            sort: 1,
          },
          {
            value: "536770",
            label: "凤庆县",
            sort: 2,
          },
        ],
      },
      {
        value: "536770",
        label: "临沧市",
        sort: 13,
        children: [
          {
            value: "536770",
            label: "临翔区",
            sort: 0,
          },
          {
            value: "536770",
            label: "双江拉祜族佤族布朗族傣族自治县",
            sort: 1,
          },
          {
            value: "536770",
            label: "沧源佤族自治县",
            sort: 2,
          },
          {
            value: "536770",
            label: "耿马傣族佤族自治县",
            sort: 3,
          },
          {
            value: "536770",
            label: "永德县",
            sort: 4,
          },
          {
            value: "536770",
            label: "镇康县",
            sort: 5,
          },
        ],
      },
      {
        value: "536780",
        label: "保山市",
        sort: 14,
        children: [
          {
            value: "536780",
            label: "隆阳区",
            sort: 0,
          },
          {
            value: "536780",
            label: "昌宁县",
            sort: 1,
          },
          {
            value: "536780",
            label: "施甸县",
            sort: 2,
          },
          {
            value: "536780",
            label: "龙陵县",
            sort: 3,
          },
          {
            value: "536784",
            label: "潞西市",
            sort: 4,
          },
          {
            value: "536784",
            label: "瑞丽市",
            sort: 5,
          },
        ],
      },
      {
        value: "536784",
        label: "德宏傣族景颇族自治州",
        sort: 15,
        children: [
          {
            value: "536780",
            label: "隆阳区",
            sort: 0,
          },
          {
            value: "536780",
            label: "昌宁县",
            sort: 1,
          },
          {
            value: "536780",
            label: "施甸县",
            sort: 2,
          },
          {
            value: "536780",
            label: "龙陵县",
            sort: 3,
          },
          {
            value: "536784",
            label: "潞西市",
            sort: 4,
          },
          {
            value: "536784",
            label: "瑞丽市",
            sort: 5,
          },
        ],
      },
    ],
  },
  {
    value: "540000",
    label: "西藏自治区",
    sort: 24,
    children: [
      {
        value: "548500",
        label: "拉萨市",
        sort: 0,
        children: [
          {
            value: "548500",
            label: "城关区",
            sort: 0,
          },
          {
            value: "548500",
            label: "达孜县",
            sort: 1,
          },
          {
            value: "548500",
            label: "墨竹工卡县",
            sort: 2,
          },
          {
            value: "548500",
            label: "曲水县",
            sort: 3,
          },
          {
            value: "548560",
            label: "贡嘎县",
            sort: 4,
          },
          {
            value: "548560",
            label: "扎囊县",
            sort: 5,
          },
        ],
      },
      {
        value: "548520",
        label: "那曲地区",
        sort: 1,
        children: [
          {
            value: "548520",
            label: "那曲县",
            sort: 0,
          },
        ],
      },
      {
        value: "548540",
        label: "昌都地区",
        sort: 2,
        children: [
          {
            value: "548540",
            label: "昌都县",
            sort: 0,
          },
        ],
      },
      {
        value: "548560",
        label: "山南地区",
        sort: 3,
        children: [
          {
            value: "548560",
            label: "乃东县",
            sort: 0,
          },
          {
            value: "548560",
            label: "桑日县",
            sort: 1,
          },
          {
            value: "548560",
            label: "曲松县",
            sort: 2,
          },
          {
            value: "548560",
            label: "加查县",
            sort: 3,
          },
          {
            value: "548560",
            label: "隆子县",
            sort: 4,
          },
          {
            value: "548560",
            label: "错那县",
            sort: 5,
          },
          {
            value: "548560",
            label: "琼结县",
            sort: 6,
          },
          {
            value: "548560",
            label: "措美县",
            sort: 7,
          },
        ],
      },
      {
        value: "548570",
        label: "日喀则地区",
        sort: 4,
        children: [
          {
            value: "548570",
            label: "日喀则市",
            sort: 0,
          },
          {
            value: "548570",
            label: "南木林县",
            sort: 1,
          },
          {
            value: "548570",
            label: "亚东县",
            sort: 2,
          },
        ],
      },
      {
        value: "548590",
        label: "阿里地区",
        sort: 5,
        children: [
          {
            value: "548590",
            label: "革吉县",
            sort: 0,
          },
          {
            value: "548590",
            label: "改则县",
            sort: 1,
          },
          {
            value: "548590",
            label: "措勤县",
            sort: 2,
          },
        ],
      },
      {
        value: "548600",
        label: "林芝地区",
        sort: 6,
        children: [
          {
            value: "548600",
            label: "林芝县",
            sort: 0,
          },
          {
            value: "548600",
            label: "工布江达县",
            sort: 1,
          },
          {
            value: "548600",
            label: "波密县",
            sort: 2,
          },
          {
            value: "548600",
            label: "朗县",
            sort: 3,
          },
          {
            value: "548600",
            label: "米林县",
            sort: 4,
          },
          {
            value: "548600",
            label: "察隅县",
            sort: 5,
          },
          {
            value: "548600",
            label: "墨脱县",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "610000",
    label: "陕西省",
    sort: 25,
    children: [
      {
        value: "617100",
        label: "西安市",
        sort: 0,
        children: [
          {
            value: "617100",
            label: "碑林区",
            sort: 0,
          },
          {
            value: "617100",
            label: "莲湖区",
            sort: 1,
          },
          {
            value: "617100",
            label: "新城区",
            sort: 2,
          },
          {
            value: "617100",
            label: "未央区",
            sort: 3,
          },
          {
            value: "617100",
            label: "灞桥区",
            sort: 4,
          },
          {
            value: "617100",
            label: "雁塔区",
            sort: 5,
          },
          {
            value: "617100",
            label: "阎良区",
            sort: 6,
          },
          {
            value: "617100",
            label: "户县",
            sort: 7,
          },
          {
            value: "617100",
            label: "长安区",
            sort: 8,
          },
          {
            value: "617100",
            label: "高陵县",
            sort: 9,
          },
          {
            value: "617100",
            label: "周至县",
            sort: 10,
          },
          {
            value: "617100",
            label: "蓝田县",
            sort: 11,
          },
          {
            value: "617100",
            label: "临潼区",
            sort: 12,
          },
        ],
      },
      {
        value: "617120",
        label: "咸阳市",
        sort: 1,
        children: [
          {
            value: "617120",
            label: "渭城区",
            sort: 0,
          },
          {
            value: "617120",
            label: "秦都区",
            sort: 1,
          },
          {
            value: "617120",
            label: "武功县",
            sort: 2,
          },
        ],
      },
      {
        value: "617140",
        label: "渭南市",
        sort: 2,
        children: [
          {
            value: "617140",
            label: "临渭区",
            sort: 0,
          },
          {
            value: "617140",
            label: "华县",
            sort: 1,
          },
          {
            value: "617140",
            label: "华阴市",
            sort: 2,
          },
          {
            value: "617140",
            label: "潼关县",
            sort: 3,
          },
        ],
      },
      {
        value: "617160",
        label: "延安市",
        sort: 3,
        children: [
          {
            value: "617160",
            label: "宝塔区",
            sort: 0,
          },
          {
            value: "617160",
            label: "甘泉县",
            sort: 1,
          },
        ],
      },
      {
        value: "617190",
        label: "榆林市",
        sort: 4,
        children: [
          {
            value: "617190",
            label: "榆阳区",
            sort: 0,
          },
          {
            value: "617190",
            label: "横山县",
            sort: 1,
          },
          {
            value: "617190",
            label: "佳县",
            sort: 2,
          },
          {
            value: "617190",
            label: "神木县",
            sort: 3,
          },
          {
            value: "617190",
            label: "府谷县",
            sort: 4,
          },
        ],
      },
      {
        value: "617210",
        label: "宝鸡市",
        sort: 5,
        children: [
          {
            value: "617210",
            label: "金台区",
            sort: 0,
          },
          {
            value: "617210",
            label: "渭滨区",
            sort: 1,
          },
          {
            value: "617210",
            label: "千阳县",
            sort: 2,
          },
          {
            value: "617210",
            label: "陇县",
            sort: 3,
          },
          {
            value: "617210",
            label: "陈仓区",
            sort: 4,
          },
          {
            value: "617210",
            label: "凤翔县",
            sort: 5,
          },
          {
            value: "617210",
            label: "麟游县",
            sort: 6,
          },
          {
            value: "617210",
            label: "太白县",
            sort: 7,
          },
          {
            value: "617210",
            label: "凤县",
            sort: 8,
          },
        ],
      },
      {
        value: "617230",
        label: "汉中市",
        sort: 6,
        children: [
          {
            value: "617230",
            label: "汉台区",
            sort: 0,
          },
          {
            value: "617230",
            label: "南郑县",
            sort: 1,
          },
          {
            value: "617230",
            label: "城固县",
            sort: 2,
          },
          {
            value: "617230",
            label: "洋县",
            sort: 3,
          },
          {
            value: "617230",
            label: "佛坪县",
            sort: 4,
          },
          {
            value: "617230",
            label: "西乡县",
            sort: 5,
          },
          {
            value: "617230",
            label: "镇巴县",
            sort: 6,
          },
        ],
      },
      {
        value: "617250",
        label: "安康市",
        sort: 7,
        children: [
          {
            value: "617250",
            label: "汉滨区",
            sort: 0,
          },
          {
            value: "617250",
            label: "汉阴县",
            sort: 1,
          },
          {
            value: "617250",
            label: "石泉县",
            sort: 2,
          },
          {
            value: "617250",
            label: "紫阳县",
            sort: 3,
          },
          {
            value: "617250",
            label: "岚皋县",
            sort: 4,
          },
          {
            value: "617250",
            label: "平利县",
            sort: 5,
          },
          {
            value: "617250",
            label: "镇坪县",
            sort: 6,
          },
          {
            value: "617250",
            label: "旬阳县",
            sort: 7,
          },
          {
            value: "617250",
            label: "白河县",
            sort: 8,
          },
        ],
      },
      {
        value: "617260",
        label: "商洛市",
        sort: 8,
        children: [
          {
            value: "617260",
            label: "商州区",
            sort: 0,
          },
          {
            value: "617260",
            label: "洛南县",
            sort: 1,
          },
          {
            value: "617260",
            label: "丹凤县",
            sort: 2,
          },
          {
            value: "617260",
            label: "商南县",
            sort: 3,
          },
          {
            value: "617260",
            label: "山阳县",
            sort: 4,
          },
        ],
      },
      {
        value: "617270",
        label: "铜川市",
        sort: 9,
        children: [
          {
            value: "617270",
            label: "王益区",
            sort: 0,
          },
          {
            value: "617270",
            label: "印台区",
            sort: 1,
          },
          {
            value: "617270",
            label: "耀州区",
            sort: 2,
          },
          {
            value: "617270",
            label: "宜君县",
            sort: 3,
          },
          {
            value: "617160",
            label: "洛川县",
            sort: 4,
          },
          {
            value: "617160",
            label: "富县",
            sort: 5,
          },
        ],
      },
    ],
  },
  {
    value: "620000",
    label: "甘肃省",
    sort: 26,
    children: [
      {
        value: "627300",
        label: "兰州市",
        sort: 0,
        children: [
          {
            value: "627300",
            label: "城关区",
            sort: 0,
          },
          {
            value: "627300",
            label: "七里河区",
            sort: 1,
          },
          {
            value: "627300",
            label: "西固区",
            sort: 2,
          },
          {
            value: "627300",
            label: "安宁区",
            sort: 3,
          },
          {
            value: "627300",
            label: "红古区",
            sort: 4,
          },
          {
            value: "627300",
            label: "榆中县",
            sort: 5,
          },
          {
            value: "627300",
            label: "皋兰县",
            sort: 6,
          },
          {
            value: "627300",
            label: "永登县",
            sort: 7,
          },
          {
            value: "627309",
            label: "景泰县",
            sort: 8,
          },
          {
            value: "627430",
            label: "临洮县",
            sort: 9,
          },
          {
            value: "627309",
            label: "靖远县",
            sort: 10,
          },
          {
            value: "627309",
            label: "会宁县",
            sort: 11,
          },
          {
            value: "627309",
            label: "白银区",
            sort: 12,
          },
          {
            value: "627309",
            label: "平川区",
            sort: 13,
          },
        ],
      },
      {
        value: "627309",
        label: "白银市",
        sort: 1,
        children: [
          {
            value: "627300",
            label: "城关区",
            sort: 0,
          },
          {
            value: "627300",
            label: "七里河区",
            sort: 1,
          },
          {
            value: "627300",
            label: "西固区",
            sort: 2,
          },
          {
            value: "627300",
            label: "安宁区",
            sort: 3,
          },
          {
            value: "627300",
            label: "红古区",
            sort: 4,
          },
          {
            value: "627300",
            label: "榆中县",
            sort: 5,
          },
          {
            value: "627300",
            label: "皋兰县",
            sort: 6,
          },
          {
            value: "627300",
            label: "永登县",
            sort: 7,
          },
          {
            value: "627309",
            label: "景泰县",
            sort: 8,
          },
          {
            value: "627430",
            label: "临洮县",
            sort: 9,
          },
          {
            value: "627309",
            label: "靖远县",
            sort: 10,
          },
          {
            value: "627309",
            label: "会宁县",
            sort: 11,
          },
          {
            value: "627309",
            label: "白银区",
            sort: 12,
          },
          {
            value: "627309",
            label: "平川区",
            sort: 13,
          },
        ],
      },
      {
        value: "627311",
        label: "临夏回族自治州",
        sort: 2,
        children: [
          {
            value: "627311",
            label: "临夏市",
            sort: 0,
          },
          {
            value: "627311",
            label: "和政县",
            sort: 1,
          },
          {
            value: "627311",
            label: "广河县",
            sort: 2,
          },
          {
            value: "627311",
            label: "康乐县",
            sort: 3,
          },
          {
            value: "627311",
            label: "永靖县",
            sort: 4,
          },
          {
            value: "627311",
            label: "积石山保安族东乡族撒拉族自治县",
            sort: 5,
          },
          {
            value: "627311",
            label: "临夏县",
            sort: 6,
          },
        ],
      },
      {
        value: "627330",
        label: "武威市",
        sort: 3,
        children: [
          {
            value: "627330",
            label: "凉州区",
            sort: 0,
          },
          {
            value: "627330",
            label: "天祝藏族自治县",
            sort: 1,
          },
          {
            value: "627340",
            label: "肃南裕固族自治县",
            sort: 2,
          },
          {
            value: "627330",
            label: "古浪县",
            sort: 3,
          },
          {
            value: "627330",
            label: "民勤县",
            sort: 4,
          },
        ],
      },
      {
        value: "627340",
        label: "张掖市",
        sort: 4,
        children: [
          {
            value: "627340",
            label: "甘州区",
            sort: 0,
          },
          {
            value: "627340",
            label: "山丹县",
            sort: 1,
          },
          {
            value: "627340",
            label: "临泽县",
            sort: 2,
          },
          {
            value: "627340",
            label: "高台县",
            sort: 3,
          },
          {
            value: "627340",
            label: "民乐县",
            sort: 4,
          },
        ],
      },
      {
        value: "627350",
        label: "酒泉市",
        sort: 5,
        children: [
          {
            value: "627350",
            label: "肃州区",
            sort: 0,
          },
          {
            value: "627351",
            label: "嘉峪关市",
            sort: 1,
          },
          {
            value: "627350",
            label: "玉门市",
            sort: 2,
          },
          {
            value: "627350",
            label: "肃北蒙古族自治县",
            sort: 3,
          },
          {
            value: "627350",
            label: "金塔县",
            sort: 4,
          },
        ],
      },
      {
        value: "627351",
        label: "嘉峪关市",
        sort: 6,
        children: [
          {
            value: "627350",
            label: "肃州区",
            sort: 0,
          },
          {
            value: "627351",
            label: "嘉峪关市",
            sort: 1,
          },
          {
            value: "627350",
            label: "玉门市",
            sort: 2,
          },
          {
            value: "627350",
            label: "肃北蒙古族自治县",
            sort: 3,
          },
          {
            value: "627350",
            label: "金塔县",
            sort: 4,
          },
        ],
      },
      {
        value: "627371",
        label: "金昌市",
        sort: 7,
        children: [
          {
            value: "627371",
            label: "永昌县",
            sort: 0,
          },
          {
            value: "627371",
            label: "金川区",
            sort: 1,
          },
        ],
      },
      {
        value: "627410",
        label: "天水市",
        sort: 8,
        children: [
          {
            value: "627410",
            label: "秦城区",
            sort: 0,
          },
          {
            value: "627410",
            label: "北道区",
            sort: 1,
          },
          {
            value: "627410",
            label: "甘谷县",
            sort: 2,
          },
          {
            value: "627410",
            label: "武山县",
            sort: 3,
          },
          {
            value: "627410",
            label: "清水县",
            sort: 4,
          },
          {
            value: "627410",
            label: "张家川回族自治县",
            sort: 5,
          },
          {
            value: "627410",
            label: "秦安县",
            sort: 6,
          },
        ],
      },
      {
        value: "627425",
        label: "陇南市",
        sort: 9,
        children: [
          {
            value: "627425",
            label: "西和县",
            sort: 0,
          },
          {
            value: "627425",
            label: "礼县",
            sort: 1,
          },
          {
            value: "627425",
            label: "徽县",
            sort: 2,
          },
          {
            value: "627425",
            label: "两当县",
            sort: 3,
          },
          {
            value: "627425",
            label: "成县",
            sort: 4,
          },
        ],
      },
      {
        value: "627430",
        label: "定西市",
        sort: 10,
        children: [
          {
            value: "627430",
            label: "安定区",
            sort: 0,
          },
          {
            value: "627430",
            label: "通渭县",
            sort: 1,
          },
          {
            value: "627440",
            label: "静宁县",
            sort: 2,
          },
        ],
      },
      {
        value: "627440",
        label: "平凉市",
        sort: 11,
        children: [
          {
            value: "627440",
            label: "崆峒区",
            sort: 0,
          },
          {
            value: "627440",
            label: "华亭县",
            sort: 1,
          },
          {
            value: "627440",
            label: "崇信县",
            sort: 2,
          },
          {
            value: "627440",
            label: "泾川县",
            sort: 3,
          },
          {
            value: "627440",
            label: "灵台县",
            sort: 4,
          },
          {
            value: "627450",
            label: "镇原县",
            sort: 5,
          },
          {
            value: "627440",
            label: "庄浪县",
            sort: 6,
          },
        ],
      },
      {
        value: "627450",
        label: "庆阳市",
        sort: 12,
        children: [
          {
            value: "627450",
            label: "西峰区",
            sort: 0,
          },
          {
            value: "627450",
            label: "庆城县",
            sort: 1,
          },
          {
            value: "627450",
            label: "宁县",
            sort: 2,
          },
          {
            value: "627450",
            label: "正宁县",
            sort: 3,
          },
          {
            value: "627450",
            label: "合水县",
            sort: 4,
          },
          {
            value: "627450",
            label: "华池县",
            sort: 5,
          },
          {
            value: "627450",
            label: "环县",
            sort: 6,
          },
        ],
      },
      {
        value: "627470",
        label: "甘南藏族自治州",
        sort: 13,
        children: [
          {
            value: "627470",
            label: "合作市",
            sort: 0,
          },
          {
            value: "627470",
            label: "夏河县",
            sort: 1,
          },
          {
            value: "627470",
            label: "碌曲县",
            sort: 2,
          },
          {
            value: "627470",
            label: "玛曲县",
            sort: 3,
          },
          {
            value: "627470",
            label: "迭部县",
            sort: 4,
          },
          {
            value: "627470",
            label: "临潭县",
            sort: 5,
          },
          {
            value: "627470",
            label: "卓尼县",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "630000",
    label: "青海省",
    sort: 27,
    children: [
      {
        value: "638100",
        label: "西宁市",
        sort: 0,
        children: [
          {
            value: "638100",
            label: "城中区",
            sort: 0,
          },
          {
            value: "638100",
            label: "城西区",
            sort: 1,
          },
          {
            value: "638100",
            label: "城北区",
            sort: 2,
          },
          {
            value: "638100",
            label: "城东区",
            sort: 3,
          },
          {
            value: "638100",
            label: "大通回族土族自治县",
            sort: 4,
          },
          {
            value: "638122",
            label: "刚察县",
            sort: 5,
          },
          {
            value: "638122",
            label: "门源回族自治县",
            sort: 6,
          },
          {
            value: "638106",
            label: "互助土族自治县",
            sort: 7,
          },
          {
            value: "638106",
            label: "平安县",
            sort: 8,
          },
          {
            value: "638106",
            label: "乐都县",
            sort: 9,
          },
          {
            value: "638106",
            label: "民和回族土族自治县",
            sort: 10,
          },
          {
            value: "638106",
            label: "化隆回族自治县",
            sort: 11,
          },
        ],
      },
      {
        value: "638106",
        label: "海东地区",
        sort: 1,
        children: [
          {
            value: "638100",
            label: "城中区",
            sort: 0,
          },
          {
            value: "638100",
            label: "城西区",
            sort: 1,
          },
          {
            value: "638100",
            label: "城北区",
            sort: 2,
          },
          {
            value: "638100",
            label: "城东区",
            sort: 3,
          },
          {
            value: "638100",
            label: "大通回族土族自治县",
            sort: 4,
          },
          {
            value: "638122",
            label: "刚察县",
            sort: 5,
          },
          {
            value: "638122",
            label: "门源回族自治县",
            sort: 6,
          },
          {
            value: "638106",
            label: "互助土族自治县",
            sort: 7,
          },
          {
            value: "638106",
            label: "平安县",
            sort: 8,
          },
          {
            value: "638106",
            label: "乐都县",
            sort: 9,
          },
          {
            value: "638106",
            label: "民和回族土族自治县",
            sort: 10,
          },
          {
            value: "638106",
            label: "化隆回族自治县",
            sort: 11,
          },
        ],
      },
      {
        value: "638113",
        label: "黄南藏族自治州",
        sort: 2,
        children: [
          {
            value: "638106",
            label: "循化撒拉族自治县",
            sort: 0,
          },
          {
            value: "638113",
            label: "尖扎县",
            sort: 1,
          },
          {
            value: "638113",
            label: "同仁县",
            sort: 2,
          },
          {
            value: "638113",
            label: "泽库县",
            sort: 3,
          },
          {
            value: "638113",
            label: "河南蒙古族自治县",
            sort: 4,
          },
          {
            value: "638100",
            label: "湟中县",
            sort: 5,
          },
          {
            value: "638130",
            label: "共和县",
            sort: 6,
          },
          {
            value: "638130",
            label: "贵德县",
            sort: 7,
          },
        ],
      },
      {
        value: "638122",
        label: "海北藏族自治州",
        sort: 3,
        children: [
          {
            value: "638100",
            label: "湟源县",
            sort: 0,
          },
          {
            value: "638122",
            label: "海晏县",
            sort: 1,
          },
        ],
      },
      {
        value: "638130",
        label: "海南藏族自治州",
        sort: 4,
        children: [
          {
            value: "638130",
            label: "贵南县",
            sort: 0,
          },
          {
            value: "638130",
            label: "同德县",
            sort: 1,
          },
          {
            value: "638130",
            label: "兴海县",
            sort: 2,
          },
          {
            value: "638140",
            label: "玛多县",
            sort: 3,
          },
        ],
      },
      {
        value: "638140",
        label: "果洛藏族自治州",
        sort: 5,
        children: [
          {
            value: "638140",
            label: "玛沁县",
            sort: 0,
          },
          {
            value: "638140",
            label: "甘德县",
            sort: 1,
          },
          {
            value: "638140",
            label: "达日县",
            sort: 2,
          },
        ],
      },
      {
        value: "638170",
        label: "海西蒙古族藏族自治州",
        sort: 6,
        children: [
          {
            value: "638170",
            label: "德令哈市",
            sort: 0,
          },
          {
            value: "638170",
            label: "乌兰县",
            sort: 1,
          },
          {
            value: "638170",
            label: "天峻县",
            sort: 2,
          },
        ],
      },
    ],
  },
  {
    value: "640000",
    label: "宁夏回族自治区",
    sort: 28,
    children: [
      {
        value: "647500",
        label: "银川市",
        sort: 0,
        children: [
          {
            value: "647500",
            label: "兴庆区",
            sort: 0,
          },
          {
            value: "647500",
            label: "金凤区",
            sort: 1,
          },
          {
            value: "647500",
            label: "西夏区",
            sort: 2,
          },
          {
            value: "647500",
            label: "永宁县",
            sort: 3,
          },
          {
            value: "647500",
            label: "贺兰县",
            sort: 4,
          },
          {
            value: "647500",
            label: "灵武市",
            sort: 5,
          },
        ],
      },
      {
        value: "647511",
        label: "吴忠市",
        sort: 1,
        children: [
          {
            value: "647511",
            label: "利通区",
            sort: 0,
          },
          {
            value: "647511",
            label: "同心县",
            sort: 1,
          },
          {
            value: "647511",
            label: "盐池县",
            sort: 2,
          },
          {
            value: "647511",
            label: "青铜峡市",
            sort: 3,
          },
        ],
      },
      {
        value: "647530",
        label: "石嘴山市",
        sort: 2,
        children: [
          {
            value: "647530",
            label: "大武口区",
            sort: 0,
          },
          {
            value: "647530",
            label: "惠农区",
            sort: 1,
          },
          {
            value: "647530",
            label: "平罗县",
            sort: 2,
          },
        ],
      },
      {
        value: "647550",
        label: "中卫市",
        sort: 3,
        children: [
          {
            value: "647550",
            label: "沙坡头区",
            sort: 0,
          },
          {
            value: "647550",
            label: "中宁县",
            sort: 1,
          },
          {
            value: "647550",
            label: "海原县",
            sort: 2,
          },
        ],
      },
      {
        value: "647560",
        label: "固原市",
        sort: 4,
        children: [
          {
            value: "647560",
            label: "原州区",
            sort: 0,
          },
          {
            value: "647560",
            label: "西吉县",
            sort: 1,
          },
          {
            value: "647560",
            label: "隆德县",
            sort: 2,
          },
          {
            value: "647560",
            label: "泾源县",
            sort: 3,
          },
          {
            value: "647560",
            label: "彭阳县",
            sort: 4,
          },
        ],
      },
    ],
  },
  {
    value: "650000",
    label: "新疆维吾尔自治区",
    sort: 29,
    children: [
      {
        value: "658300",
        label: "乌鲁木齐市",
        sort: 0,
        children: [
          {
            value: "658300",
            label: "新市区",
            sort: 0,
          },
          {
            value: "658300",
            label: "头屯河区",
            sort: 1,
          },
        ],
      },
      {
        value: "658311",
        label: "昌吉回族自治州",
        sort: 1,
        children: [
          {
            value: "658311",
            label: "昌吉市",
            sort: 0,
          },
          {
            value: "658311",
            label: "呼图壁县",
            sort: 1,
          },
          {
            value: "658311",
            label: "米泉市",
            sort: 2,
          },
          {
            value: "658311",
            label: "阜康市",
            sort: 3,
          },
          {
            value: "658311",
            label: "吉木萨尔县",
            sort: 4,
          },
          {
            value: "658311",
            label: "奇台县",
            sort: 5,
          },
          {
            value: "658311",
            label: "木垒哈萨克自治县",
            sort: 6,
          },
        ],
      },
      {
        value: "658313",
        label: "五家渠市",
        sort: 2,
        children: [
          {
            value: "658311",
            label: "昌吉市",
            sort: 0,
          },
          {
            value: "658311",
            label: "呼图壁县",
            sort: 1,
          },
          {
            value: "658311",
            label: "米泉市",
            sort: 2,
          },
          {
            value: "658311",
            label: "阜康市",
            sort: 3,
          },
          {
            value: "658311",
            label: "吉木萨尔县",
            sort: 4,
          },
          {
            value: "658311",
            label: "奇台县",
            sort: 5,
          },
          {
            value: "658311",
            label: "木垒哈萨克自治县",
            sort: 6,
          },
        ],
      },
      {
        value: "658320",
        label: "石河子市",
        sort: 3,
        children: [
          {
            value: "658347",
            label: "沙湾县",
            sort: 0,
          },
          {
            value: "658311",
            label: "玛纳斯县",
            sort: 1,
          },
        ],
      },
      {
        value: "658334",
        label: "博尔塔拉蒙古自治州",
        sort: 4,
        children: [
          {
            value: "658347",
            label: "乌苏市",
            sort: 0,
          },
          {
            value: "658350",
            label: "奎屯市",
            sort: 1,
          },
          {
            value: "658334",
            label: "精河县",
            sort: 2,
          },
          {
            value: "658334",
            label: "博乐市",
            sort: 3,
          },
          {
            value: "658334",
            label: "温泉县",
            sort: 4,
          },
          {
            value: "658340",
            label: "独山子区",
            sort: 5,
          },
        ],
      },
      {
        value: "658340",
        label: "克拉玛依市",
        sort: 5,
        children: [
          {
            value: "658340",
            label: "克拉玛依区",
            sort: 0,
          },
          {
            value: "658340",
            label: "白碱滩区",
            sort: 1,
          },
          {
            value: "658340",
            label: "乌尔禾区",
            sort: 2,
          },
          {
            value: "658347",
            label: "和布克赛尔蒙古自治县",
            sort: 3,
          },
          {
            value: "658347",
            label: "托里县",
            sort: 4,
          },
          {
            value: "658347",
            label: "额敏县",
            sort: 5,
          },
          {
            value: "658347",
            label: "塔城市",
            sort: 6,
          },
          {
            value: "658347",
            label: "裕民县",
            sort: 7,
          },
        ],
      },
      {
        value: "658347",
        label: "塔城地区",
        sort: 6,
        children: [
          {
            value: "658340",
            label: "克拉玛依区",
            sort: 0,
          },
          {
            value: "658340",
            label: "白碱滩区",
            sort: 1,
          },
          {
            value: "658340",
            label: "乌尔禾区",
            sort: 2,
          },
          {
            value: "658347",
            label: "和布克赛尔蒙古自治县",
            sort: 3,
          },
          {
            value: "658347",
            label: "托里县",
            sort: 4,
          },
          {
            value: "658347",
            label: "额敏县",
            sort: 5,
          },
          {
            value: "658347",
            label: "塔城市",
            sort: 6,
          },
          {
            value: "658347",
            label: "裕民县",
            sort: 7,
          },
        ],
      },
      {
        value: "658350",
        label: "伊犁哈萨克自治州",
        sort: 7,
        children: [
          {
            value: "658350",
            label: "伊宁市",
            sort: 0,
          },
          {
            value: "658350",
            label: "伊宁县",
            sort: 1,
          },
          {
            value: "658350",
            label: "霍城县",
            sort: 2,
          },
          {
            value: "658350",
            label: "察布查尔锡伯自治县",
            sort: 3,
          },
          {
            value: "658350",
            label: "巩留县",
            sort: 4,
          },
          {
            value: "658350",
            label: "特克斯县",
            sort: 5,
          },
          {
            value: "658350",
            label: "昭苏县",
            sort: 6,
          },
          {
            value: "658350",
            label: "尼勒克县",
            sort: 7,
          },
          {
            value: "658350",
            label: "新源县",
            sort: 8,
          },
        ],
      },
      {
        value: "658365",
        label: "阿勒泰地区",
        sort: 8,
        children: [
          {
            value: "658365",
            label: "富蕴县",
            sort: 0,
          },
          {
            value: "658365",
            label: "福海县",
            sort: 1,
          },
          {
            value: "658365",
            label: "阿勒泰市",
            sort: 2,
          },
          {
            value: "658365",
            label: "布尔津县",
            sort: 3,
          },
          {
            value: "658365",
            label: "哈巴河县",
            sort: 4,
          },
        ],
      },
      {
        value: "658380",
        label: "吐鲁番地区",
        sort: 9,
        children: [
          {
            value: "658380",
            label: "吐鲁番市",
            sort: 0,
          },
          {
            value: "658380",
            label: "托克逊县",
            sort: 1,
          },
          {
            value: "658380",
            label: "鄯善县",
            sort: 2,
          },
        ],
      },
      {
        value: "658390",
        label: "哈密地区",
        sort: 10,
        children: [
          {
            value: "658390",
            label: "哈密市",
            sort: 0,
          },
          {
            value: "658390",
            label: "巴里坤哈萨克自治县",
            sort: 1,
          },
          {
            value: "658390",
            label: "伊吾县",
            sort: 2,
          },
        ],
      },
      {
        value: "658410",
        label: "巴音郭楞蒙古自治州",
        sort: 11,
        children: [
          {
            value: "658410",
            label: "库尔勒市",
            sort: 0,
          },
          {
            value: "658410",
            label: "焉耆回族自治县",
            sort: 1,
          },
          {
            value: "658410",
            label: "和硕县",
            sort: 2,
          },
          {
            value: "658410",
            label: "和静县",
            sort: 3,
          },
          {
            value: "658410",
            label: "博湖县",
            sort: 4,
          },
          {
            value: "658410",
            label: "尉犁县",
            sort: 5,
          },
          {
            value: "658410",
            label: "轮台县",
            sort: 6,
          },
          {
            value: "658410",
            label: "若羌县",
            sort: 7,
          },
          {
            value: "658410",
            label: "且末县",
            sort: 8,
          },
        ],
      },
      {
        value: "658430",
        label: "阿克苏地区",
        sort: 12,
        children: [
          {
            value: "658430",
            label: "阿克苏市",
            sort: 0,
          },
          {
            value: "658430",
            label: "温宿县",
            sort: 1,
          },
          {
            value: "658430",
            label: "阿瓦提县",
            sort: 2,
          },
          {
            value: "658430",
            label: "乌什县",
            sort: 3,
          },
          {
            value: "658453",
            label: "阿合奇县",
            sort: 4,
          },
          {
            value: "658430",
            label: "柯坪县",
            sort: 5,
          },
          {
            value: "658440",
            label: "巴楚县",
            sort: 6,
          },
        ],
      },
      {
        value: "658433",
        label: "阿拉尔市",
        sort: 13,
        children: [
          {
            value: "658430",
            label: "阿克苏市",
            sort: 0,
          },
          {
            value: "658430",
            label: "温宿县",
            sort: 1,
          },
          {
            value: "658430",
            label: "阿瓦提县",
            sort: 2,
          },
          {
            value: "658430",
            label: "乌什县",
            sort: 3,
          },
          {
            value: "658453",
            label: "阿合奇县",
            sort: 4,
          },
          {
            value: "658430",
            label: "柯坪县",
            sort: 5,
          },
          {
            value: "658440",
            label: "巴楚县",
            sort: 6,
          },
        ],
      },
      {
        value: "658439",
        label: "图木舒克市",
        sort: 14,
        children: [
          {
            value: "658430",
            label: "阿克苏市",
            sort: 0,
          },
          {
            value: "658430",
            label: "温宿县",
            sort: 1,
          },
          {
            value: "658430",
            label: "阿瓦提县",
            sort: 2,
          },
          {
            value: "658430",
            label: "乌什县",
            sort: 3,
          },
          {
            value: "658453",
            label: "阿合奇县",
            sort: 4,
          },
          {
            value: "658430",
            label: "柯坪县",
            sort: 5,
          },
          {
            value: "658440",
            label: "巴楚县",
            sort: 6,
          },
        ],
      },
      {
        value: "658440",
        label: "喀什地区",
        sort: 15,
        children: [
          {
            value: "658440",
            label: "喀什市",
            sort: 0,
          },
          {
            value: "658440",
            label: "疏附县",
            sort: 1,
          },
          {
            value: "658440",
            label: "疏勒县",
            sort: 2,
          },
          {
            value: "658440",
            label: "伽师县",
            sort: 3,
          },
          {
            value: "658440",
            label: "岳普湖县",
            sort: 4,
          },
          {
            value: "658440",
            label: "英吉沙县",
            sort: 5,
          },
          {
            value: "658440",
            label: "麦盖提县",
            sort: 6,
          },
          {
            value: "658440",
            label: "莎车县",
            sort: 7,
          },
          {
            value: "658440",
            label: "泽普县",
            sort: 8,
          },
          {
            value: "658440",
            label: "叶城县",
            sort: 9,
          },
        ],
      },
      {
        value: "658453",
        label: "克孜勒苏柯尔克孜自治州",
        sort: 16,
        children: [
          {
            value: "658480",
            label: "皮山县",
            sort: 0,
          },
          {
            value: "658440",
            label: "塔什库尔干塔吉克自治县",
            sort: 1,
          },
          {
            value: "658453",
            label: "阿图什市",
            sort: 2,
          },
          {
            value: "658453",
            label: "乌恰县",
            sort: 3,
          },
          {
            value: "658453",
            label: "阿克陶县",
            sort: 4,
          },
        ],
      },
      {
        value: "658480",
        label: "和田地区",
        sort: 17,
        children: [
          {
            value: "658480",
            label: "和田市",
            sort: 0,
          },
          {
            value: "658480",
            label: "和田县",
            sort: 1,
          },
          {
            value: "658480",
            label: "墨玉县",
            sort: 2,
          },
          {
            value: "658480",
            label: "洛浦县",
            sort: 3,
          },
          {
            value: "658480",
            label: "策勒县",
            sort: 4,
          },
          {
            value: "658480",
            label: "于田县",
            sort: 5,
          },
          {
            value: "658480",
            label: "民丰县",
            sort: 6,
          },
        ],
      },
    ],
  },
  {
    value: "920000",
    label: "台湾省",
    sort: 30,
    children: [
      {
        value: "920000",
        label: "台湾省",
        sort: 0,
        children: [
          {
            value: "920000",
            label: "台湾省",
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    value: "910000",
    label: "香港特别行政区",
    sort: 31,
    children: [
      {
        value: "910000",
        label: "香港特别行政区",
        sort: 0,
        children: [
          {
            value: "910000",
            label: "香港特别行政区",
            sort: 0,
          },
        ],
      },
    ],
  },
  {
    value: "940000",
    label: "澳门特别行政区",
    sort: 32,
    children: [
      {
        value: "940000",
        label: "澳门特别行政区",
        sort: 0,
        children: [
          {
            value: "940000",
            label: "澳门特别行政区",
            sort: 0,
          },
        ],
      },
    ],
  },
];
export default CITYDATA;
